function _typeof(xt) {
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof = function(Nt) {
        return typeof Nt
    }
    : _typeof = function(Nt) {
        return Nt && typeof Symbol == "function" && Nt.constructor === Symbol && Nt !== Symbol.prototype ? "symbol" : typeof Nt
    }
    ,
    _typeof(xt)
}
/*! jQuery v3.5.1 | (c) JS Foundation and other contributors | jquery.org/license */
(function(xt, le) {
    "use strict";
    (typeof module == "undefined" ? "undefined" : _typeof(module)) == "object" && _typeof(module.exports) == "object" ? module.exports = xt.document ? le(xt, !0) : function(Nt) {
        if (!Nt.document)
            throw new Error("jQuery requires a window with a document");
        return le(Nt)
    }
    : le(xt)
}
)(typeof window != "undefined" ? window : this, function(xt, le) {
    "use strict";
    var Nt = []
      , d = Object.getPrototypeOf
      , w = Nt.slice
      , e = Nt.flat ? function(o) {
        return Nt.flat.call(o)
    }
    : function(o) {
        return Nt.concat.apply([], o)
    }
      , c = Nt.push
      , p = Nt.indexOf
      , i = {}
      , l = i.toString
      , a = i.hasOwnProperty
      , g = a.toString
      , S = g.call(Object)
      , T = {}
      , y = function(t) {
        return typeof t == "function" && typeof t.nodeType != "number"
    }
      , A = function(t) {
        return t != null && t === t.window
    }
      , j = xt.document
      , L = {
        type: !0,
        src: !0,
        nonce: !0,
        noModule: !0
    };
    function W(o, t, n) {
        var s, u, h = (n = n || j).createElement("script");
        if (h.text = o,
        t)
            for (s in L)
                (u = t[s] || t.getAttribute && t.getAttribute(s)) && h.setAttribute(s, u);
        n.head.appendChild(h).parentNode.removeChild(h)
    }
    function K(o) {
        return o == null ? o + "" : _typeof(o) == "object" || typeof o == "function" ? i[l.call(o)] || "object" : _typeof(o)
    }
    var U = "3.5.1"
      , r = function o(t, n) {
        return new o.fn.init(t,n)
    };
    function ot(o) {
        var t = !!o && "length"in o && o.length
          , n = K(o);
        return !y(o) && !A(o) && (n === "array" || t === 0 || typeof t == "number" && 0 < t && t - 1 in o)
    }
    r.fn = r.prototype = {
        jquery: U,
        constructor: r,
        length: 0,
        toArray: function() {
            return w.call(this)
        },
        get: function(t) {
            return t == null ? w.call(this) : t < 0 ? this[t + this.length] : this[t]
        },
        pushStack: function(t) {
            var n = r.merge(this.constructor(), t);
            return n.prevObject = this,
            n
        },
        each: function(t) {
            return r.each(this, t)
        },
        map: function(t) {
            return this.pushStack(r.map(this, function(n, s) {
                return t.call(n, s, n)
            }))
        },
        slice: function() {
            return this.pushStack(w.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        even: function() {
            return this.pushStack(r.grep(this, function(t, n) {
                return (n + 1) % 2
            }))
        },
        odd: function() {
            return this.pushStack(r.grep(this, function(t, n) {
                return n % 2
            }))
        },
        eq: function(t) {
            var n = this.length
              , s = +t + (t < 0 ? n : 0);
            return this.pushStack(0 <= s && s < n ? [this[s]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor()
        },
        push: c,
        sort: Nt.sort,
        splice: Nt.splice
    },
    r.extend = r.fn.extend = function() {
        var o, t, n, s, u, h, f = arguments[0] || {}, m = 1, C = arguments.length, b = !1;
        for (typeof f == "boolean" && (b = f,
        f = arguments[m] || {},
        m++),
        _typeof(f) == "object" || y(f) || (f = {}),
        m === C && (f = this,
        m--); m < C; m++)
            if ((o = arguments[m]) != null)
                for (t in o)
                    s = o[t],
                    t !== "__proto__" && f !== s && (b && s && (r.isPlainObject(s) || (u = Array.isArray(s))) ? (n = f[t],
                    h = u && !Array.isArray(n) ? [] : u || r.isPlainObject(n) ? n : {},
                    u = !1,
                    f[t] = r.extend(b, h, s)) : s !== void 0 && (f[t] = s));
        return f
    }
    ,
    r.extend({
        expando: "jQuery" + (U + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(t) {
            throw new Error(t)
        },
        noop: function() {},
        isPlainObject: function(t) {
            var n, s;
            return !(!t || l.call(t) !== "[object Object]") && (!(n = d(t)) || typeof (s = a.call(n, "constructor") && n.constructor) == "function" && g.call(s) === S)
        },
        isEmptyObject: function(t) {
            var n;
            for (n in t)
                return !1;
            return !0
        },
        globalEval: function(t, n, s) {
            W(t, {
                nonce: n && n.nonce
            }, s)
        },
        each: function(t, n) {
            var s, u = 0;
            if (ot(t))
                for (s = t.length; u < s && n.call(t[u], u, t[u]) !== !1; u++)
                    ;
            else
                for (u in t)
                    if (n.call(t[u], u, t[u]) === !1)
                        break;
            return t
        },
        makeArray: function(t, n) {
            var s = n || [];
            return t != null && (ot(Object(t)) ? r.merge(s, typeof t == "string" ? [t] : t) : c.call(s, t)),
            s
        },
        inArray: function(t, n, s) {
            return n == null ? -1 : p.call(n, t, s)
        },
        merge: function(t, n) {
            for (var s = +n.length, u = 0, h = t.length; u < s; u++)
                t[h++] = n[u];
            return t.length = h,
            t
        },
        grep: function(t, n, s) {
            for (var u = [], h = 0, f = t.length, m = !s; h < f; h++)
                !n(t[h], h) !== m && u.push(t[h]);
            return u
        },
        map: function(t, n, s) {
            var u, h, f = 0, m = [];
            if (ot(t))
                for (u = t.length; f < u; f++)
                    (h = n(t[f], f, s)) != null && m.push(h);
            else
                for (f in t)
                    (h = n(t[f], f, s)) != null && m.push(h);
            return e(m)
        },
        guid: 1,
        support: T
    }),
    typeof Symbol == "function" && (r.fn[Symbol.iterator] = Nt[Symbol.iterator]),
    r.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(o, t) {
        i["[object " + t + "]"] = t.toLowerCase()
    });
    var B = function(o) {
        var t, n, s, u, h, f, m, C, b, E, H, I, k, M, rt, Z, At, ae, pe, $t = "sizzle" + 1 * new Date, Ht = o.document, vt = 0, Qe = 0, qt = ui(), Wt = ui(), It = ui(), Ye = ui(), me = function(v, _) {
            return v === _ && (H = !0),
            0
        }, ii = {}.hasOwnProperty, ve = [], Oe = ve.pop, Ge = ve.push, Gt = ve.push, te = ve.slice, Kt = function(v, _) {
            for (var D = 0, z = v.length; D < z; D++)
                if (v[D] === _)
                    return D;
            return -1
        }, je = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", Ct = "[\\x20\\t\\r\\n\\f]", Ft = "(?:\\\\[\\da-fA-F]{1,6}" + Ct + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", Pt = "\\[" + Ct + "*(" + Ft + ")(?:" + Ct + "*([*^$|!~]?=)" + Ct + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + Ft + "))|)" + Ct + "*\\]", Qt = ":(" + Ft + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + Pt + ")*)|.*)\\)|)", be = new RegExp(Ct + "+","g"), Rt = new RegExp("^" + Ct + "+|((?:^|[^\\\\])(?:\\\\.)*)" + Ct + "+$","g"), ze = new RegExp("^" + Ct + "*," + Ct + "*"), Re = new RegExp("^" + Ct + "*([>+~]|" + Ct + ")" + Ct + "*"), _i = new RegExp(Ct + "|>"), Wn = new RegExp(Qt), Fn = new RegExp("^" + Ft + "$"), ci = {
            ID: new RegExp("^#(" + Ft + ")"),
            CLASS: new RegExp("^\\.(" + Ft + ")"),
            TAG: new RegExp("^(" + Ft + "|[*])"),
            ATTR: new RegExp("^" + Pt),
            PSEUDO: new RegExp("^" + Qt),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + Ct + "*(even|odd|(([+-]|)(\\d*)n|)" + Ct + "*(?:([+-]|)" + Ct + "*(\\d+)|))" + Ct + "*\\)|)","i"),
            bool: new RegExp("^(?:" + je + ")$","i"),
            needsContext: new RegExp("^" + Ct + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + Ct + "*((?:-\\d)?\\d*)" + Ct + "*\\)|)(?=[^-]|$)","i")
        }, Bn = /HTML$/i, Un = /^(?:input|select|textarea|button)$/i, Xn = /^h\d$/i, ni = /^[^{]+\{\s*\[native \w/, Vn = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, zi = /[+~]/, De = new RegExp("\\\\[\\da-fA-F]{1,6}" + Ct + "?|\\\\([^\\r\\n\\f])","g"), Pe = function(v, _) {
            var D = "0x" + v.slice(1) - 65536;
            return _ || (D < 0 ? String.fromCharCode(D + 65536) : String.fromCharCode(D >> 10 | 55296, 1023 & D | 56320))
        }, rn = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, an = function(v, _) {
            return _ ? v === "\0" ? "\uFFFD" : v.slice(0, -1) + "\\" + v.charCodeAt(v.length - 1).toString(16) + " " : "\\" + v
        }, ln = function() {
            I()
        }, Qn = pi(function(x) {
            return x.disabled === !0 && x.nodeName.toLowerCase() === "fieldset"
        }, {
            dir: "parentNode",
            next: "legend"
        });
        try {
            Gt.apply(ve = te.call(Ht.childNodes), Ht.childNodes),
            ve[Ht.childNodes.length].nodeType
        } catch (x) {
            Gt = {
                apply: ve.length ? function(v, _) {
                    Ge.apply(v, te.call(_))
                }
                : function(v, _) {
                    for (var D = v.length, z = 0; v[D++] = _[z++]; )
                        ;
                    v.length = D - 1
                }
            }
        }
        function Et(x, v, _, D) {
            var z, N, F, G, et, ut, mt, Tt = v && v.ownerDocument, zt = v ? v.nodeType : 9;
            if (_ = _ || [],
            typeof x != "string" || !x || zt !== 1 && zt !== 9 && zt !== 11)
                return _;
            if (!D && (I(v),
            v = v || k,
            rt)) {
                if (zt !== 11 && (et = Vn.exec(x)))
                    if (z = et[1]) {
                        if (zt === 9) {
                            if (!(F = v.getElementById(z)))
                                return _;
                            if (F.id === z)
                                return _.push(F),
                                _
                        } else if (Tt && (F = Tt.getElementById(z)) && pe(v, F) && F.id === z)
                            return _.push(F),
                            _
                    } else {
                        if (et[2])
                            return Gt.apply(_, v.getElementsByTagName(x)),
                            _;
                        if ((z = et[3]) && n.getElementsByClassName && v.getElementsByClassName)
                            return Gt.apply(_, v.getElementsByClassName(z)),
                            _
                    }
                if (n.qsa && !Ye[x + " "] && (!Z || !Z.test(x)) && (zt !== 1 || v.nodeName.toLowerCase() !== "object")) {
                    if (mt = x,
                    Tt = v,
                    zt === 1 && (_i.test(x) || Re.test(x))) {
                        for ((Tt = zi.test(x) && Ai(v.parentNode) || v) === v && n.scope || ((G = v.getAttribute("id")) ? G = G.replace(rn, an) : v.setAttribute("id", G = $t)),
                        N = (ut = f(x)).length; N--; )
                            ut[N] = (G ? "#" + G : ":scope") + " " + di(ut[N]);
                        mt = ut.join(",")
                    }
                    try {
                        return Gt.apply(_, Tt.querySelectorAll(mt)),
                        _
                    } catch (Bt) {
                        Ye(x, !0)
                    } finally {
                        G === $t && v.removeAttribute("id")
                    }
                }
            }
            return C(x.replace(Rt, "$1"), v, _, D)
        }
        function ui() {
            var x = [];
            return function v(_, D) {
                return x.push(_ + " ") > s.cacheLength && delete v[x.shift()],
                v[_ + " "] = D
            }
        }
        function Te(x) {
            return x[$t] = !0,
            x
        }
        function Ce(x) {
            var v = k.createElement("fieldset");
            try {
                return !!x(v)
            } catch (_) {
                return !1
            } finally {
                v.parentNode && v.parentNode.removeChild(v),
                v = null
            }
        }
        function $i(x, v) {
            for (var _ = x.split("|"), D = _.length; D--; )
                s.attrHandle[_[D]] = v
        }
        function cn(x, v) {
            var _ = v && x
              , D = _ && x.nodeType === 1 && v.nodeType === 1 && x.sourceIndex - v.sourceIndex;
            if (D)
                return D;
            if (_) {
                for (; _ = _.nextSibling; )
                    if (_ === v)
                        return -1
            }
            return x ? 1 : -1
        }
        function Yn(x) {
            return function(v) {
                return v.nodeName.toLowerCase() === "input" && v.type === x
            }
        }
        function Gn(x) {
            return function(v) {
                var _ = v.nodeName.toLowerCase();
                return (_ === "input" || _ === "button") && v.type === x
            }
        }
        function un(x) {
            return function(v) {
                return "form"in v ? v.parentNode && v.disabled === !1 ? "label"in v ? "label"in v.parentNode ? v.parentNode.disabled === x : v.disabled === x : v.isDisabled === x || v.isDisabled !== !x && Qn(v) === x : v.disabled === x : "label"in v && v.disabled === x
            }
        }
        function We(x) {
            return Te(function(v) {
                return v = +v,
                Te(function(_, D) {
                    for (var z, N = x([], _.length, v), F = N.length; F--; )
                        _[z = N[F]] && (_[z] = !(D[z] = _[z]))
                })
            })
        }
        function Ai(x) {
            return x && typeof x.getElementsByTagName != "undefined" && x
        }
        for (t in n = Et.support = {},
        h = Et.isXML = function(x) {
            var v = x.namespaceURI
              , _ = (x.ownerDocument || x).documentElement;
            return !Bn.test(v || _ && _.nodeName || "HTML")
        }
        ,
        I = Et.setDocument = function(x) {
            var v, _, D = x ? x.ownerDocument || x : Ht;
            return D != k && D.nodeType === 9 && D.documentElement && (M = (k = D).documentElement,
            rt = !h(k),
            Ht != k && (_ = k.defaultView) && _.top !== _ && (_.addEventListener ? _.addEventListener("unload", ln, !1) : _.attachEvent && _.attachEvent("onunload", ln)),
            n.scope = Ce(function(z) {
                return M.appendChild(z).appendChild(k.createElement("div")),
                typeof z.querySelectorAll != "undefined" && !z.querySelectorAll(":scope fieldset div").length
            }),
            n.attributes = Ce(function(z) {
                return z.className = "i",
                !z.getAttribute("className")
            }),
            n.getElementsByTagName = Ce(function(z) {
                return z.appendChild(k.createComment("")),
                !z.getElementsByTagName("*").length
            }),
            n.getElementsByClassName = ni.test(k.getElementsByClassName),
            n.getById = Ce(function(z) {
                return M.appendChild(z).id = $t,
                !k.getElementsByName || !k.getElementsByName($t).length
            }),
            n.getById ? (s.filter.ID = function(z) {
                var N = z.replace(De, Pe);
                return function(F) {
                    return F.getAttribute("id") === N
                }
            }
            ,
            s.find.ID = function(z, N) {
                if (typeof N.getElementById != "undefined" && rt) {
                    var F = N.getElementById(z);
                    return F ? [F] : []
                }
            }
            ) : (s.filter.ID = function(z) {
                var N = z.replace(De, Pe);
                return function(F) {
                    var G = typeof F.getAttributeNode != "undefined" && F.getAttributeNode("id");
                    return G && G.value === N
                }
            }
            ,
            s.find.ID = function(z, N) {
                if (typeof N.getElementById != "undefined" && rt) {
                    var F, G, et, ut = N.getElementById(z);
                    if (ut) {
                        if ((F = ut.getAttributeNode("id")) && F.value === z)
                            return [ut];
                        for (et = N.getElementsByName(z),
                        G = 0; ut = et[G++]; )
                            if ((F = ut.getAttributeNode("id")) && F.value === z)
                                return [ut]
                    }
                    return []
                }
            }
            ),
            s.find.TAG = n.getElementsByTagName ? function(z, N) {
                return typeof N.getElementsByTagName != "undefined" ? N.getElementsByTagName(z) : n.qsa ? N.querySelectorAll(z) : void 0
            }
            : function(z, N) {
                var F, G = [], et = 0, ut = N.getElementsByTagName(z);
                if (z === "*") {
                    for (; F = ut[et++]; )
                        F.nodeType === 1 && G.push(F);
                    return G
                }
                return ut
            }
            ,
            s.find.CLASS = n.getElementsByClassName && function(z, N) {
                if (typeof N.getElementsByClassName != "undefined" && rt)
                    return N.getElementsByClassName(z)
            }
            ,
            At = [],
            Z = [],
            (n.qsa = ni.test(k.querySelectorAll)) && (Ce(function(z) {
                var N;
                M.appendChild(z).innerHTML = "<a id='" + $t + "'></a><select id='" + $t + "-\r\\' msallowcapture=''><option selected=''></option></select>",
                z.querySelectorAll("[msallowcapture^='']").length && Z.push("[*^$]=" + Ct + "*(?:''|\"\")"),
                z.querySelectorAll("[selected]").length || Z.push("\\[" + Ct + "*(?:value|" + je + ")"),
                z.querySelectorAll("[id~=" + $t + "-]").length || Z.push("~="),
                (N = k.createElement("input")).setAttribute("name", ""),
                z.appendChild(N),
                z.querySelectorAll("[name='']").length || Z.push("\\[" + Ct + "*name" + Ct + "*=" + Ct + "*(?:''|\"\")"),
                z.querySelectorAll(":checked").length || Z.push(":checked"),
                z.querySelectorAll("a#" + $t + "+*").length || Z.push(".#.+[+~]"),
                z.querySelectorAll("\\\f"),
                Z.push("[\\r\\n\\f]")
            }),
            Ce(function(z) {
                z.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                var N = k.createElement("input");
                N.setAttribute("type", "hidden"),
                z.appendChild(N).setAttribute("name", "D"),
                z.querySelectorAll("[name=d]").length && Z.push("name" + Ct + "*[*^$|!~]?="),
                z.querySelectorAll(":enabled").length !== 2 && Z.push(":enabled", ":disabled"),
                M.appendChild(z).disabled = !0,
                z.querySelectorAll(":disabled").length !== 2 && Z.push(":enabled", ":disabled"),
                z.querySelectorAll("*,:x"),
                Z.push(",.*:")
            })),
            (n.matchesSelector = ni.test(ae = M.matches || M.webkitMatchesSelector || M.mozMatchesSelector || M.oMatchesSelector || M.msMatchesSelector)) && Ce(function(z) {
                n.disconnectedMatch = ae.call(z, "*"),
                ae.call(z, "[s!='']:x"),
                At.push("!=", Qt)
            }),
            Z = Z.length && new RegExp(Z.join("|")),
            At = At.length && new RegExp(At.join("|")),
            v = ni.test(M.compareDocumentPosition),
            pe = v || ni.test(M.contains) ? function(z, N) {
                var F = z.nodeType === 9 ? z.documentElement : z
                  , G = N && N.parentNode;
                return z === G || !(!G || G.nodeType !== 1 || !(F.contains ? F.contains(G) : z.compareDocumentPosition && 16 & z.compareDocumentPosition(G)))
            }
            : function(z, N) {
                if (N) {
                    for (; N = N.parentNode; )
                        if (N === z)
                            return !0
                }
                return !1
            }
            ,
            me = v ? function(z, N) {
                if (z === N)
                    return H = !0,
                    0;
                var F = !z.compareDocumentPosition - !N.compareDocumentPosition;
                return F || (1 & (F = (z.ownerDocument || z) == (N.ownerDocument || N) ? z.compareDocumentPosition(N) : 1) || !n.sortDetached && N.compareDocumentPosition(z) === F ? z == k || z.ownerDocument == Ht && pe(Ht, z) ? -1 : N == k || N.ownerDocument == Ht && pe(Ht, N) ? 1 : E ? Kt(E, z) - Kt(E, N) : 0 : 4 & F ? -1 : 1)
            }
            : function(z, N) {
                if (z === N)
                    return H = !0,
                    0;
                var F, G = 0, et = z.parentNode, ut = N.parentNode, mt = [z], Tt = [N];
                if (!et || !ut)
                    return z == k ? -1 : N == k ? 1 : et ? -1 : ut ? 1 : E ? Kt(E, z) - Kt(E, N) : 0;
                if (et === ut)
                    return cn(z, N);
                for (F = z; F = F.parentNode; )
                    mt.unshift(F);
                for (F = N; F = F.parentNode; )
                    Tt.unshift(F);
                for (; mt[G] === Tt[G]; )
                    G++;
                return G ? cn(mt[G], Tt[G]) : mt[G] == Ht ? -1 : Tt[G] == Ht ? 1 : 0
            }
            ),
            k
        }
        ,
        Et.matches = function(x, v) {
            return Et(x, null, null, v)
        }
        ,
        Et.matchesSelector = function(x, v) {
            if (I(x),
            n.matchesSelector && rt && !Ye[v + " "] && (!At || !At.test(v)) && (!Z || !Z.test(v)))
                try {
                    var _ = ae.call(x, v);
                    if (_ || n.disconnectedMatch || x.document && x.document.nodeType !== 11)
                        return _
                } catch (D) {
                    Ye(v, !0)
                }
            return 0 < Et(v, k, null, [x]).length
        }
        ,
        Et.contains = function(x, v) {
            return (x.ownerDocument || x) != k && I(x),
            pe(x, v)
        }
        ,
        Et.attr = function(x, v) {
            (x.ownerDocument || x) != k && I(x);
            var _ = s.attrHandle[v.toLowerCase()]
              , D = _ && ii.call(s.attrHandle, v.toLowerCase()) ? _(x, v, !rt) : void 0;
            return D !== void 0 ? D : n.attributes || !rt ? x.getAttribute(v) : (D = x.getAttributeNode(v)) && D.specified ? D.value : null
        }
        ,
        Et.escape = function(x) {
            return (x + "").replace(rn, an)
        }
        ,
        Et.error = function(x) {
            throw new Error("Syntax error, unrecognized expression: " + x)
        }
        ,
        Et.uniqueSort = function(x) {
            var v, _ = [], D = 0, z = 0;
            if (H = !n.detectDuplicates,
            E = !n.sortStable && x.slice(0),
            x.sort(me),
            H) {
                for (; v = x[z++]; )
                    v === x[z] && (D = _.push(z));
                for (; D--; )
                    x.splice(_[D], 1)
            }
            return E = null,
            x
        }
        ,
        u = Et.getText = function(x) {
            var v, _ = "", D = 0, z = x.nodeType;
            if (z) {
                if (z === 1 || z === 9 || z === 11) {
                    if (typeof x.textContent == "string")
                        return x.textContent;
                    for (x = x.firstChild; x; x = x.nextSibling)
                        _ += u(x)
                } else if (z === 3 || z === 4)
                    return x.nodeValue
            } else
                for (; v = x[D++]; )
                    _ += u(v);
            return _
        }
        ,
        (s = Et.selectors = {
            cacheLength: 50,
            createPseudo: Te,
            match: ci,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: !0
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: !0
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(v) {
                    return v[1] = v[1].replace(De, Pe),
                    v[3] = (v[3] || v[4] || v[5] || "").replace(De, Pe),
                    v[2] === "~=" && (v[3] = " " + v[3] + " "),
                    v.slice(0, 4)
                },
                CHILD: function(v) {
                    return v[1] = v[1].toLowerCase(),
                    v[1].slice(0, 3) === "nth" ? (v[3] || Et.error(v[0]),
                    v[4] = +(v[4] ? v[5] + (v[6] || 1) : 2 * (v[3] === "even" || v[3] === "odd")),
                    v[5] = +(v[7] + v[8] || v[3] === "odd")) : v[3] && Et.error(v[0]),
                    v
                },
                PSEUDO: function(v) {
                    var _, D = !v[6] && v[2];
                    return ci.CHILD.test(v[0]) ? null : (v[3] ? v[2] = v[4] || v[5] || "" : D && Wn.test(D) && (_ = f(D, !0)) && (_ = D.indexOf(")", D.length - _) - D.length) && (v[0] = v[0].slice(0, _),
                    v[2] = D.slice(0, _)),
                    v.slice(0, 3))
                }
            },
            filter: {
                TAG: function(v) {
                    var _ = v.replace(De, Pe).toLowerCase();
                    return v === "*" ? function() {
                        return !0
                    }
                    : function(D) {
                        return D.nodeName && D.nodeName.toLowerCase() === _
                    }
                },
                CLASS: function(v) {
                    var _ = qt[v + " "];
                    return _ || (_ = new RegExp("(^|" + Ct + ")" + v + "(" + Ct + "|$)")) && qt(v, function(D) {
                        return _.test(typeof D.className == "string" && D.className || typeof D.getAttribute != "undefined" && D.getAttribute("class") || "")
                    })
                },
                ATTR: function(v, _, D) {
                    return function(z) {
                        var N = Et.attr(z, v);
                        return N == null ? _ === "!=" : !_ || (N += "",
                        _ === "=" ? N === D : _ === "!=" ? N !== D : _ === "^=" ? D && N.indexOf(D) === 0 : _ === "*=" ? D && -1 < N.indexOf(D) : _ === "$=" ? D && N.slice(-D.length) === D : _ === "~=" ? -1 < (" " + N.replace(be, " ") + " ").indexOf(D) : _ === "|=" && (N === D || N.slice(0, D.length + 1) === D + "-"))
                    }
                },
                CHILD: function(v, _, D, z, N) {
                    var F = v.slice(0, 3) !== "nth"
                      , G = v.slice(-4) !== "last"
                      , et = _ === "of-type";
                    return z === 1 && N === 0 ? function(ut) {
                        return !!ut.parentNode
                    }
                    : function(ut, mt, Tt) {
                        var zt, Bt, Zt, St, Jt, Yt, Lt = F !== G ? "nextSibling" : "previousSibling", he = ut.parentNode, Se = et && ut.nodeName.toLowerCase(), ne = !Tt && !et, Ut = !1;
                        if (he) {
                            if (F) {
                                for (; Lt; ) {
                                    for (St = ut; St = St[Lt]; )
                                        if (et ? St.nodeName.toLowerCase() === Se : St.nodeType === 1)
                                            return !1;
                                    Yt = Lt = v === "only" && !Yt && "nextSibling"
                                }
                                return !0
                            }
                            if (Yt = [G ? he.firstChild : he.lastChild],
                            G && ne) {
                                for (Ut = (Jt = (zt = (Bt = (Zt = (St = he)[$t] || (St[$t] = {}))[St.uniqueID] || (Zt[St.uniqueID] = {}))[v] || [])[0] === vt && zt[1]) && zt[2],
                                St = Jt && he.childNodes[Jt]; St = ++Jt && St && St[Lt] || (Ut = Jt = 0) || Yt.pop(); )
                                    if (St.nodeType === 1 && ++Ut && St === ut) {
                                        Bt[v] = [vt, Jt, Ut];
                                        break
                                    }
                            } else if (ne && (Ut = Jt = (zt = (Bt = (Zt = (St = ut)[$t] || (St[$t] = {}))[St.uniqueID] || (Zt[St.uniqueID] = {}))[v] || [])[0] === vt && zt[1]),
                            Ut === !1)
                                for (; (St = ++Jt && St && St[Lt] || (Ut = Jt = 0) || Yt.pop()) && !((et ? St.nodeName.toLowerCase() === Se : St.nodeType === 1) && ++Ut && (ne && ((Bt = (Zt = St[$t] || (St[$t] = {}))[St.uniqueID] || (Zt[St.uniqueID] = {}))[v] = [vt, Ut]),
                                St === ut)); )
                                    ;
                            return (Ut -= N) === z || Ut % z == 0 && 0 <= Ut / z
                        }
                    }
                },
                PSEUDO: function(v, _) {
                    var D, z = s.pseudos[v] || s.setFilters[v.toLowerCase()] || Et.error("unsupported pseudo: " + v);
                    return z[$t] ? z(_) : 1 < z.length ? (D = [v, v, "", _],
                    s.setFilters.hasOwnProperty(v.toLowerCase()) ? Te(function(N, F) {
                        for (var G, et = z(N, _), ut = et.length; ut--; )
                            N[G = Kt(N, et[ut])] = !(F[G] = et[ut])
                    }) : function(N) {
                        return z(N, 0, D)
                    }
                    ) : z
                }
            },
            pseudos: {
                not: Te(function(x) {
                    var v = []
                      , _ = []
                      , D = m(x.replace(Rt, "$1"));
                    return D[$t] ? Te(function(z, N, F, G) {
                        for (var et, ut = D(z, null, G, []), mt = z.length; mt--; )
                            (et = ut[mt]) && (z[mt] = !(N[mt] = et))
                    }) : function(z, N, F) {
                        return v[0] = z,
                        D(v, null, F, _),
                        v[0] = null,
                        !_.pop()
                    }
                }),
                has: Te(function(x) {
                    return function(v) {
                        return 0 < Et(x, v).length
                    }
                }),
                contains: Te(function(x) {
                    return x = x.replace(De, Pe),
                    function(v) {
                        return -1 < (v.textContent || u(v)).indexOf(x)
                    }
                }),
                lang: Te(function(x) {
                    return Fn.test(x || "") || Et.error("unsupported lang: " + x),
                    x = x.replace(De, Pe).toLowerCase(),
                    function(v) {
                        var _;
                        do
                            if (_ = rt ? v.lang : v.getAttribute("xml:lang") || v.getAttribute("lang"))
                                return (_ = _.toLowerCase()) === x || _.indexOf(x + "-") === 0;
                        while ((v = v.parentNode) && v.nodeType === 1);
                        return !1
                    }
                }),
                target: function(v) {
                    var _ = o.location && o.location.hash;
                    return _ && _.slice(1) === v.id
                },
                root: function(v) {
                    return v === M
                },
                focus: function(v) {
                    return v === k.activeElement && (!k.hasFocus || k.hasFocus()) && !!(v.type || v.href || ~v.tabIndex)
                },
                enabled: un(!1),
                disabled: un(!0),
                checked: function(v) {
                    var _ = v.nodeName.toLowerCase();
                    return _ === "input" && !!v.checked || _ === "option" && !!v.selected
                },
                selected: function(v) {
                    return v.parentNode && v.parentNode.selectedIndex,
                    v.selected === !0
                },
                empty: function(v) {
                    for (v = v.firstChild; v; v = v.nextSibling)
                        if (v.nodeType < 6)
                            return !1;
                    return !0
                },
                parent: function(v) {
                    return !s.pseudos.empty(v)
                },
                header: function(v) {
                    return Xn.test(v.nodeName)
                },
                input: function(v) {
                    return Un.test(v.nodeName)
                },
                button: function(v) {
                    var _ = v.nodeName.toLowerCase();
                    return _ === "input" && v.type === "button" || _ === "button"
                },
                text: function(v) {
                    var _;
                    return v.nodeName.toLowerCase() === "input" && v.type === "text" && ((_ = v.getAttribute("type")) == null || _.toLowerCase() === "text")
                },
                first: We(function() {
                    return [0]
                }),
                last: We(function(x, v) {
                    return [v - 1]
                }),
                eq: We(function(x, v, _) {
                    return [_ < 0 ? _ + v : _]
                }),
                even: We(function(x, v) {
                    for (var _ = 0; _ < v; _ += 2)
                        x.push(_);
                    return x
                }),
                odd: We(function(x, v) {
                    for (var _ = 1; _ < v; _ += 2)
                        x.push(_);
                    return x
                }),
                lt: We(function(x, v, _) {
                    for (var D = _ < 0 ? _ + v : v < _ ? v : _; 0 <= --D; )
                        x.push(D);
                    return x
                }),
                gt: We(function(x, v, _) {
                    for (var D = _ < 0 ? _ + v : _; ++D < v; )
                        x.push(D);
                    return x
                })
            }
        }).pseudos.nth = s.pseudos.eq,
        {
            radio: !0,
            checkbox: !0,
            file: !0,
            password: !0,
            image: !0
        })
            s.pseudos[t] = Yn(t);
        for (t in {
            submit: !0,
            reset: !0
        })
            s.pseudos[t] = Gn(t);
        function dn() {}
        function di(x) {
            for (var v = 0, _ = x.length, D = ""; v < _; v++)
                D += x[v].value;
            return D
        }
        function pi(x, v, _) {
            var D = v.dir
              , z = v.next
              , N = z || D
              , F = _ && N === "parentNode"
              , G = Qe++;
            return v.first ? function(et, ut, mt) {
                for (; et = et[D]; )
                    if (et.nodeType === 1 || F)
                        return x(et, ut, mt);
                return !1
            }
            : function(et, ut, mt) {
                var Tt, zt, Bt, Zt = [vt, G];
                if (mt) {
                    for (; et = et[D]; )
                        if ((et.nodeType === 1 || F) && x(et, ut, mt))
                            return !0
                } else
                    for (; et = et[D]; )
                        if (et.nodeType === 1 || F)
                            if (zt = (Bt = et[$t] || (et[$t] = {}))[et.uniqueID] || (Bt[et.uniqueID] = {}),
                            z && z === et.nodeName.toLowerCase())
                                et = et[D] || et;
                            else {
                                if ((Tt = zt[N]) && Tt[0] === vt && Tt[1] === G)
                                    return Zt[2] = Tt[2];
                                if ((zt[N] = Zt)[2] = x(et, ut, mt))
                                    return !0
                            }
                return !1
            }
        }
        function Ei(x) {
            return 1 < x.length ? function(v, _, D) {
                for (var z = x.length; z--; )
                    if (!x[z](v, _, D))
                        return !1;
                return !0
            }
            : x[0]
        }
        function hi(x, v, _, D, z) {
            for (var N, F = [], G = 0, et = x.length, ut = v != null; G < et; G++)
                (N = x[G]) && (_ && !_(N, D, z) || (F.push(N),
                ut && v.push(G)));
            return F
        }
        function ji(x, v, _, D, z, N) {
            return D && !D[$t] && (D = ji(D)),
            z && !z[$t] && (z = ji(z, N)),
            Te(function(F, G, et, ut) {
                var mt, Tt, zt, Bt = [], Zt = [], St = G.length, Jt = F || function(he, Se, ne) {
                    for (var Ut = 0, Le = Se.length; Ut < Le; Ut++)
                        Et(he, Se[Ut], ne);
                    return ne
                }(v || "*", et.nodeType ? [et] : et, []), Yt = !x || !F && v ? Jt : hi(Jt, Bt, x, et, ut), Lt = _ ? z || (F ? x : St || D) ? [] : G : Yt;
                if (_ && _(Yt, Lt, et, ut),
                D)
                    for (mt = hi(Lt, Zt),
                    D(mt, [], et, ut),
                    Tt = mt.length; Tt--; )
                        (zt = mt[Tt]) && (Lt[Zt[Tt]] = !(Yt[Zt[Tt]] = zt));
                if (F) {
                    if (z || x) {
                        if (z) {
                            for (mt = [],
                            Tt = Lt.length; Tt--; )
                                (zt = Lt[Tt]) && mt.push(Yt[Tt] = zt);
                            z(null, Lt = [], mt, ut)
                        }
                        for (Tt = Lt.length; Tt--; )
                            (zt = Lt[Tt]) && -1 < (mt = z ? Kt(F, zt) : Bt[Tt]) && (F[mt] = !(G[mt] = zt))
                    }
                } else
                    Lt = hi(Lt === G ? Lt.splice(St, Lt.length) : Lt),
                    z ? z(null, G, Lt, ut) : Gt.apply(G, Lt)
            })
        }
        function Di(x) {
            for (var v, _, D, z = x.length, N = s.relative[x[0].type], F = N || s.relative[" "], G = N ? 1 : 0, et = pi(function(Tt) {
                return Tt === v
            }, F, !0), ut = pi(function(Tt) {
                return -1 < Kt(v, Tt)
            }, F, !0), mt = [function(Tt, zt, Bt) {
                var Zt = !N && (Bt || zt !== b) || ((v = zt).nodeType ? et(Tt, zt, Bt) : ut(Tt, zt, Bt));
                return v = null,
                Zt
            }
            ]; G < z; G++)
                if (_ = s.relative[x[G].type])
                    mt = [pi(Ei(mt), _)];
                else {
                    if ((_ = s.filter[x[G].type].apply(null, x[G].matches))[$t]) {
                        for (D = ++G; D < z && !s.relative[x[D].type]; D++)
                            ;
                        return ji(1 < G && Ei(mt), 1 < G && di(x.slice(0, G - 1).concat({
                            value: x[G - 2].type === " " ? "*" : ""
                        })).replace(Rt, "$1"), _, G < D && Di(x.slice(G, D)), D < z && Di(x = x.slice(D)), D < z && di(x))
                    }
                    mt.push(_)
                }
            return Ei(mt)
        }
        return dn.prototype = s.filters = s.pseudos,
        s.setFilters = new dn,
        f = Et.tokenize = function(x, v) {
            var _, D, z, N, F, G, et, ut = Wt[x + " "];
            if (ut)
                return v ? 0 : ut.slice(0);
            for (F = x,
            G = [],
            et = s.preFilter; F; ) {
                for (N in _ && !(D = ze.exec(F)) || (D && (F = F.slice(D[0].length) || F),
                G.push(z = [])),
                _ = !1,
                (D = Re.exec(F)) && (_ = D.shift(),
                z.push({
                    value: _,
                    type: D[0].replace(Rt, " ")
                }),
                F = F.slice(_.length)),
                s.filter)
                    !(D = ci[N].exec(F)) || et[N] && !(D = et[N](D)) || (_ = D.shift(),
                    z.push({
                        value: _,
                        type: N,
                        matches: D
                    }),
                    F = F.slice(_.length));
                if (!_)
                    break
            }
            return v ? F.length : F ? Et.error(x) : Wt(x, G).slice(0)
        }
        ,
        m = Et.compile = function(x, v) {
            var _, D, z, N, F, G, et = [], ut = [], mt = It[x + " "];
            if (!mt) {
                for (v || (v = f(x)),
                _ = v.length; _--; )
                    (mt = Di(v[_]))[$t] ? et.push(mt) : ut.push(mt);
                (mt = It(x, (D = ut,
                N = 0 < (z = et).length,
                F = 0 < D.length,
                G = function(zt, Bt, Zt, St, Jt) {
                    var Yt, Lt, he, Se = 0, ne = "0", Ut = zt && [], Le = [], pn = b, hn = zt || F && s.find.TAG("*", Jt), fn = vt += pn == null ? 1 : Math.random() || .1, Zn = hn.length;
                    for (Jt && (b = Bt == k || Bt || Jt); ne !== Zn && (Yt = hn[ne]) != null; ne++) {
                        if (F && Yt) {
                            for (Lt = 0,
                            Bt || Yt.ownerDocument == k || (I(Yt),
                            Zt = !rt); he = D[Lt++]; )
                                if (he(Yt, Bt || k, Zt)) {
                                    St.push(Yt);
                                    break
                                }
                            Jt && (vt = fn)
                        }
                        N && ((Yt = !he && Yt) && Se--,
                        zt && Ut.push(Yt))
                    }
                    if (Se += ne,
                    N && ne !== Se) {
                        for (Lt = 0; he = z[Lt++]; )
                            he(Ut, Le, Bt, Zt);
                        if (zt) {
                            if (0 < Se)
                                for (; ne--; )
                                    Ut[ne] || Le[ne] || (Le[ne] = Oe.call(St));
                            Le = hi(Le)
                        }
                        Gt.apply(St, Le),
                        Jt && !zt && 0 < Le.length && 1 < Se + z.length && Et.uniqueSort(St)
                    }
                    return Jt && (vt = fn,
                    b = pn),
                    Ut
                }
                ,
                N ? Te(G) : G))).selector = x
            }
            return mt
        }
        ,
        C = Et.select = function(x, v, _, D) {
            var z, N, F, G, et, ut = typeof x == "function" && x, mt = !D && f(x = ut.selector || x);
            if (_ = _ || [],
            mt.length === 1) {
                if (2 < (N = mt[0] = mt[0].slice(0)).length && (F = N[0]).type === "ID" && v.nodeType === 9 && rt && s.relative[N[1].type]) {
                    if (!(v = (s.find.ID(F.matches[0].replace(De, Pe), v) || [])[0]))
                        return _;
                    ut && (v = v.parentNode),
                    x = x.slice(N.shift().value.length)
                }
                for (z = ci.needsContext.test(x) ? 0 : N.length; z-- && (F = N[z],
                !s.relative[G = F.type]); )
                    if ((et = s.find[G]) && (D = et(F.matches[0].replace(De, Pe), zi.test(N[0].type) && Ai(v.parentNode) || v))) {
                        if (N.splice(z, 1),
                        !(x = D.length && di(N)))
                            return Gt.apply(_, D),
                            _;
                        break
                    }
            }
            return (ut || m(x, mt))(D, v, !rt, _, !v || zi.test(x) && Ai(v.parentNode) || v),
            _
        }
        ,
        n.sortStable = $t.split("").sort(me).join("") === $t,
        n.detectDuplicates = !!H,
        I(),
        n.sortDetached = Ce(function(x) {
            return 1 & x.compareDocumentPosition(k.createElement("fieldset"))
        }),
        Ce(function(x) {
            return x.innerHTML = "<a href='#'></a>",
            x.firstChild.getAttribute("href") === "#"
        }) || $i("type|href|height|width", function(x, v, _) {
            if (!_)
                return x.getAttribute(v, v.toLowerCase() === "type" ? 1 : 2)
        }),
        n.attributes && Ce(function(x) {
            return x.innerHTML = "<input/>",
            x.firstChild.setAttribute("value", ""),
            x.firstChild.getAttribute("value") === ""
        }) || $i("value", function(x, v, _) {
            if (!_ && x.nodeName.toLowerCase() === "input")
                return x.defaultValue
        }),
        Ce(function(x) {
            return x.getAttribute("disabled") == null
        }) || $i(je, function(x, v, _) {
            var D;
            if (!_)
                return x[v] === !0 ? v.toLowerCase() : (D = x.getAttributeNode(v)) && D.specified ? D.value : null
        }),
        Et
    }(xt);
    r.find = B,
    r.expr = B.selectors,
    r.expr[":"] = r.expr.pseudos,
    r.uniqueSort = r.unique = B.uniqueSort,
    r.text = B.getText,
    r.isXMLDoc = B.isXML,
    r.contains = B.contains,
    r.escapeSelector = B.escape;
    var it = function(t, n, s) {
        for (var u = [], h = s !== void 0; (t = t[n]) && t.nodeType !== 9; )
            if (t.nodeType === 1) {
                if (h && r(t).is(s))
                    break;
                u.push(t)
            }
        return u
    }
      , yt = function(t, n) {
        for (var s = []; t; t = t.nextSibling)
            t.nodeType === 1 && t !== n && s.push(t);
        return s
    }
      , Y = r.expr.match.needsContext;
    function X(o, t) {
        return o.nodeName && o.nodeName.toLowerCase() === t.toLowerCase()
    }
    var tt = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function ft(o, t, n) {
        return y(t) ? r.grep(o, function(s, u) {
            return !!t.call(s, u, s) !== n
        }) : t.nodeType ? r.grep(o, function(s) {
            return s === t !== n
        }) : typeof t != "string" ? r.grep(o, function(s) {
            return -1 < p.call(t, s) !== n
        }) : r.filter(t, o, n)
    }
    r.filter = function(o, t, n) {
        var s = t[0];
        return n && (o = ":not(" + o + ")"),
        t.length === 1 && s.nodeType === 1 ? r.find.matchesSelector(s, o) ? [s] : [] : r.find.matches(o, r.grep(t, function(u) {
            return u.nodeType === 1
        }))
    }
    ,
    r.fn.extend({
        find: function(t) {
            var n, s, u = this.length, h = this;
            if (typeof t != "string")
                return this.pushStack(r(t).filter(function() {
                    for (n = 0; n < u; n++)
                        if (r.contains(h[n], this))
                            return !0
                }));
            for (s = this.pushStack([]),
            n = 0; n < u; n++)
                r.find(t, h[n], s);
            return 1 < u ? r.uniqueSort(s) : s
        },
        filter: function(t) {
            return this.pushStack(ft(this, t || [], !1))
        },
        not: function(t) {
            return this.pushStack(ft(this, t || [], !0))
        },
        is: function(t) {
            return !!ft(this, typeof t == "string" && Y.test(t) ? r(t) : t || [], !1).length
        }
    });
    var dt, V = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    (r.fn.init = function(o, t, n) {
        var s, u;
        if (!o)
            return this;
        if (n = n || dt,
        typeof o == "string") {
            if (!(s = o[0] === "<" && o[o.length - 1] === ">" && 3 <= o.length ? [null, o, null] : V.exec(o)) || !s[1] && t)
                return !t || t.jquery ? (t || n).find(o) : this.constructor(t).find(o);
            if (s[1]) {
                if (t = t instanceof r ? t[0] : t,
                r.merge(this, r.parseHTML(s[1], t && t.nodeType ? t.ownerDocument || t : j, !0)),
                tt.test(s[1]) && r.isPlainObject(t))
                    for (s in t)
                        y(this[s]) ? this[s](t[s]) : this.attr(s, t[s]);
                return this
            }
            return (u = j.getElementById(s[2])) && (this[0] = u,
            this.length = 1),
            this
        }
        return o.nodeType ? (this[0] = o,
        this.length = 1,
        this) : y(o) ? n.ready !== void 0 ? n.ready(o) : o(r) : r.makeArray(o, this)
    }
    ).prototype = r.fn,
    dt = r(j);
    var nt = /^(?:parents|prev(?:Until|All))/
      , ct = {
        children: !0,
        contents: !0,
        next: !0,
        prev: !0
    };
    function R(o, t) {
        for (; (o = o[t]) && o.nodeType !== 1; )
            ;
        return o
    }
    r.fn.extend({
        has: function(t) {
            var n = r(t, this)
              , s = n.length;
            return this.filter(function() {
                for (var u = 0; u < s; u++)
                    if (r.contains(this, n[u]))
                        return !0
            })
        },
        closest: function(t, n) {
            var s, u = 0, h = this.length, f = [], m = typeof t != "string" && r(t);
            if (!Y.test(t)) {
                for (; u < h; u++)
                    for (s = this[u]; s && s !== n; s = s.parentNode)
                        if (s.nodeType < 11 && (m ? -1 < m.index(s) : s.nodeType === 1 && r.find.matchesSelector(s, t))) {
                            f.push(s);
                            break
                        }
            }
            return this.pushStack(1 < f.length ? r.uniqueSort(f) : f)
        },
        index: function(t) {
            return t ? typeof t == "string" ? p.call(r(t), this[0]) : p.call(this, t.jquery ? t[0] : t) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(t, n) {
            return this.pushStack(r.uniqueSort(r.merge(this.get(), r(t, n))))
        },
        addBack: function(t) {
            return this.add(t == null ? this.prevObject : this.prevObject.filter(t))
        }
    }),
    r.each({
        parent: function(t) {
            var n = t.parentNode;
            return n && n.nodeType !== 11 ? n : null
        },
        parents: function(t) {
            return it(t, "parentNode")
        },
        parentsUntil: function(t, n, s) {
            return it(t, "parentNode", s)
        },
        next: function(t) {
            return R(t, "nextSibling")
        },
        prev: function(t) {
            return R(t, "previousSibling")
        },
        nextAll: function(t) {
            return it(t, "nextSibling")
        },
        prevAll: function(t) {
            return it(t, "previousSibling")
        },
        nextUntil: function(t, n, s) {
            return it(t, "nextSibling", s)
        },
        prevUntil: function(t, n, s) {
            return it(t, "previousSibling", s)
        },
        siblings: function(t) {
            return yt((t.parentNode || {}).firstChild, t)
        },
        children: function(t) {
            return yt(t.firstChild)
        },
        contents: function(t) {
            return t.contentDocument != null && d(t.contentDocument) ? t.contentDocument : (X(t, "template") && (t = t.content || t),
            r.merge([], t.childNodes))
        }
    }, function(o, t) {
        r.fn[o] = function(n, s) {
            var u = r.map(this, t, n);
            return o.slice(-5) !== "Until" && (s = n),
            s && typeof s == "string" && (u = r.filter(s, u)),
            1 < this.length && (ct[o] || r.uniqueSort(u),
            nt.test(o) && u.reverse()),
            this.pushStack(u)
        }
    });
    var P = /[^\x20\t\r\n\f]+/g;
    function O(o) {
        return o
    }
    function q(o) {
        throw o
    }
    function Q(o, t, n, s) {
        var u;
        try {
            o && y(u = o.promise) ? u.call(o).done(t).fail(n) : o && y(u = o.then) ? u.call(o, t, n) : t.apply(void 0, [o].slice(s))
        } catch (h) {
            n.apply(void 0, [h])
        }
    }
    r.Callbacks = function(o) {
        var t, n;
        o = typeof o == "string" ? (t = o,
        n = {},
        r.each(t.match(P) || [], function(I, k) {
            n[k] = !0
        }),
        n) : r.extend({}, o);
        var s, u, h, f, m = [], C = [], b = -1, E = function() {
            for (f = f || o.once,
            h = s = !0; C.length; b = -1)
                for (u = C.shift(); ++b < m.length; )
                    m[b].apply(u[0], u[1]) === !1 && o.stopOnFalse && (b = m.length,
                    u = !1);
            o.memory || (u = !1),
            s = !1,
            f && (m = u ? [] : "")
        }, H = {
            add: function() {
                return m && (u && !s && (b = m.length - 1,
                C.push(u)),
                function k(M) {
                    r.each(M, function(rt, Z) {
                        y(Z) ? o.unique && H.has(Z) || m.push(Z) : Z && Z.length && K(Z) !== "string" && k(Z)
                    })
                }(arguments),
                u && !s && E()),
                this
            },
            remove: function() {
                return r.each(arguments, function(k, M) {
                    for (var rt; -1 < (rt = r.inArray(M, m, rt)); )
                        m.splice(rt, 1),
                        rt <= b && b--
                }),
                this
            },
            has: function(k) {
                return k ? -1 < r.inArray(k, m) : 0 < m.length
            },
            empty: function() {
                return m && (m = []),
                this
            },
            disable: function() {
                return f = C = [],
                m = u = "",
                this
            },
            disabled: function() {
                return !m
            },
            lock: function() {
                return f = C = [],
                u || s || (m = u = ""),
                this
            },
            locked: function() {
                return !!f
            },
            fireWith: function(k, M) {
                return f || (M = [k, (M = M || []).slice ? M.slice() : M],
                C.push(M),
                s || E()),
                this
            },
            fire: function() {
                return H.fireWith(this, arguments),
                this
            },
            fired: function() {
                return !!h
            }
        };
        return H
    }
    ,
    r.extend({
        Deferred: function(t) {
            var n = [["notify", "progress", r.Callbacks("memory"), r.Callbacks("memory"), 2], ["resolve", "done", r.Callbacks("once memory"), r.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", r.Callbacks("once memory"), r.Callbacks("once memory"), 1, "rejected"]]
              , s = "pending"
              , u = {
                state: function() {
                    return s
                },
                always: function() {
                    return h.done(arguments).fail(arguments),
                    this
                },
                catch: function(m) {
                    return u.then(null, m)
                },
                pipe: function() {
                    var m = arguments;
                    return r.Deferred(function(C) {
                        r.each(n, function(b, E) {
                            var H = y(m[E[4]]) && m[E[4]];
                            h[E[1]](function() {
                                var I = H && H.apply(this, arguments);
                                I && y(I.promise) ? I.promise().progress(C.notify).done(C.resolve).fail(C.reject) : C[E[0] + "With"](this, H ? [I] : arguments)
                            })
                        }),
                        m = null
                    }).promise()
                },
                then: function(m, C, b) {
                    var E = 0;
                    function H(I, k, M, rt) {
                        return function() {
                            var Z = this
                              , At = arguments
                              , ae = function() {
                                var Ht, vt;
                                if (!(I < E)) {
                                    if ((Ht = M.apply(Z, At)) === k.promise())
                                        throw new TypeError("Thenable self-resolution");
                                    vt = Ht && (_typeof(Ht) == "object" || typeof Ht == "function") && Ht.then,
                                    y(vt) ? rt ? vt.call(Ht, H(E, k, O, rt), H(E, k, q, rt)) : (E++,
                                    vt.call(Ht, H(E, k, O, rt), H(E, k, q, rt), H(E, k, O, k.notifyWith))) : (M !== O && (Z = void 0,
                                    At = [Ht]),
                                    (rt || k.resolveWith)(Z, At))
                                }
                            }
                              , pe = rt ? ae : function() {
                                try {
                                    ae()
                                } catch ($t) {
                                    r.Deferred.exceptionHook && r.Deferred.exceptionHook($t, pe.stackTrace),
                                    E <= I + 1 && (M !== q && (Z = void 0,
                                    At = [$t]),
                                    k.rejectWith(Z, At))
                                }
                            }
                            ;
                            I ? pe() : (r.Deferred.getStackHook && (pe.stackTrace = r.Deferred.getStackHook()),
                            xt.setTimeout(pe))
                        }
                    }
                    return r.Deferred(function(I) {
                        n[0][3].add(H(0, I, y(b) ? b : O, I.notifyWith)),
                        n[1][3].add(H(0, I, y(m) ? m : O)),
                        n[2][3].add(H(0, I, y(C) ? C : q))
                    }).promise()
                },
                promise: function(m) {
                    return m != null ? r.extend(m, u) : u
                }
            }
              , h = {};
            return r.each(n, function(f, m) {
                var C = m[2]
                  , b = m[5];
                u[m[1]] = C.add,
                b && C.add(function() {
                    s = b
                }, n[3 - f][2].disable, n[3 - f][3].disable, n[0][2].lock, n[0][3].lock),
                C.add(m[3].fire),
                h[m[0]] = function() {
                    return h[m[0] + "With"](this === h ? void 0 : this, arguments),
                    this
                }
                ,
                h[m[0] + "With"] = C.fireWith
            }),
            u.promise(h),
            t && t.call(h, h),
            h
        },
        when: function(t) {
            var n = arguments.length
              , s = n
              , u = Array(s)
              , h = w.call(arguments)
              , f = r.Deferred()
              , m = function(b) {
                return function(E) {
                    u[b] = this,
                    h[b] = 1 < arguments.length ? w.call(arguments) : E,
                    --n || f.resolveWith(u, h)
                }
            };
            if (n <= 1 && (Q(t, f.done(m(s)).resolve, f.reject, !n),
            f.state() === "pending" || y(h[s] && h[s].then)))
                return f.then();
            for (; s--; )
                Q(h[s], m(s), f.reject);
            return f.promise()
        }
    });
    var st = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    r.Deferred.exceptionHook = function(o, t) {
        xt.console && xt.console.warn && o && st.test(o.name) && xt.console.warn("jQuery.Deferred exception: " + o.message, o.stack, t)
    }
    ,
    r.readyException = function(o) {
        xt.setTimeout(function() {
            throw o
        })
    }
    ;
    var J = r.Deferred();
    function gt() {
        j.removeEventListener("DOMContentLoaded", gt),
        xt.removeEventListener("load", gt),
        r.ready()
    }
    r.fn.ready = function(o) {
        return J.then(o).catch(function(t) {
            r.readyException(t)
        }),
        this
    }
    ,
    r.extend({
        isReady: !1,
        readyWait: 1,
        ready: function(t) {
            (t === !0 ? --r.readyWait : r.isReady) || (r.isReady = !0) !== t && 0 < --r.readyWait || J.resolveWith(j, [r])
        }
    }),
    r.ready.then = J.then,
    j.readyState === "complete" || j.readyState !== "loading" && !j.documentElement.doScroll ? xt.setTimeout(r.ready) : (j.addEventListener("DOMContentLoaded", gt),
    xt.addEventListener("load", gt));
    var wt = function o(t, n, s, u, h, f, m) {
        var C = 0
          , b = t.length
          , E = s == null;
        if (K(s) === "object")
            for (C in h = !0,
            s)
                o(t, n, C, s[C], !0, f, m);
        else if (u !== void 0 && (h = !0,
        y(u) || (m = !0),
        E && (m ? (n.call(t, u),
        n = null) : (E = n,
        n = function(I, k, M) {
            return E.call(r(I), M)
        }
        )),
        n))
            for (; C < b; C++)
                n(t[C], s, m ? u : u.call(t[C], C, n(t[C], s)));
        return h ? t : E ? n.call(t) : b ? n(t[0], s) : f
    }
      , ht = /^-ms-/
      , pt = /-([a-z])/g;
    function kt(o, t) {
        return t.toUpperCase()
    }
    function jt(o) {
        return o.replace(ht, "ms-").replace(pt, kt)
    }
    var ce = function(t) {
        return t.nodeType === 1 || t.nodeType === 9 || !+t.nodeType
    };
    function ee() {
        this.expando = r.expando + ee.uid++
    }
    ee.uid = 1,
    ee.prototype = {
        cache: function(t) {
            var n = t[this.expando];
            return n || (n = {},
            ce(t) && (t.nodeType ? t[this.expando] = n : Object.defineProperty(t, this.expando, {
                value: n,
                configurable: !0
            }))),
            n
        },
        set: function(t, n, s) {
            var u, h = this.cache(t);
            if (typeof n == "string")
                h[jt(n)] = s;
            else
                for (u in n)
                    h[jt(u)] = n[u];
            return h
        },
        get: function(t, n) {
            return n === void 0 ? this.cache(t) : t[this.expando] && t[this.expando][jt(n)]
        },
        access: function(t, n, s) {
            return n === void 0 || n && typeof n == "string" && s === void 0 ? this.get(t, n) : (this.set(t, n, s),
            s !== void 0 ? s : n)
        },
        remove: function(t, n) {
            var s, u = t[this.expando];
            if (u !== void 0) {
                if (n !== void 0)
                    for (s = (n = Array.isArray(n) ? n.map(jt) : (n = jt(n))in u ? [n] : n.match(P) || []).length; s--; )
                        delete u[n[s]];
                (n === void 0 || r.isEmptyObject(u)) && (t.nodeType ? t[this.expando] = void 0 : delete t[this.expando])
            }
        },
        hasData: function(t) {
            var n = t[this.expando];
            return n !== void 0 && !r.isEmptyObject(n)
        }
    };
    var at = new ee
      , Xt = new ee
      , ye = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/
      , fe = /[A-Z]/g;
    function Me(o, t, n) {
        var s, u;
        if (n === void 0 && o.nodeType === 1)
            if (s = "data-" + t.replace(fe, "-$&").toLowerCase(),
            typeof (n = o.getAttribute(s)) == "string") {
                try {
                    n = (u = n) === "true" || u !== "false" && (u === "null" ? null : u === +u + "" ? +u : ye.test(u) ? JSON.parse(u) : u)
                } catch (h) {}
                Xt.set(o, t, n)
            } else
                n = void 0;
        return n
    }
    r.extend({
        hasData: function(t) {
            return Xt.hasData(t) || at.hasData(t)
        },
        data: function(t, n, s) {
            return Xt.access(t, n, s)
        },
        removeData: function(t, n) {
            Xt.remove(t, n)
        },
        _data: function(t, n, s) {
            return at.access(t, n, s)
        },
        _removeData: function(t, n) {
            at.remove(t, n)
        }
    }),
    r.fn.extend({
        data: function(t, n) {
            var s, u, h, f = this[0], m = f && f.attributes;
            if (t === void 0) {
                if (this.length && (h = Xt.get(f),
                f.nodeType === 1 && !at.get(f, "hasDataAttrs"))) {
                    for (s = m.length; s--; )
                        m[s] && (u = m[s].name).indexOf("data-") === 0 && (u = jt(u.slice(5)),
                        Me(f, u, h[u]));
                    at.set(f, "hasDataAttrs", !0)
                }
                return h
            }
            return _typeof(t) == "object" ? this.each(function() {
                Xt.set(this, t)
            }) : wt(this, function(C) {
                var b;
                if (f && C === void 0)
                    return (b = Xt.get(f, t)) !== void 0 || (b = Me(f, t)) !== void 0 ? b : void 0;
                this.each(function() {
                    Xt.set(this, t, C)
                })
            }, null, n, 1 < arguments.length, null, !0)
        },
        removeData: function(t) {
            return this.each(function() {
                Xt.remove(this, t)
            })
        }
    }),
    r.extend({
        queue: function(t, n, s) {
            var u;
            if (t)
                return n = (n || "fx") + "queue",
                u = at.get(t, n),
                s && (!u || Array.isArray(s) ? u = at.access(t, n, r.makeArray(s)) : u.push(s)),
                u || []
        },
        dequeue: function(t, n) {
            n = n || "fx";
            var s = r.queue(t, n)
              , u = s.length
              , h = s.shift()
              , f = r._queueHooks(t, n);
            h === "inprogress" && (h = s.shift(),
            u--),
            h && (n === "fx" && s.unshift("inprogress"),
            delete f.stop,
            h.call(t, function() {
                r.dequeue(t, n)
            }, f)),
            !u && f && f.empty.fire()
        },
        _queueHooks: function(t, n) {
            var s = n + "queueHooks";
            return at.get(t, s) || at.access(t, s, {
                empty: r.Callbacks("once memory").add(function() {
                    at.remove(t, [n + "queue", s])
                })
            })
        }
    }),
    r.fn.extend({
        queue: function(t, n) {
            var s = 2;
            return typeof t != "string" && (n = t,
            t = "fx",
            s--),
            arguments.length < s ? r.queue(this[0], t) : n === void 0 ? this : this.each(function() {
                var u = r.queue(this, t, n);
                r._queueHooks(this, t),
                t === "fx" && u[0] !== "inprogress" && r.dequeue(this, t)
            })
        },
        dequeue: function(t) {
            return this.each(function() {
                r.dequeue(this, t)
            })
        },
        clearQueue: function(t) {
            return this.queue(t || "fx", [])
        },
        promise: function(t, n) {
            var s, u = 1, h = r.Deferred(), f = this, m = this.length, C = function() {
                --u || h.resolveWith(f, [f])
            };
            for (typeof t != "string" && (n = t,
            t = void 0),
            t = t || "fx"; m--; )
                (s = at.get(f[m], t + "queueHooks")) && s.empty && (u++,
                s.empty.add(C));
            return C(),
            h.promise(n)
        }
    });
    var oe = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source
      , ge = new RegExp("^(?:([+-])=|)(" + oe + ")([a-z%]*)$","i")
      , ue = ["Top", "Right", "Bottom", "Left"]
      , $e = j.documentElement
      , Ae = function(t) {
        return r.contains(t.ownerDocument, t)
    }
      , se = {
        composed: !0
    };
    $e.getRootNode && (Ae = function(t) {
        return r.contains(t.ownerDocument, t) || t.getRootNode(se) === t.ownerDocument
    }
    );
    var He = function(t, n) {
        return (t = n || t).style.display === "none" || t.style.display === "" && Ae(t) && r.css(t, "display") === "none"
    };
    function si(o, t, n, s) {
        var u, h, f = 20, m = s ? function() {
            return s.cur()
        }
        : function() {
            return r.css(o, t, "")
        }
        , C = m(), b = n && n[3] || (r.cssNumber[t] ? "" : "px"), E = o.nodeType && (r.cssNumber[t] || b !== "px" && +C) && ge.exec(r.css(o, t));
        if (E && E[3] !== b) {
            for (C /= 2,
            b = b || E[3],
            E = +C || 1; f--; )
                r.style(o, t, E + b),
                (1 - h) * (1 - (h = m() / C || .5)) <= 0 && (f = 0),
                E /= h;
            E *= 2,
            r.style(o, t, E + b),
            n = n || []
        }
        return n && (E = +E || +C || 0,
        u = n[1] ? E + (n[1] + 1) * n[2] : +n[2],
        s && (s.unit = b,
        s.start = E,
        s.end = u)),
        u
    }
    var Ze = {};
    function Ne(o, t) {
        for (var n, s, u, h, f, m, C, b = [], E = 0, H = o.length; E < H; E++)
            (s = o[E]).style && (n = s.style.display,
            t ? (n === "none" && (b[E] = at.get(s, "display") || null,
            b[E] || (s.style.display = "")),
            s.style.display === "" && He(s) && (b[E] = (C = f = h = void 0,
            f = (u = s).ownerDocument,
            m = u.nodeName,
            (C = Ze[m]) || (h = f.body.appendChild(f.createElement(m)),
            C = r.css(h, "display"),
            h.parentNode.removeChild(h),
            C === "none" && (C = "block"),
            Ze[m] = C)))) : n !== "none" && (b[E] = "none",
            at.set(s, "display", n)));
        for (E = 0; E < H; E++)
            b[E] != null && (o[E].style.display = b[E]);
        return o
    }
    r.fn.extend({
        show: function() {
            return Ne(this, !0)
        },
        hide: function() {
            return Ne(this)
        },
        toggle: function(t) {
            return typeof t == "boolean" ? t ? this.show() : this.hide() : this.each(function() {
                He(this) ? r(this).show() : r(this).hide()
            })
        }
    });
    var Ee, Fe, ke = /^(?:checkbox|radio)$/i, Be = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i, _t = /^$|^module$|\/(?:java|ecma)script/i;
    Ee = j.createDocumentFragment().appendChild(j.createElement("div")),
    (Fe = j.createElement("input")).setAttribute("type", "radio"),
    Fe.setAttribute("checked", "checked"),
    Fe.setAttribute("name", "t"),
    Ee.appendChild(Fe),
    T.checkClone = Ee.cloneNode(!0).cloneNode(!0).lastChild.checked,
    Ee.innerHTML = "<textarea>x</textarea>",
    T.noCloneChecked = !!Ee.cloneNode(!0).lastChild.defaultValue,
    Ee.innerHTML = "<option></option>",
    T.option = !!Ee.lastChild;
    var lt = {
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
    };
    function bt(o, t) {
        var n;
        return n = typeof o.getElementsByTagName != "undefined" ? o.getElementsByTagName(t || "*") : typeof o.querySelectorAll != "undefined" ? o.querySelectorAll(t || "*") : [],
        t === void 0 || t && X(o, t) ? r.merge([o], n) : n
    }
    function Dt(o, t) {
        for (var n = 0, s = o.length; n < s; n++)
            at.set(o[n], "globalEval", !t || at.get(t[n], "globalEval"))
    }
    lt.tbody = lt.tfoot = lt.colgroup = lt.caption = lt.thead,
    lt.th = lt.td,
    T.option || (lt.optgroup = lt.option = [1, "<select multiple='multiple'>", "</select>"]);
    var Vt = /<|&#?\w+;/;
    function Ot(o, t, n, s, u) {
        for (var h, f, m, C, b, E, H = t.createDocumentFragment(), I = [], k = 0, M = o.length; k < M; k++)
            if ((h = o[k]) || h === 0)
                if (K(h) === "object")
                    r.merge(I, h.nodeType ? [h] : h);
                else if (Vt.test(h)) {
                    for (f = f || H.appendChild(t.createElement("div")),
                    m = (Be.exec(h) || ["", ""])[1].toLowerCase(),
                    C = lt[m] || lt._default,
                    f.innerHTML = C[1] + r.htmlPrefilter(h) + C[2],
                    E = C[0]; E--; )
                        f = f.lastChild;
                    r.merge(I, f.childNodes),
                    (f = H.firstChild).textContent = ""
                } else
                    I.push(t.createTextNode(h));
        for (H.textContent = "",
        k = 0; h = I[k++]; )
            if (s && -1 < r.inArray(h, s))
                u && u.push(h);
            else if (b = Ae(h),
            f = bt(H.appendChild(h), "script"),
            b && Dt(f),
            n)
                for (E = 0; h = f[E++]; )
                    _t.test(h.type || "") && n.push(h);
        return H
    }
    var ie = /^key/
      , _e = /^(?:mouse|pointer|contextmenu|drag|drop)|click/
      , de = /^([^.]*)(?:\.(.+)|)/;
    function re() {
        return !0
    }
    function Mt() {
        return !1
    }
    function gn(o, t) {
        return o === function() {
            try {
                return j.activeElement
            } catch (n) {}
        }() == (t === "focus")
    }
    function fi(o, t, n, s, u, h) {
        var f, m;
        if (_typeof(t) == "object") {
            for (m in typeof n != "string" && (s = s || n,
            n = void 0),
            t)
                fi(o, m, n, s, t[m], h);
            return o
        }
        if (s == null && u == null ? (u = n,
        s = n = void 0) : u == null && (typeof n == "string" ? (u = s,
        s = void 0) : (u = s,
        s = n,
        n = void 0)),
        u === !1)
            u = Mt;
        else if (!u)
            return o;
        return h === 1 && (f = u,
        (u = function(b) {
            return r().off(b),
            f.apply(this, arguments)
        }
        ).guid = f.guid || (f.guid = r.guid++)),
        o.each(function() {
            r.event.add(this, t, u, s, n)
        })
    }
    function oi(o, t, n) {
        n ? (at.set(o, t, !1),
        r.event.add(o, t, {
            namespace: !1,
            handler: function(u) {
                var h, f, m = at.get(this, t);
                if (1 & u.isTrigger && this[t]) {
                    if (m.length)
                        (r.event.special[t] || {}).delegateType && u.stopPropagation();
                    else if (m = w.call(arguments),
                    at.set(this, t, m),
                    h = n(this, t),
                    this[t](),
                    m !== (f = at.get(this, t)) || h ? at.set(this, t, !1) : f = {},
                    m !== f)
                        return u.stopImmediatePropagation(),
                        u.preventDefault(),
                        f.value
                } else
                    m.length && (at.set(this, t, {
                        value: r.event.trigger(r.extend(m[0], r.Event.prototype), m.slice(1), this)
                    }),
                    u.stopImmediatePropagation())
            }
        })) : at.get(o, t) === void 0 && r.event.add(o, t, re)
    }
    r.event = {
        global: {},
        add: function(t, n, s, u, h) {
            var f, m, C, b, E, H, I, k, M, rt, Z, At = at.get(t);
            if (ce(t))
                for (s.handler && (s = (f = s).handler,
                h = f.selector),
                h && r.find.matchesSelector($e, h),
                s.guid || (s.guid = r.guid++),
                (b = At.events) || (b = At.events = Object.create(null)),
                (m = At.handle) || (m = At.handle = function(ae) {
                    return typeof r != "undefined" && r.event.triggered !== ae.type ? r.event.dispatch.apply(t, arguments) : void 0
                }
                ),
                E = (n = (n || "").match(P) || [""]).length; E--; )
                    M = Z = (C = de.exec(n[E]) || [])[1],
                    rt = (C[2] || "").split(".").sort(),
                    M && (I = r.event.special[M] || {},
                    M = (h ? I.delegateType : I.bindType) || M,
                    I = r.event.special[M] || {},
                    H = r.extend({
                        type: M,
                        origType: Z,
                        data: u,
                        handler: s,
                        guid: s.guid,
                        selector: h,
                        needsContext: h && r.expr.match.needsContext.test(h),
                        namespace: rt.join(".")
                    }, f),
                    (k = b[M]) || ((k = b[M] = []).delegateCount = 0,
                    I.setup && I.setup.call(t, u, rt, m) !== !1 || t.addEventListener && t.addEventListener(M, m)),
                    I.add && (I.add.call(t, H),
                    H.handler.guid || (H.handler.guid = s.guid)),
                    h ? k.splice(k.delegateCount++, 0, H) : k.push(H),
                    r.event.global[M] = !0)
        },
        remove: function(t, n, s, u, h) {
            var f, m, C, b, E, H, I, k, M, rt, Z, At = at.hasData(t) && at.get(t);
            if (At && (b = At.events)) {
                for (E = (n = (n || "").match(P) || [""]).length; E--; )
                    if (M = Z = (C = de.exec(n[E]) || [])[1],
                    rt = (C[2] || "").split(".").sort(),
                    M) {
                        for (I = r.event.special[M] || {},
                        k = b[M = (u ? I.delegateType : I.bindType) || M] || [],
                        C = C[2] && new RegExp("(^|\\.)" + rt.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                        m = f = k.length; f--; )
                            H = k[f],
                            !h && Z !== H.origType || s && s.guid !== H.guid || C && !C.test(H.namespace) || u && u !== H.selector && (u !== "**" || !H.selector) || (k.splice(f, 1),
                            H.selector && k.delegateCount--,
                            I.remove && I.remove.call(t, H));
                        m && !k.length && (I.teardown && I.teardown.call(t, rt, At.handle) !== !1 || r.removeEvent(t, M, At.handle),
                        delete b[M])
                    } else
                        for (M in b)
                            r.event.remove(t, M + n[E], s, u, !0);
                r.isEmptyObject(b) && at.remove(t, "handle events")
            }
        },
        dispatch: function(t) {
            var n, s, u, h, f, m, C = new Array(arguments.length), b = r.event.fix(t), E = (at.get(this, "events") || Object.create(null))[b.type] || [], H = r.event.special[b.type] || {};
            for (C[0] = b,
            n = 1; n < arguments.length; n++)
                C[n] = arguments[n];
            if (b.delegateTarget = this,
            !H.preDispatch || H.preDispatch.call(this, b) !== !1) {
                for (m = r.event.handlers.call(this, b, E),
                n = 0; (h = m[n++]) && !b.isPropagationStopped(); )
                    for (b.currentTarget = h.elem,
                    s = 0; (f = h.handlers[s++]) && !b.isImmediatePropagationStopped(); )
                        b.rnamespace && f.namespace !== !1 && !b.rnamespace.test(f.namespace) || (b.handleObj = f,
                        b.data = f.data,
                        (u = ((r.event.special[f.origType] || {}).handle || f.handler).apply(h.elem, C)) !== void 0 && (b.result = u) === !1 && (b.preventDefault(),
                        b.stopPropagation()));
                return H.postDispatch && H.postDispatch.call(this, b),
                b.result
            }
        },
        handlers: function(t, n) {
            var s, u, h, f, m, C = [], b = n.delegateCount, E = t.target;
            if (b && E.nodeType && !(t.type === "click" && 1 <= t.button)) {
                for (; E !== this; E = E.parentNode || this)
                    if (E.nodeType === 1 && (t.type !== "click" || E.disabled !== !0)) {
                        for (f = [],
                        m = {},
                        s = 0; s < b; s++)
                            m[h = (u = n[s]).selector + " "] === void 0 && (m[h] = u.needsContext ? -1 < r(h, this).index(E) : r.find(h, this, null, [E]).length),
                            m[h] && f.push(u);
                        f.length && C.push({
                            elem: E,
                            handlers: f
                        })
                    }
            }
            return E = this,
            b < n.length && C.push({
                elem: E,
                handlers: n.slice(b)
            }),
            C
        },
        addProp: function(t, n) {
            Object.defineProperty(r.Event.prototype, t, {
                enumerable: !0,
                configurable: !0,
                get: y(n) ? function() {
                    if (this.originalEvent)
                        return n(this.originalEvent)
                }
                : function() {
                    if (this.originalEvent)
                        return this.originalEvent[t]
                }
                ,
                set: function(u) {
                    Object.defineProperty(this, t, {
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                        value: u
                    })
                }
            })
        },
        fix: function(t) {
            return t[r.expando] ? t : new r.Event(t)
        },
        special: {
            load: {
                noBubble: !0
            },
            click: {
                setup: function(t) {
                    var n = this || t;
                    return ke.test(n.type) && n.click && X(n, "input") && oi(n, "click", re),
                    !1
                },
                trigger: function(t) {
                    var n = this || t;
                    return ke.test(n.type) && n.click && X(n, "input") && oi(n, "click"),
                    !0
                },
                _default: function(t) {
                    var n = t.target;
                    return ke.test(n.type) && n.click && X(n, "input") && at.get(n, "click") || X(n, "a")
                }
            },
            beforeunload: {
                postDispatch: function(t) {
                    t.result !== void 0 && t.originalEvent && (t.originalEvent.returnValue = t.result)
                }
            }
        }
    },
    r.removeEvent = function(o, t, n) {
        o.removeEventListener && o.removeEventListener(t, n)
    }
    ,
    r.Event = function(o, t) {
        if (!(this instanceof r.Event))
            return new r.Event(o,t);
        o && o.type ? (this.originalEvent = o,
        this.type = o.type,
        this.isDefaultPrevented = o.defaultPrevented || o.defaultPrevented === void 0 && o.returnValue === !1 ? re : Mt,
        this.target = o.target && o.target.nodeType === 3 ? o.target.parentNode : o.target,
        this.currentTarget = o.currentTarget,
        this.relatedTarget = o.relatedTarget) : this.type = o,
        t && r.extend(this, t),
        this.timeStamp = o && o.timeStamp || Date.now(),
        this[r.expando] = !0
    }
    ,
    r.Event.prototype = {
        constructor: r.Event,
        isDefaultPrevented: Mt,
        isPropagationStopped: Mt,
        isImmediatePropagationStopped: Mt,
        isSimulated: !1,
        preventDefault: function() {
            var t = this.originalEvent;
            this.isDefaultPrevented = re,
            t && !this.isSimulated && t.preventDefault()
        },
        stopPropagation: function() {
            var t = this.originalEvent;
            this.isPropagationStopped = re,
            t && !this.isSimulated && t.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var t = this.originalEvent;
            this.isImmediatePropagationStopped = re,
            t && !this.isSimulated && t.stopImmediatePropagation(),
            this.stopPropagation()
        }
    },
    r.each({
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function(t) {
            var n = t.button;
            return t.which == null && ie.test(t.type) ? t.charCode != null ? t.charCode : t.keyCode : !t.which && n !== void 0 && _e.test(t.type) ? 1 & n ? 1 : 2 & n ? 3 : 4 & n ? 2 : 0 : t.which
        }
    }, r.event.addProp),
    r.each({
        focus: "focusin",
        blur: "focusout"
    }, function(o, t) {
        r.event.special[o] = {
            setup: function() {
                return oi(this, o, gn),
                !1
            },
            trigger: function() {
                return oi(this, o),
                !0
            },
            delegateType: t
        }
    }),
    r.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(o, t) {
        r.event.special[o] = {
            delegateType: t,
            bindType: t,
            handle: function(s) {
                var u, h = s.relatedTarget, f = s.handleObj;
                return h && (h === this || r.contains(this, h)) || (s.type = f.origType,
                u = f.handler.apply(this, arguments),
                s.type = t),
                u
            }
        }
    }),
    r.fn.extend({
        on: function(t, n, s, u) {
            return fi(this, t, n, s, u)
        },
        one: function(t, n, s, u) {
            return fi(this, t, n, s, u, 1)
        },
        off: function(t, n, s) {
            var u, h;
            if (t && t.preventDefault && t.handleObj)
                return u = t.handleObj,
                r(t.delegateTarget).off(u.namespace ? u.origType + "." + u.namespace : u.origType, u.selector, u.handler),
                this;
            if (_typeof(t) == "object") {
                for (h in t)
                    this.off(h, n, t[h]);
                return this
            }
            return n !== !1 && typeof n != "function" || (s = n,
            n = void 0),
            s === !1 && (s = Mt),
            this.each(function() {
                r.event.remove(this, t, s, n)
            })
        }
    });
    var mn = /<script|<style|<link/i
      , vn = /checked\s*(?:[^=]|=\s*.checked.)/i
      , yn = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    function Pi(o, t) {
        return X(o, "table") && X(t.nodeType !== 11 ? t : t.firstChild, "tr") && r(o).children("tbody")[0] || o
    }
    function wn(o) {
        return o.type = (o.getAttribute("type") !== null) + "/" + o.type,
        o
    }
    function xn(o) {
        return (o.type || "").slice(0, 5) === "true/" ? o.type = o.type.slice(5) : o.removeAttribute("type"),
        o
    }
    function Li(o, t) {
        var n, s, u, h, f, m;
        if (t.nodeType === 1) {
            if (at.hasData(o) && (m = at.get(o).events))
                for (u in at.remove(t, "handle events"),
                m)
                    for (n = 0,
                    s = m[u].length; n < s; n++)
                        r.event.add(t, u, m[u][n]);
            Xt.hasData(o) && (h = Xt.access(o),
            f = r.extend({}, h),
            Xt.set(t, f))
        }
    }
    function Ue(o, t, n, s) {
        t = e(t);
        var u, h, f, m, C, b, E = 0, H = o.length, I = H - 1, k = t[0], M = y(k);
        if (M || 1 < H && typeof k == "string" && !T.checkClone && vn.test(k))
            return o.each(function(rt) {
                var Z = o.eq(rt);
                M && (t[0] = k.call(this, rt, Z.html())),
                Ue(Z, t, n, s)
            });
        if (H && (h = (u = Ot(t, o[0].ownerDocument, !1, o, s)).firstChild,
        u.childNodes.length === 1 && (u = h),
        h || s)) {
            for (m = (f = r.map(bt(u, "script"), wn)).length; E < H; E++)
                C = u,
                E !== I && (C = r.clone(C, !0, !0),
                m && r.merge(f, bt(C, "script"))),
                n.call(o[E], C, E);
            if (m)
                for (b = f[f.length - 1].ownerDocument,
                r.map(f, xn),
                E = 0; E < m; E++)
                    C = f[E],
                    _t.test(C.type || "") && !at.access(C, "globalEval") && r.contains(b, C) && (C.src && (C.type || "").toLowerCase() !== "module" ? r._evalUrl && !C.noModule && r._evalUrl(C.src, {
                        nonce: C.nonce || C.getAttribute("nonce")
                    }, b) : W(C.textContent.replace(yn, ""), C, b))
        }
        return o
    }
    function Ni(o, t, n) {
        for (var s, u = t ? r.filter(t, o) : o, h = 0; (s = u[h]) != null; h++)
            n || s.nodeType !== 1 || r.cleanData(bt(s)),
            s.parentNode && (n && Ae(s) && Dt(bt(s, "script")),
            s.parentNode.removeChild(s));
        return o
    }
    r.extend({
        htmlPrefilter: function(t) {
            return t
        },
        clone: function(t, n, s) {
            var u, h, f, m, C, b, E, H = t.cloneNode(!0), I = Ae(t);
            if (!(T.noCloneChecked || t.nodeType !== 1 && t.nodeType !== 11 || r.isXMLDoc(t)))
                for (m = bt(H),
                u = 0,
                h = (f = bt(t)).length; u < h; u++)
                    C = f[u],
                    b = m[u],
                    (E = b.nodeName.toLowerCase()) === "input" && ke.test(C.type) ? b.checked = C.checked : E !== "input" && E !== "textarea" || (b.defaultValue = C.defaultValue);
            if (n)
                if (s)
                    for (f = f || bt(t),
                    m = m || bt(H),
                    u = 0,
                    h = f.length; u < h; u++)
                        Li(f[u], m[u]);
                else
                    Li(t, H);
            return 0 < (m = bt(H, "script")).length && Dt(m, !I && bt(t, "script")),
            H
        },
        cleanData: function(t) {
            for (var n, s, u, h = r.event.special, f = 0; (s = t[f]) !== void 0; f++)
                if (ce(s)) {
                    if (n = s[at.expando]) {
                        if (n.events)
                            for (u in n.events)
                                h[u] ? r.event.remove(s, u) : r.removeEvent(s, u, n.handle);
                        s[at.expando] = void 0
                    }
                    s[Xt.expando] && (s[Xt.expando] = void 0)
                }
        }
    }),
    r.fn.extend({
        detach: function(t) {
            return Ni(this, t, !0)
        },
        remove: function(t) {
            return Ni(this, t)
        },
        text: function(t) {
            return wt(this, function(n) {
                return n === void 0 ? r.text(this) : this.empty().each(function() {
                    this.nodeType !== 1 && this.nodeType !== 11 && this.nodeType !== 9 || (this.textContent = n)
                })
            }, null, t, arguments.length)
        },
        append: function() {
            return Ue(this, arguments, function(t) {
                this.nodeType !== 1 && this.nodeType !== 11 && this.nodeType !== 9 || Pi(this, t).appendChild(t)
            })
        },
        prepend: function() {
            return Ue(this, arguments, function(t) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var n = Pi(this, t);
                    n.insertBefore(t, n.firstChild)
                }
            })
        },
        before: function() {
            return Ue(this, arguments, function(t) {
                this.parentNode && this.parentNode.insertBefore(t, this)
            })
        },
        after: function() {
            return Ue(this, arguments, function(t) {
                this.parentNode && this.parentNode.insertBefore(t, this.nextSibling)
            })
        },
        empty: function() {
            for (var t, n = 0; (t = this[n]) != null; n++)
                t.nodeType === 1 && (r.cleanData(bt(t, !1)),
                t.textContent = "");
            return this
        },
        clone: function(t, n) {
            return t = t != null && t,
            n = n == null ? t : n,
            this.map(function() {
                return r.clone(this, t, n)
            })
        },
        html: function(t) {
            return wt(this, function(n) {
                var s = this[0] || {}
                  , u = 0
                  , h = this.length;
                if (n === void 0 && s.nodeType === 1)
                    return s.innerHTML;
                if (typeof n == "string" && !mn.test(n) && !lt[(Be.exec(n) || ["", ""])[1].toLowerCase()]) {
                    n = r.htmlPrefilter(n);
                    try {
                        for (; u < h; u++)
                            (s = this[u] || {}).nodeType === 1 && (r.cleanData(bt(s, !1)),
                            s.innerHTML = n);
                        s = 0
                    } catch (f) {}
                }
                s && this.empty().append(n)
            }, null, t, arguments.length)
        },
        replaceWith: function() {
            var t = [];
            return Ue(this, arguments, function(n) {
                var s = this.parentNode;
                r.inArray(this, t) < 0 && (r.cleanData(bt(this)),
                s && s.replaceChild(n, this))
            }, t)
        }
    }),
    r.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(o, t) {
        r.fn[o] = function(n) {
            for (var s, u = [], h = r(n), f = h.length - 1, m = 0; m <= f; m++)
                s = m === f ? this : this.clone(!0),
                r(h[m])[t](s),
                c.apply(u, s.get());
            return this.pushStack(u)
        }
    });
    var gi = new RegExp("^(" + oe + ")(?!px)[a-z%]+$","i")
      , ri = function(t) {
        var n = t.ownerDocument.defaultView;
        return n && n.opener || (n = xt),
        n.getComputedStyle(t)
    }
      , Oi = function(t, n, s) {
        var u, h, f = {};
        for (h in n)
            f[h] = t.style[h],
            t.style[h] = n[h];
        for (h in u = s.call(t),
        n)
            t.style[h] = f[h];
        return u
    }
      , bn = new RegExp(ue.join("|"),"i");
    function Je(o, t, n) {
        var s, u, h, f, m = o.style;
        return (n = n || ri(o)) && ((f = n.getPropertyValue(t) || n[t]) !== "" || Ae(o) || (f = r.style(o, t)),
        !T.pixelBoxStyles() && gi.test(f) && bn.test(t) && (s = m.width,
        u = m.minWidth,
        h = m.maxWidth,
        m.minWidth = m.maxWidth = m.width = f,
        f = n.width,
        m.width = s,
        m.minWidth = u,
        m.maxWidth = h)),
        f !== void 0 ? f + "" : f
    }
    function Mi(o, t) {
        return {
            get: function() {
                if (!o())
                    return (this.get = t).apply(this, arguments);
                delete this.get
            }
        }
    }
    (function() {
        function o() {
            if (b) {
                C.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",
                b.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",
                $e.appendChild(C).appendChild(b);
                var E = xt.getComputedStyle(b);
                n = E.top !== "1%",
                m = t(E.marginLeft) === 12,
                b.style.right = "60%",
                h = t(E.right) === 36,
                s = t(E.width) === 36,
                b.style.position = "absolute",
                u = t(b.offsetWidth / 3) === 12,
                $e.removeChild(C),
                b = null
            }
        }
        function t(E) {
            return Math.round(parseFloat(E))
        }
        var n, s, u, h, f, m, C = j.createElement("div"), b = j.createElement("div");
        b.style && (b.style.backgroundClip = "content-box",
        b.cloneNode(!0).style.backgroundClip = "",
        T.clearCloneStyle = b.style.backgroundClip === "content-box",
        r.extend(T, {
            boxSizingReliable: function() {
                return o(),
                s
            },
            pixelBoxStyles: function() {
                return o(),
                h
            },
            pixelPosition: function() {
                return o(),
                n
            },
            reliableMarginLeft: function() {
                return o(),
                m
            },
            scrollboxSize: function() {
                return o(),
                u
            },
            reliableTrDimensions: function() {
                var H, I, k, M;
                return f == null && (H = j.createElement("table"),
                I = j.createElement("tr"),
                k = j.createElement("div"),
                H.style.cssText = "position:absolute;left:-11111px",
                I.style.height = "1px",
                k.style.height = "9px",
                $e.appendChild(H).appendChild(I).appendChild(k),
                M = xt.getComputedStyle(I),
                f = 3 < parseInt(M.height),
                $e.removeChild(H)),
                f
            }
        }))
    }
    )();
    var Hi = ["Webkit", "Moz", "ms"]
      , qi = j.createElement("div").style
      , Ii = {};
    function mi(o) {
        var t = r.cssProps[o] || Ii[o];
        return t || (o in qi ? o : Ii[o] = function(n) {
            for (var s = n[0].toUpperCase() + n.slice(1), u = Hi.length; u--; )
                if ((n = Hi[u] + s)in qi)
                    return n
        }(o) || o)
    }
    var Tn = /^(none|table(?!-c[ea]).+)/
      , Ri = /^--/
      , Cn = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }
      , Wi = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function Fi(o, t, n) {
        var s = ge.exec(t);
        return s ? Math.max(0, s[2] - (n || 0)) + (s[3] || "px") : t
    }
    function vi(o, t, n, s, u, h) {
        var f = t === "width" ? 1 : 0
          , m = 0
          , C = 0;
        if (n === (s ? "border" : "content"))
            return 0;
        for (; f < 4; f += 2)
            n === "margin" && (C += r.css(o, n + ue[f], !0, u)),
            s ? (n === "content" && (C -= r.css(o, "padding" + ue[f], !0, u)),
            n !== "margin" && (C -= r.css(o, "border" + ue[f] + "Width", !0, u))) : (C += r.css(o, "padding" + ue[f], !0, u),
            n !== "padding" ? C += r.css(o, "border" + ue[f] + "Width", !0, u) : m += r.css(o, "border" + ue[f] + "Width", !0, u));
        return !s && 0 <= h && (C += Math.max(0, Math.ceil(o["offset" + t[0].toUpperCase() + t.slice(1)] - h - C - m - .5)) || 0),
        C
    }
    function Bi(o, t, n) {
        var s = ri(o)
          , u = (!T.boxSizingReliable() || n) && r.css(o, "boxSizing", !1, s) === "border-box"
          , h = u
          , f = Je(o, t, s)
          , m = "offset" + t[0].toUpperCase() + t.slice(1);
        if (gi.test(f)) {
            if (!n)
                return f;
            f = "auto"
        }
        return (!T.boxSizingReliable() && u || !T.reliableTrDimensions() && X(o, "tr") || f === "auto" || !parseFloat(f) && r.css(o, "display", !1, s) === "inline") && o.getClientRects().length && (u = r.css(o, "boxSizing", !1, s) === "border-box",
        (h = m in o) && (f = o[m])),
        (f = parseFloat(f) || 0) + vi(o, t, n || (u ? "border" : "content"), h, s, f) + "px"
    }
    function we(o, t, n, s, u) {
        return new we.prototype.init(o,t,n,s,u)
    }
    r.extend({
        cssHooks: {
            opacity: {
                get: function(t, n) {
                    if (n) {
                        var s = Je(t, "opacity");
                        return s === "" ? "1" : s
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            gridArea: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnStart: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowStart: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {},
        style: function(t, n, s, u) {
            if (t && t.nodeType !== 3 && t.nodeType !== 8 && t.style) {
                var h, f, m, C = jt(n), b = Ri.test(n), E = t.style;
                if (b || (n = mi(C)),
                m = r.cssHooks[n] || r.cssHooks[C],
                s === void 0)
                    return m && "get"in m && (h = m.get(t, !1, u)) !== void 0 ? h : E[n];
                (f = _typeof(s)) === "string" && (h = ge.exec(s)) && h[1] && (s = si(t, n, h),
                f = "number"),
                s != null && s == s && (f !== "number" || b || (s += h && h[3] || (r.cssNumber[C] ? "" : "px")),
                T.clearCloneStyle || s !== "" || n.indexOf("background") !== 0 || (E[n] = "inherit"),
                m && "set"in m && (s = m.set(t, s, u)) === void 0 || (b ? E.setProperty(n, s) : E[n] = s))
            }
        },
        css: function(t, n, s, u) {
            var h, f, m, C = jt(n);
            return Ri.test(n) || (n = mi(C)),
            (m = r.cssHooks[n] || r.cssHooks[C]) && "get"in m && (h = m.get(t, !0, s)),
            h === void 0 && (h = Je(t, n, u)),
            h === "normal" && n in Wi && (h = Wi[n]),
            s === "" || s ? (f = parseFloat(h),
            s === !0 || isFinite(f) ? f || 0 : h) : h
        }
    }),
    r.each(["height", "width"], function(o, t) {
        r.cssHooks[t] = {
            get: function(s, u, h) {
                if (u)
                    return !Tn.test(r.css(s, "display")) || s.getClientRects().length && s.getBoundingClientRect().width ? Bi(s, t, h) : Oi(s, Cn, function() {
                        return Bi(s, t, h)
                    })
            },
            set: function(s, u, h) {
                var f, m = ri(s), C = !T.scrollboxSize() && m.position === "absolute", b = (C || h) && r.css(s, "boxSizing", !1, m) === "border-box", E = h ? vi(s, t, h, b, m) : 0;
                return b && C && (E -= Math.ceil(s["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(m[t]) - vi(s, t, "border", !1, m) - .5)),
                E && (f = ge.exec(u)) && (f[3] || "px") !== "px" && (s.style[t] = u,
                u = r.css(s, t)),
                Fi(0, u, E)
            }
        }
    }),
    r.cssHooks.marginLeft = Mi(T.reliableMarginLeft, function(o, t) {
        if (t)
            return (parseFloat(Je(o, "marginLeft")) || o.getBoundingClientRect().left - Oi(o, {
                marginLeft: 0
            }, function() {
                return o.getBoundingClientRect().left
            })) + "px"
    }),
    r.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(o, t) {
        r.cssHooks[o + t] = {
            expand: function(s) {
                for (var u = 0, h = {}, f = typeof s == "string" ? s.split(" ") : [s]; u < 4; u++)
                    h[o + ue[u] + t] = f[u] || f[u - 2] || f[0];
                return h
            }
        },
        o !== "margin" && (r.cssHooks[o + t].set = Fi)
    }),
    r.fn.extend({
        css: function(t, n) {
            return wt(this, function(s, u, h) {
                var f, m, C = {}, b = 0;
                if (Array.isArray(u)) {
                    for (f = ri(s),
                    m = u.length; b < m; b++)
                        C[u[b]] = r.css(s, u[b], !1, f);
                    return C
                }
                return h !== void 0 ? r.style(s, u, h) : r.css(s, u)
            }, t, n, 1 < arguments.length)
        }
    }),
    ((r.Tween = we).prototype = {
        constructor: we,
        init: function(t, n, s, u, h, f) {
            this.elem = t,
            this.prop = s,
            this.easing = h || r.easing._default,
            this.options = n,
            this.start = this.now = this.cur(),
            this.end = u,
            this.unit = f || (r.cssNumber[s] ? "" : "px")
        },
        cur: function() {
            var t = we.propHooks[this.prop];
            return t && t.get ? t.get(this) : we.propHooks._default.get(this)
        },
        run: function(t) {
            var n, s = we.propHooks[this.prop];
            return this.options.duration ? this.pos = n = r.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration) : this.pos = n = t,
            this.now = (this.end - this.start) * n + this.start,
            this.options.step && this.options.step.call(this.elem, this.now, this),
            s && s.set ? s.set(this) : we.propHooks._default.set(this),
            this
        }
    }).init.prototype = we.prototype,
    (we.propHooks = {
        _default: {
            get: function(t) {
                var n;
                return t.elem.nodeType !== 1 || t.elem[t.prop] != null && t.elem.style[t.prop] == null ? t.elem[t.prop] : (n = r.css(t.elem, t.prop, "")) && n !== "auto" ? n : 0
            },
            set: function(t) {
                r.fx.step[t.prop] ? r.fx.step[t.prop](t) : t.elem.nodeType !== 1 || !r.cssHooks[t.prop] && t.elem.style[mi(t.prop)] == null ? t.elem[t.prop] = t.now : r.style(t.elem, t.prop, t.now + t.unit)
            }
        }
    }).scrollTop = we.propHooks.scrollLeft = {
        set: function(t) {
            t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now)
        }
    },
    r.easing = {
        linear: function(t) {
            return t
        },
        swing: function(t) {
            return .5 - Math.cos(t * Math.PI) / 2
        },
        _default: "swing"
    },
    r.fx = we.prototype.init,
    r.fx.step = {};
    var Xe, ai, Ve, Ui, Sn = /^(?:toggle|show|hide)$/, kn = /queueHooks$/;
    function yi() {
        ai && (j.hidden === !1 && xt.requestAnimationFrame ? xt.requestAnimationFrame(yi) : xt.setTimeout(yi, r.fx.interval),
        r.fx.tick())
    }
    function Xi() {
        return xt.setTimeout(function() {
            Xe = void 0
        }),
        Xe = Date.now()
    }
    function li(o, t) {
        var n, s = 0, u = {
            height: o
        };
        for (t = t ? 1 : 0; s < 4; s += 2 - t)
            u["margin" + (n = ue[s])] = u["padding" + n] = o;
        return t && (u.opacity = u.width = o),
        u
    }
    function Vi(o, t, n) {
        for (var s, u = (xe.tweeners[t] || []).concat(xe.tweeners["*"]), h = 0, f = u.length; h < f; h++)
            if (s = u[h].call(n, t, o))
                return s
    }
    function xe(o, t, n) {
        var s, u, h = 0, f = xe.prefilters.length, m = r.Deferred().always(function() {
            delete C.elem
        }), C = function() {
            if (u)
                return !1;
            for (var I = Xe || Xi(), k = Math.max(0, b.startTime + b.duration - I), M = 1 - (k / b.duration || 0), rt = 0, Z = b.tweens.length; rt < Z; rt++)
                b.tweens[rt].run(M);
            return m.notifyWith(o, [b, M, k]),
            M < 1 && Z ? k : (Z || m.notifyWith(o, [b, 1, 0]),
            m.resolveWith(o, [b]),
            !1)
        }, b = m.promise({
            elem: o,
            props: r.extend({}, t),
            opts: r.extend(!0, {
                specialEasing: {},
                easing: r.easing._default
            }, n),
            originalProperties: t,
            originalOptions: n,
            startTime: Xe || Xi(),
            duration: n.duration,
            tweens: [],
            createTween: function(I, k) {
                var M = r.Tween(o, b.opts, I, k, b.opts.specialEasing[I] || b.opts.easing);
                return b.tweens.push(M),
                M
            },
            stop: function(I) {
                var k = 0
                  , M = I ? b.tweens.length : 0;
                if (u)
                    return this;
                for (u = !0; k < M; k++)
                    b.tweens[k].run(1);
                return I ? (m.notifyWith(o, [b, 1, 0]),
                m.resolveWith(o, [b, I])) : m.rejectWith(o, [b, I]),
                this
            }
        }), E = b.props;
        for (!function(H, I) {
            var k, M, rt, Z, At;
            for (k in H)
                if (rt = I[M = jt(k)],
                Z = H[k],
                Array.isArray(Z) && (rt = Z[1],
                Z = H[k] = Z[0]),
                k !== M && (H[M] = Z,
                delete H[k]),
                (At = r.cssHooks[M]) && "expand"in At)
                    for (k in Z = At.expand(Z),
                    delete H[M],
                    Z)
                        k in H || (H[k] = Z[k],
                        I[k] = rt);
                else
                    I[M] = rt
        }(E, b.opts.specialEasing); h < f; h++)
            if (s = xe.prefilters[h].call(b, o, E, b.opts))
                return y(s.stop) && (r._queueHooks(b.elem, b.opts.queue).stop = s.stop.bind(s)),
                s;
        return r.map(E, Vi, b),
        y(b.opts.start) && b.opts.start.call(o, b),
        b.progress(b.opts.progress).done(b.opts.done, b.opts.complete).fail(b.opts.fail).always(b.opts.always),
        r.fx.timer(r.extend(C, {
            elem: o,
            anim: b,
            queue: b.opts.queue
        })),
        b
    }
    r.Animation = r.extend(xe, {
        tweeners: {
            "*": [function(o, t) {
                var n = this.createTween(o, t);
                return si(n.elem, o, ge.exec(t), n),
                n
            }
            ]
        },
        tweener: function(t, n) {
            y(t) ? (n = t,
            t = ["*"]) : t = t.match(P);
            for (var s, u = 0, h = t.length; u < h; u++)
                s = t[u],
                xe.tweeners[s] = xe.tweeners[s] || [],
                xe.tweeners[s].unshift(n)
        },
        prefilters: [function(o, t, n) {
            var s, u, h, f, m, C, b, E, H = "width"in t || "height"in t, I = this, k = {}, M = o.style, rt = o.nodeType && He(o), Z = at.get(o, "fxshow");
            for (s in n.queue || ((f = r._queueHooks(o, "fx")).unqueued == null && (f.unqueued = 0,
            m = f.empty.fire,
            f.empty.fire = function() {
                f.unqueued || m()
            }
            ),
            f.unqueued++,
            I.always(function() {
                I.always(function() {
                    f.unqueued--,
                    r.queue(o, "fx").length || f.empty.fire()
                })
            })),
            t)
                if (u = t[s],
                Sn.test(u)) {
                    if (delete t[s],
                    h = h || u === "toggle",
                    u === (rt ? "hide" : "show")) {
                        if (u !== "show" || !Z || Z[s] === void 0)
                            continue;
                        rt = !0
                    }
                    k[s] = Z && Z[s] || r.style(o, s)
                }
            if ((C = !r.isEmptyObject(t)) || !r.isEmptyObject(k))
                for (s in H && o.nodeType === 1 && (n.overflow = [M.overflow, M.overflowX, M.overflowY],
                (b = Z && Z.display) == null && (b = at.get(o, "display")),
                (E = r.css(o, "display")) === "none" && (b ? E = b : (Ne([o], !0),
                b = o.style.display || b,
                E = r.css(o, "display"),
                Ne([o]))),
                (E === "inline" || E === "inline-block" && b != null) && r.css(o, "float") === "none" && (C || (I.done(function() {
                    M.display = b
                }),
                b == null && (E = M.display,
                b = E === "none" ? "" : E)),
                M.display = "inline-block")),
                n.overflow && (M.overflow = "hidden",
                I.always(function() {
                    M.overflow = n.overflow[0],
                    M.overflowX = n.overflow[1],
                    M.overflowY = n.overflow[2]
                })),
                C = !1,
                k)
                    C || (Z ? "hidden"in Z && (rt = Z.hidden) : Z = at.access(o, "fxshow", {
                        display: b
                    }),
                    h && (Z.hidden = !rt),
                    rt && Ne([o], !0),
                    I.done(function() {
                        for (s in rt || Ne([o]),
                        at.remove(o, "fxshow"),
                        k)
                            r.style(o, s, k[s])
                    })),
                    C = Vi(rt ? Z[s] : 0, s, I),
                    s in Z || (Z[s] = C.start,
                    rt && (C.end = C.start,
                    C.start = 0))
        }
        ],
        prefilter: function(t, n) {
            n ? xe.prefilters.unshift(t) : xe.prefilters.push(t)
        }
    }),
    r.speed = function(o, t, n) {
        var s = o && _typeof(o) == "object" ? r.extend({}, o) : {
            complete: n || !n && t || y(o) && o,
            duration: o,
            easing: n && t || t && !y(t) && t
        };
        return r.fx.off ? s.duration = 0 : typeof s.duration != "number" && (s.duration in r.fx.speeds ? s.duration = r.fx.speeds[s.duration] : s.duration = r.fx.speeds._default),
        s.queue != null && s.queue !== !0 || (s.queue = "fx"),
        s.old = s.complete,
        s.complete = function() {
            y(s.old) && s.old.call(this),
            s.queue && r.dequeue(this, s.queue)
        }
        ,
        s
    }
    ,
    r.fn.extend({
        fadeTo: function(t, n, s, u) {
            return this.filter(He).css("opacity", 0).show().end().animate({
                opacity: n
            }, t, s, u)
        },
        animate: function(t, n, s, u) {
            var h = r.isEmptyObject(t)
              , f = r.speed(n, s, u)
              , m = function() {
                var b = xe(this, r.extend({}, t), f);
                (h || at.get(this, "finish")) && b.stop(!0)
            };
            return m.finish = m,
            h || f.queue === !1 ? this.each(m) : this.queue(f.queue, m)
        },
        stop: function(t, n, s) {
            var u = function(f) {
                var m = f.stop;
                delete f.stop,
                m(s)
            };
            return typeof t != "string" && (s = n,
            n = t,
            t = void 0),
            n && this.queue(t || "fx", []),
            this.each(function() {
                var h = !0
                  , f = t != null && t + "queueHooks"
                  , m = r.timers
                  , C = at.get(this);
                if (f)
                    C[f] && C[f].stop && u(C[f]);
                else
                    for (f in C)
                        C[f] && C[f].stop && kn.test(f) && u(C[f]);
                for (f = m.length; f--; )
                    m[f].elem !== this || t != null && m[f].queue !== t || (m[f].anim.stop(s),
                    h = !1,
                    m.splice(f, 1));
                !h && s || r.dequeue(this, t)
            })
        },
        finish: function(t) {
            return t !== !1 && (t = t || "fx"),
            this.each(function() {
                var n, s = at.get(this), u = s[t + "queue"], h = s[t + "queueHooks"], f = r.timers, m = u ? u.length : 0;
                for (s.finish = !0,
                r.queue(this, t, []),
                h && h.stop && h.stop.call(this, !0),
                n = f.length; n--; )
                    f[n].elem === this && f[n].queue === t && (f[n].anim.stop(!0),
                    f.splice(n, 1));
                for (n = 0; n < m; n++)
                    u[n] && u[n].finish && u[n].finish.call(this);
                delete s.finish
            })
        }
    }),
    r.each(["toggle", "show", "hide"], function(o, t) {
        var n = r.fn[t];
        r.fn[t] = function(s, u, h) {
            return s == null || typeof s == "boolean" ? n.apply(this, arguments) : this.animate(li(t, !0), s, u, h)
        }
    }),
    r.each({
        slideDown: li("show"),
        slideUp: li("hide"),
        slideToggle: li("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(o, t) {
        r.fn[o] = function(n, s, u) {
            return this.animate(t, n, s, u)
        }
    }),
    r.timers = [],
    r.fx.tick = function() {
        var o, t = 0, n = r.timers;
        for (Xe = Date.now(); t < n.length; t++)
            (o = n[t])() || n[t] !== o || n.splice(t--, 1);
        n.length || r.fx.stop(),
        Xe = void 0
    }
    ,
    r.fx.timer = function(o) {
        r.timers.push(o),
        r.fx.start()
    }
    ,
    r.fx.interval = 13,
    r.fx.start = function() {
        ai || (ai = !0,
        yi())
    }
    ,
    r.fx.stop = function() {
        ai = null
    }
    ,
    r.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    },
    r.fn.delay = function(o, t) {
        return o = r.fx && r.fx.speeds[o] || o,
        t = t || "fx",
        this.queue(t, function(n, s) {
            var u = xt.setTimeout(n, o);
            s.stop = function() {
                xt.clearTimeout(u)
            }
        })
    }
    ,
    Ve = j.createElement("input"),
    Ui = j.createElement("select").appendChild(j.createElement("option")),
    Ve.type = "checkbox",
    T.checkOn = Ve.value !== "",
    T.optSelected = Ui.selected,
    (Ve = j.createElement("input")).value = "t",
    Ve.type = "radio",
    T.radioValue = Ve.value === "t";
    var Qi, Ke = r.expr.attrHandle;
    r.fn.extend({
        attr: function(t, n) {
            return wt(this, r.attr, t, n, 1 < arguments.length)
        },
        removeAttr: function(t) {
            return this.each(function() {
                r.removeAttr(this, t)
            })
        }
    }),
    r.extend({
        attr: function(t, n, s) {
            var u, h, f = t.nodeType;
            if (f !== 3 && f !== 8 && f !== 2)
                return typeof t.getAttribute == "undefined" ? r.prop(t, n, s) : (f === 1 && r.isXMLDoc(t) || (h = r.attrHooks[n.toLowerCase()] || (r.expr.match.bool.test(n) ? Qi : void 0)),
                s !== void 0 ? s === null ? void r.removeAttr(t, n) : h && "set"in h && (u = h.set(t, s, n)) !== void 0 ? u : (t.setAttribute(n, s + ""),
                s) : h && "get"in h && (u = h.get(t, n)) !== null ? u : (u = r.find.attr(t, n)) == null ? void 0 : u)
        },
        attrHooks: {
            type: {
                set: function(t, n) {
                    if (!T.radioValue && n === "radio" && X(t, "input")) {
                        var s = t.value;
                        return t.setAttribute("type", n),
                        s && (t.value = s),
                        n
                    }
                }
            }
        },
        removeAttr: function(t, n) {
            var s, u = 0, h = n && n.match(P);
            if (h && t.nodeType === 1)
                for (; s = h[u++]; )
                    t.removeAttribute(s)
        }
    }),
    Qi = {
        set: function(t, n, s) {
            return n === !1 ? r.removeAttr(t, s) : t.setAttribute(s, s),
            s
        }
    },
    r.each(r.expr.match.bool.source.match(/\w+/g), function(o, t) {
        var n = Ke[t] || r.find.attr;
        Ke[t] = function(s, u, h) {
            var f, m, C = u.toLowerCase();
            return h || (m = Ke[C],
            Ke[C] = f,
            f = n(s, u, h) != null ? C : null,
            Ke[C] = m),
            f
        }
    });
    var _n = /^(?:input|select|textarea|button)$/i
      , zn = /^(?:a|area)$/i;
    function qe(o) {
        return (o.match(P) || []).join(" ")
    }
    function Ie(o) {
        return o.getAttribute && o.getAttribute("class") || ""
    }
    function wi(o) {
        return Array.isArray(o) ? o : typeof o == "string" && o.match(P) || []
    }
    r.fn.extend({
        prop: function(t, n) {
            return wt(this, r.prop, t, n, 1 < arguments.length)
        },
        removeProp: function(t) {
            return this.each(function() {
                delete this[r.propFix[t] || t]
            })
        }
    }),
    r.extend({
        prop: function(t, n, s) {
            var u, h, f = t.nodeType;
            if (f !== 3 && f !== 8 && f !== 2)
                return f === 1 && r.isXMLDoc(t) || (n = r.propFix[n] || n,
                h = r.propHooks[n]),
                s !== void 0 ? h && "set"in h && (u = h.set(t, s, n)) !== void 0 ? u : t[n] = s : h && "get"in h && (u = h.get(t, n)) !== null ? u : t[n]
        },
        propHooks: {
            tabIndex: {
                get: function(t) {
                    var n = r.find.attr(t, "tabindex");
                    return n ? parseInt(n, 10) : _n.test(t.nodeName) || zn.test(t.nodeName) && t.href ? 0 : -1
                }
            }
        },
        propFix: {
            for: "htmlFor",
            class: "className"
        }
    }),
    T.optSelected || (r.propHooks.selected = {
        get: function(t) {
            var n = t.parentNode;
            return n && n.parentNode && n.parentNode.selectedIndex,
            null
        },
        set: function(t) {
            var n = t.parentNode;
            n && (n.selectedIndex,
            n.parentNode && n.parentNode.selectedIndex)
        }
    }),
    r.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        r.propFix[this.toLowerCase()] = this
    }),
    r.fn.extend({
        addClass: function(t) {
            var n, s, u, h, f, m, C, b = 0;
            if (y(t))
                return this.each(function(E) {
                    r(this).addClass(t.call(this, E, Ie(this)))
                });
            if ((n = wi(t)).length) {
                for (; s = this[b++]; )
                    if (h = Ie(s),
                    u = s.nodeType === 1 && " " + qe(h) + " ") {
                        for (m = 0; f = n[m++]; )
                            u.indexOf(" " + f + " ") < 0 && (u += f + " ");
                        h !== (C = qe(u)) && s.setAttribute("class", C)
                    }
            }
            return this
        },
        removeClass: function(t) {
            var n, s, u, h, f, m, C, b = 0;
            if (y(t))
                return this.each(function(E) {
                    r(this).removeClass(t.call(this, E, Ie(this)))
                });
            if (!arguments.length)
                return this.attr("class", "");
            if ((n = wi(t)).length) {
                for (; s = this[b++]; )
                    if (h = Ie(s),
                    u = s.nodeType === 1 && " " + qe(h) + " ") {
                        for (m = 0; f = n[m++]; )
                            for (; -1 < u.indexOf(" " + f + " "); )
                                u = u.replace(" " + f + " ", " ");
                        h !== (C = qe(u)) && s.setAttribute("class", C)
                    }
            }
            return this
        },
        toggleClass: function(t, n) {
            var s = _typeof(t)
              , u = s === "string" || Array.isArray(t);
            return typeof n == "boolean" && u ? n ? this.addClass(t) : this.removeClass(t) : y(t) ? this.each(function(h) {
                r(this).toggleClass(t.call(this, h, Ie(this), n), n)
            }) : this.each(function() {
                var h, f, m, C;
                if (u)
                    for (f = 0,
                    m = r(this),
                    C = wi(t); h = C[f++]; )
                        m.hasClass(h) ? m.removeClass(h) : m.addClass(h);
                else
                    t !== void 0 && s !== "boolean" || ((h = Ie(this)) && at.set(this, "__className__", h),
                    this.setAttribute && this.setAttribute("class", h || t === !1 ? "" : at.get(this, "__className__") || ""))
            })
        },
        hasClass: function(t) {
            var n, s, u = 0;
            for (n = " " + t + " "; s = this[u++]; )
                if (s.nodeType === 1 && -1 < (" " + qe(Ie(s)) + " ").indexOf(n))
                    return !0;
            return !1
        }
    });
    var $n = /\r/g;
    r.fn.extend({
        val: function(t) {
            var n, s, u, h = this[0];
            return arguments.length ? (u = y(t),
            this.each(function(f) {
                var m;
                this.nodeType === 1 && ((m = u ? t.call(this, f, r(this).val()) : t) == null ? m = "" : typeof m == "number" ? m += "" : Array.isArray(m) && (m = r.map(m, function(C) {
                    return C == null ? "" : C + ""
                })),
                (n = r.valHooks[this.type] || r.valHooks[this.nodeName.toLowerCase()]) && "set"in n && n.set(this, m, "value") !== void 0 || (this.value = m))
            })) : h ? (n = r.valHooks[h.type] || r.valHooks[h.nodeName.toLowerCase()]) && "get"in n && (s = n.get(h, "value")) !== void 0 ? s : typeof (s = h.value) == "string" ? s.replace($n, "") : s == null ? "" : s : void 0
        }
    }),
    r.extend({
        valHooks: {
            option: {
                get: function(t) {
                    var n = r.find.attr(t, "value");
                    return n != null ? n : qe(r.text(t))
                }
            },
            select: {
                get: function(t) {
                    var n, s, u, h = t.options, f = t.selectedIndex, m = t.type === "select-one", C = m ? null : [], b = m ? f + 1 : h.length;
                    for (u = f < 0 ? b : m ? f : 0; u < b; u++)
                        if (((s = h[u]).selected || u === f) && !s.disabled && (!s.parentNode.disabled || !X(s.parentNode, "optgroup"))) {
                            if (n = r(s).val(),
                            m)
                                return n;
                            C.push(n)
                        }
                    return C
                },
                set: function(t, n) {
                    for (var s, u, h = t.options, f = r.makeArray(n), m = h.length; m--; )
                        ((u = h[m]).selected = -1 < r.inArray(r.valHooks.option.get(u), f)) && (s = !0);
                    return s || (t.selectedIndex = -1),
                    f
                }
            }
        }
    }),
    r.each(["radio", "checkbox"], function() {
        r.valHooks[this] = {
            set: function(t, n) {
                if (Array.isArray(n))
                    return t.checked = -1 < r.inArray(r(t).val(), n)
            }
        },
        T.checkOn || (r.valHooks[this].get = function(o) {
            return o.getAttribute("value") === null ? "on" : o.value
        }
        )
    }),
    T.focusin = "onfocusin"in xt;
    var Yi = /^(?:focusinfocus|focusoutblur)$/
      , Gi = function(t) {
        t.stopPropagation()
    };
    r.extend(r.event, {
        trigger: function(t, n, s, u) {
            var h, f, m, C, b, E, H, I, k = [s || j], M = a.call(t, "type") ? t.type : t, rt = a.call(t, "namespace") ? t.namespace.split(".") : [];
            if (f = I = m = s = s || j,
            s.nodeType !== 3 && s.nodeType !== 8 && !Yi.test(M + r.event.triggered) && (-1 < M.indexOf(".") && (M = (rt = M.split(".")).shift(),
            rt.sort()),
            b = M.indexOf(":") < 0 && "on" + M,
            (t = t[r.expando] ? t : new r.Event(M,_typeof(t) == "object" && t)).isTrigger = u ? 2 : 3,
            t.namespace = rt.join("."),
            t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + rt.join("\\.(?:.*\\.|)") + "(\\.|$)") : null,
            t.result = void 0,
            t.target || (t.target = s),
            n = n == null ? [t] : r.makeArray(n, [t]),
            H = r.event.special[M] || {},
            u || !H.trigger || H.trigger.apply(s, n) !== !1)) {
                if (!u && !H.noBubble && !A(s)) {
                    for (C = H.delegateType || M,
                    Yi.test(C + M) || (f = f.parentNode); f; f = f.parentNode)
                        k.push(f),
                        m = f;
                    m === (s.ownerDocument || j) && k.push(m.defaultView || m.parentWindow || xt)
                }
                for (h = 0; (f = k[h++]) && !t.isPropagationStopped(); )
                    I = f,
                    t.type = 1 < h ? C : H.bindType || M,
                    (E = (at.get(f, "events") || Object.create(null))[t.type] && at.get(f, "handle")) && E.apply(f, n),
                    (E = b && f[b]) && E.apply && ce(f) && (t.result = E.apply(f, n),
                    t.result === !1 && t.preventDefault());
                return t.type = M,
                u || t.isDefaultPrevented() || H._default && H._default.apply(k.pop(), n) !== !1 || !ce(s) || b && y(s[M]) && !A(s) && ((m = s[b]) && (s[b] = null),
                r.event.triggered = M,
                t.isPropagationStopped() && I.addEventListener(M, Gi),
                s[M](),
                t.isPropagationStopped() && I.removeEventListener(M, Gi),
                r.event.triggered = void 0,
                m && (s[b] = m)),
                t.result
            }
        },
        simulate: function(t, n, s) {
            var u = r.extend(new r.Event, s, {
                type: t,
                isSimulated: !0
            });
            r.event.trigger(u, null, n)
        }
    }),
    r.fn.extend({
        trigger: function(t, n) {
            return this.each(function() {
                r.event.trigger(t, n, this)
            })
        },
        triggerHandler: function(t, n) {
            var s = this[0];
            if (s)
                return r.event.trigger(t, n, s, !0)
        }
    }),
    T.focusin || r.each({
        focus: "focusin",
        blur: "focusout"
    }, function(o, t) {
        var n = function(u) {
            r.event.simulate(t, u.target, r.event.fix(u))
        };
        r.event.special[t] = {
            setup: function() {
                var u = this.ownerDocument || this.document || this
                  , h = at.access(u, t);
                h || u.addEventListener(o, n, !0),
                at.access(u, t, (h || 0) + 1)
            },
            teardown: function() {
                var u = this.ownerDocument || this.document || this
                  , h = at.access(u, t) - 1;
                h ? at.access(u, t, h) : (u.removeEventListener(o, n, !0),
                at.remove(u, t))
            }
        }
    });
    var ti = xt.location
      , Zi = {
        guid: Date.now()
    }
      , xi = /\?/;
    r.parseXML = function(o) {
        var t;
        if (!o || typeof o != "string")
            return null;
        try {
            t = new xt.DOMParser().parseFromString(o, "text/xml")
        } catch (n) {
            t = void 0
        }
        return t && !t.getElementsByTagName("parsererror").length || r.error("Invalid XML: " + o),
        t
    }
    ;
    var An = /\[\]$/
      , Ji = /\r?\n/g
      , En = /^(?:submit|button|image|reset|file)$/i
      , jn = /^(?:input|select|textarea|keygen)/i;
    function bi(o, t, n, s) {
        var u;
        if (Array.isArray(t))
            r.each(t, function(h, f) {
                n || An.test(o) ? s(o, f) : bi(o + "[" + (_typeof(f) == "object" && f != null ? h : "") + "]", f, n, s)
            });
        else if (n || K(t) !== "object")
            s(o, t);
        else
            for (u in t)
                bi(o + "[" + u + "]", t[u], n, s)
    }
    r.param = function(o, t) {
        var n, s = [], u = function(f, m) {
            var C = y(m) ? m() : m;
            s[s.length] = encodeURIComponent(f) + "=" + encodeURIComponent(C == null ? "" : C)
        };
        if (o == null)
            return "";
        if (Array.isArray(o) || o.jquery && !r.isPlainObject(o))
            r.each(o, function() {
                u(this.name, this.value)
            });
        else
            for (n in o)
                bi(n, o[n], t, u);
        return s.join("&")
    }
    ,
    r.fn.extend({
        serialize: function() {
            return r.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var t = r.prop(this, "elements");
                return t ? r.makeArray(t) : this
            }).filter(function() {
                var t = this.type;
                return this.name && !r(this).is(":disabled") && jn.test(this.nodeName) && !En.test(t) && (this.checked || !ke.test(t))
            }).map(function(t, n) {
                var s = r(this).val();
                return s == null ? null : Array.isArray(s) ? r.map(s, function(u) {
                    return {
                        name: n.name,
                        value: u.replace(Ji, "\r\n")
                    }
                }) : {
                    name: n.name,
                    value: s.replace(Ji, "\r\n")
                }
            }).get()
        }
    });
    var Dn = /%20/g
      , Pn = /#.*$/
      , Ln = /([?&])_=[^&]*/
      , Nn = /^(.*?):[ \t]*([^\r\n]*)$/gm
      , On = /^(?:GET|HEAD)$/
      , Mn = /^\/\//
      , Ki = {}
      , Ti = {}
      , tn = "*/".concat("*")
      , Ci = j.createElement("a");
    function en(o) {
        return function(t, n) {
            typeof t != "string" && (n = t,
            t = "*");
            var s, u = 0, h = t.toLowerCase().match(P) || [];
            if (y(n))
                for (; s = h[u++]; )
                    s[0] === "+" ? (s = s.slice(1) || "*",
                    (o[s] = o[s] || []).unshift(n)) : (o[s] = o[s] || []).push(n)
        }
    }
    function nn(o, t, n, s) {
        var u = {}
          , h = o === Ti;
        function f(m) {
            var C;
            return u[m] = !0,
            r.each(o[m] || [], function(b, E) {
                var H = E(t, n, s);
                return typeof H != "string" || h || u[H] ? h ? !(C = H) : void 0 : (t.dataTypes.unshift(H),
                f(H),
                !1)
            }),
            C
        }
        return f(t.dataTypes[0]) || !u["*"] && f("*")
    }
    function Si(o, t) {
        var n, s, u = r.ajaxSettings.flatOptions || {};
        for (n in t)
            t[n] !== void 0 && ((u[n] ? o : s || (s = {}))[n] = t[n]);
        return s && r.extend(!0, o, s),
        o
    }
    Ci.href = ti.href,
    r.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: ti.href,
            type: "GET",
            isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(ti.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": tn,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": JSON.parse,
                "text xml": r.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(t, n) {
            return n ? Si(Si(t, r.ajaxSettings), n) : Si(r.ajaxSettings, t)
        },
        ajaxPrefilter: en(Ki),
        ajaxTransport: en(Ti),
        ajax: function(t, n) {
            _typeof(t) == "object" && (n = t,
            t = void 0),
            n = n || {};
            var s, u, h, f, m, C, b, E, H, I, k = r.ajaxSetup({}, n), M = k.context || k, rt = k.context && (M.nodeType || M.jquery) ? r(M) : r.event, Z = r.Deferred(), At = r.Callbacks("once memory"), ae = k.statusCode || {}, pe = {}, $t = {}, Ht = "canceled", vt = {
                readyState: 0,
                getResponseHeader: function(Wt) {
                    var It;
                    if (b) {
                        if (!f)
                            for (f = {}; It = Nn.exec(h); )
                                f[It[1].toLowerCase() + " "] = (f[It[1].toLowerCase() + " "] || []).concat(It[2]);
                        It = f[Wt.toLowerCase() + " "]
                    }
                    return It == null ? null : It.join(", ")
                },
                getAllResponseHeaders: function() {
                    return b ? h : null
                },
                setRequestHeader: function(Wt, It) {
                    return b == null && (Wt = $t[Wt.toLowerCase()] = $t[Wt.toLowerCase()] || Wt,
                    pe[Wt] = It),
                    this
                },
                overrideMimeType: function(Wt) {
                    return b == null && (k.mimeType = Wt),
                    this
                },
                statusCode: function(Wt) {
                    var It;
                    if (Wt)
                        if (b)
                            vt.always(Wt[vt.status]);
                        else
                            for (It in Wt)
                                ae[It] = [ae[It], Wt[It]];
                    return this
                },
                abort: function(Wt) {
                    var It = Wt || Ht;
                    return s && s.abort(It),
                    Qe(0, It),
                    this
                }
            };
            if (Z.promise(vt),
            k.url = ((t || k.url || ti.href) + "").replace(Mn, ti.protocol + "//"),
            k.type = n.method || n.type || k.method || k.type,
            k.dataTypes = (k.dataType || "*").toLowerCase().match(P) || [""],
            k.crossDomain == null) {
                C = j.createElement("a");
                try {
                    C.href = k.url,
                    C.href = C.href,
                    k.crossDomain = Ci.protocol + "//" + Ci.host != C.protocol + "//" + C.host
                } catch (qt) {
                    k.crossDomain = !0
                }
            }
            if (k.data && k.processData && typeof k.data != "string" && (k.data = r.param(k.data, k.traditional)),
            nn(Ki, k, n, vt),
            b)
                return vt;
            for (H in (E = r.event && k.global) && r.active++ == 0 && r.event.trigger("ajaxStart"),
            k.type = k.type.toUpperCase(),
            k.hasContent = !On.test(k.type),
            u = k.url.replace(Pn, ""),
            k.hasContent ? k.data && k.processData && (k.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && (k.data = k.data.replace(Dn, "+")) : (I = k.url.slice(u.length),
            k.data && (k.processData || typeof k.data == "string") && (u += (xi.test(u) ? "&" : "?") + k.data,
            delete k.data),
            k.cache === !1 && (u = u.replace(Ln, "$1"),
            I = (xi.test(u) ? "&" : "?") + "_=" + Zi.guid++ + I),
            k.url = u + I),
            k.ifModified && (r.lastModified[u] && vt.setRequestHeader("If-Modified-Since", r.lastModified[u]),
            r.etag[u] && vt.setRequestHeader("If-None-Match", r.etag[u])),
            (k.data && k.hasContent && k.contentType !== !1 || n.contentType) && vt.setRequestHeader("Content-Type", k.contentType),
            vt.setRequestHeader("Accept", k.dataTypes[0] && k.accepts[k.dataTypes[0]] ? k.accepts[k.dataTypes[0]] + (k.dataTypes[0] !== "*" ? ", " + tn + "; q=0.01" : "") : k.accepts["*"]),
            k.headers)
                vt.setRequestHeader(H, k.headers[H]);
            if (k.beforeSend && (k.beforeSend.call(M, vt, k) === !1 || b))
                return vt.abort();
            if (Ht = "abort",
            At.add(k.complete),
            vt.done(k.success),
            vt.fail(k.error),
            s = nn(Ti, k, n, vt)) {
                if (vt.readyState = 1,
                E && rt.trigger("ajaxSend", [vt, k]),
                b)
                    return vt;
                k.async && 0 < k.timeout && (m = xt.setTimeout(function() {
                    vt.abort("timeout")
                }, k.timeout));
                try {
                    b = !1,
                    s.send(pe, Qe)
                } catch (qt) {
                    if (b)
                        throw qt;
                    Qe(-1, qt)
                }
            } else
                Qe(-1, "No Transport");
            function Qe(qt, Wt, It, Ye) {
                var me, ii, ve, Oe, Ge, Gt = Wt;
                b || (b = !0,
                m && xt.clearTimeout(m),
                s = void 0,
                h = Ye || "",
                vt.readyState = 0 < qt ? 4 : 0,
                me = 200 <= qt && qt < 300 || qt === 304,
                It && (Oe = function(te, Kt, je) {
                    for (var Ct, Ft, Pt, Qt, be = te.contents, Rt = te.dataTypes; Rt[0] === "*"; )
                        Rt.shift(),
                        Ct === void 0 && (Ct = te.mimeType || Kt.getResponseHeader("Content-Type"));
                    if (Ct) {
                        for (Ft in be)
                            if (be[Ft] && be[Ft].test(Ct)) {
                                Rt.unshift(Ft);
                                break
                            }
                    }
                    if (Rt[0]in je)
                        Pt = Rt[0];
                    else {
                        for (Ft in je) {
                            if (!Rt[0] || te.converters[Ft + " " + Rt[0]]) {
                                Pt = Ft;
                                break
                            }
                            Qt || (Qt = Ft)
                        }
                        Pt = Pt || Qt
                    }
                    if (Pt)
                        return Pt !== Rt[0] && Rt.unshift(Pt),
                        je[Pt]
                }(k, vt, It)),
                !me && -1 < r.inArray("script", k.dataTypes) && (k.converters["text script"] = function() {}
                ),
                Oe = function(te, Kt, je, Ct) {
                    var Ft, Pt, Qt, be, Rt, ze = {}, Re = te.dataTypes.slice();
                    if (Re[1])
                        for (Qt in te.converters)
                            ze[Qt.toLowerCase()] = te.converters[Qt];
                    for (Pt = Re.shift(); Pt; )
                        if (te.responseFields[Pt] && (je[te.responseFields[Pt]] = Kt),
                        !Rt && Ct && te.dataFilter && (Kt = te.dataFilter(Kt, te.dataType)),
                        Rt = Pt,
                        Pt = Re.shift()) {
                            if (Pt === "*")
                                Pt = Rt;
                            else if (Rt !== "*" && Rt !== Pt) {
                                if (!(Qt = ze[Rt + " " + Pt] || ze["* " + Pt])) {
                                    for (Ft in ze)
                                        if ((be = Ft.split(" "))[1] === Pt && (Qt = ze[Rt + " " + be[0]] || ze["* " + be[0]])) {
                                            Qt === !0 ? Qt = ze[Ft] : ze[Ft] !== !0 && (Pt = be[0],
                                            Re.unshift(be[1]));
                                            break
                                        }
                                }
                                if (Qt !== !0)
                                    if (Qt && te.throws)
                                        Kt = Qt(Kt);
                                    else
                                        try {
                                            Kt = Qt(Kt)
                                        } catch (_i) {
                                            return {
                                                state: "parsererror",
                                                error: Qt ? _i : "No conversion from " + Rt + " to " + Pt
                                            }
                                        }
                            }
                        }
                    return {
                        state: "success",
                        data: Kt
                    }
                }(k, Oe, vt, me),
                me ? (k.ifModified && ((Ge = vt.getResponseHeader("Last-Modified")) && (r.lastModified[u] = Ge),
                (Ge = vt.getResponseHeader("etag")) && (r.etag[u] = Ge)),
                qt === 204 || k.type === "HEAD" ? Gt = "nocontent" : qt === 304 ? Gt = "notmodified" : (Gt = Oe.state,
                ii = Oe.data,
                me = !(ve = Oe.error))) : (ve = Gt,
                !qt && Gt || (Gt = "error",
                qt < 0 && (qt = 0))),
                vt.status = qt,
                vt.statusText = (Wt || Gt) + "",
                me ? Z.resolveWith(M, [ii, Gt, vt]) : Z.rejectWith(M, [vt, Gt, ve]),
                vt.statusCode(ae),
                ae = void 0,
                E && rt.trigger(me ? "ajaxSuccess" : "ajaxError", [vt, k, me ? ii : ve]),
                At.fireWith(M, [vt, Gt]),
                E && (rt.trigger("ajaxComplete", [vt, k]),
                --r.active || r.event.trigger("ajaxStop")))
            }
            return vt
        },
        getJSON: function(t, n, s) {
            return r.get(t, n, s, "json")
        },
        getScript: function(t, n) {
            return r.get(t, void 0, n, "script")
        }
    }),
    r.each(["get", "post"], function(o, t) {
        r[t] = function(n, s, u, h) {
            return y(s) && (h = h || u,
            u = s,
            s = void 0),
            r.ajax(r.extend({
                url: n,
                type: t,
                dataType: h,
                data: s,
                success: u
            }, r.isPlainObject(n) && n))
        }
    }),
    r.ajaxPrefilter(function(o) {
        var t;
        for (t in o.headers)
            t.toLowerCase() === "content-type" && (o.contentType = o.headers[t] || "")
    }),
    r._evalUrl = function(o, t, n) {
        return r.ajax({
            url: o,
            type: "GET",
            dataType: "script",
            cache: !0,
            async: !1,
            global: !1,
            converters: {
                "text script": function() {}
            },
            dataFilter: function(u) {
                r.globalEval(u, t, n)
            }
        })
    }
    ,
    r.fn.extend({
        wrapAll: function(t) {
            var n;
            return this[0] && (y(t) && (t = t.call(this[0])),
            n = r(t, this[0].ownerDocument).eq(0).clone(!0),
            this[0].parentNode && n.insertBefore(this[0]),
            n.map(function() {
                for (var s = this; s.firstElementChild; )
                    s = s.firstElementChild;
                return s
            }).append(this)),
            this
        },
        wrapInner: function(t) {
            return y(t) ? this.each(function(n) {
                r(this).wrapInner(t.call(this, n))
            }) : this.each(function() {
                var n = r(this)
                  , s = n.contents();
                s.length ? s.wrapAll(t) : n.append(t)
            })
        },
        wrap: function(t) {
            var n = y(t);
            return this.each(function(s) {
                r(this).wrapAll(n ? t.call(this, s) : t)
            })
        },
        unwrap: function(t) {
            return this.parent(t).not("body").each(function() {
                r(this).replaceWith(this.childNodes)
            }),
            this
        }
    }),
    r.expr.pseudos.hidden = function(o) {
        return !r.expr.pseudos.visible(o)
    }
    ,
    r.expr.pseudos.visible = function(o) {
        return !!(o.offsetWidth || o.offsetHeight || o.getClientRects().length)
    }
    ,
    r.ajaxSettings.xhr = function() {
        try {
            return new xt.XMLHttpRequest
        } catch (o) {}
    }
    ;
    var Hn = {
        0: 200,
        1223: 204
    }
      , ei = r.ajaxSettings.xhr();
    T.cors = !!ei && "withCredentials"in ei,
    T.ajax = ei = !!ei,
    r.ajaxTransport(function(o) {
        var t, n;
        if (T.cors || ei && !o.crossDomain)
            return {
                send: function(u, h) {
                    var f, m = o.xhr();
                    if (m.open(o.type, o.url, o.async, o.username, o.password),
                    o.xhrFields)
                        for (f in o.xhrFields)
                            m[f] = o.xhrFields[f];
                    for (f in o.mimeType && m.overrideMimeType && m.overrideMimeType(o.mimeType),
                    o.crossDomain || u["X-Requested-With"] || (u["X-Requested-With"] = "XMLHttpRequest"),
                    u)
                        m.setRequestHeader(f, u[f]);
                    t = function(b) {
                        return function() {
                            t && (t = n = m.onload = m.onerror = m.onabort = m.ontimeout = m.onreadystatechange = null,
                            b === "abort" ? m.abort() : b === "error" ? typeof m.status != "number" ? h(0, "error") : h(m.status, m.statusText) : h(Hn[m.status] || m.status, m.statusText, (m.responseType || "text") !== "text" || typeof m.responseText != "string" ? {
                                binary: m.response
                            } : {
                                text: m.responseText
                            }, m.getAllResponseHeaders()))
                        }
                    }
                    ,
                    m.onload = t(),
                    n = m.onerror = m.ontimeout = t("error"),
                    m.onabort !== void 0 ? m.onabort = n : m.onreadystatechange = function() {
                        m.readyState === 4 && xt.setTimeout(function() {
                            t && n()
                        })
                    }
                    ,
                    t = t("abort");
                    try {
                        m.send(o.hasContent && o.data || null)
                    } catch (C) {
                        if (t)
                            throw C
                    }
                },
                abort: function() {
                    t && t()
                }
            }
    }),
    r.ajaxPrefilter(function(o) {
        o.crossDomain && (o.contents.script = !1)
    }),
    r.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(t) {
                return r.globalEval(t),
                t
            }
        }
    }),
    r.ajaxPrefilter("script", function(o) {
        o.cache === void 0 && (o.cache = !1),
        o.crossDomain && (o.type = "GET")
    }),
    r.ajaxTransport("script", function(o) {
        var t, n;
        if (o.crossDomain || o.scriptAttrs)
            return {
                send: function(u, h) {
                    t = r("<script>").attr(o.scriptAttrs || {}).prop({
                        charset: o.scriptCharset,
                        src: o.url
                    }).on("load error", n = function(m) {
                        t.remove(),
                        n = null,
                        m && h(m.type === "error" ? 404 : 200, m.type)
                    }
                    ),
                    j.head.appendChild(t[0])
                },
                abort: function() {
                    n && n()
                }
            }
    });
    var sn, on = [], ki = /(=)\?(?=&|$)|\?\?/;
    r.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var t = on.pop() || r.expando + "_" + Zi.guid++;
            return this[t] = !0,
            t
        }
    }),
    r.ajaxPrefilter("json jsonp", function(o, t, n) {
        var s, u, h, f = o.jsonp !== !1 && (ki.test(o.url) ? "url" : typeof o.data == "string" && (o.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && ki.test(o.data) && "data");
        if (f || o.dataTypes[0] === "jsonp")
            return s = o.jsonpCallback = y(o.jsonpCallback) ? o.jsonpCallback() : o.jsonpCallback,
            f ? o[f] = o[f].replace(ki, "$1" + s) : o.jsonp !== !1 && (o.url += (xi.test(o.url) ? "&" : "?") + o.jsonp + "=" + s),
            o.converters["script json"] = function() {
                return h || r.error(s + " was not called"),
                h[0]
            }
            ,
            o.dataTypes[0] = "json",
            u = xt[s],
            xt[s] = function() {
                h = arguments
            }
            ,
            n.always(function() {
                u === void 0 ? r(xt).removeProp(s) : xt[s] = u,
                o[s] && (o.jsonpCallback = t.jsonpCallback,
                on.push(s)),
                h && y(u) && u(h[0]),
                h = u = void 0
            }),
            "script"
    }),
    T.createHTMLDocument = ((sn = j.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>",
    sn.childNodes.length === 2),
    r.parseHTML = function(o, t, n) {
        return typeof o != "string" ? [] : (typeof t == "boolean" && (n = t,
        t = !1),
        t || (T.createHTMLDocument ? ((s = (t = j.implementation.createHTMLDocument("")).createElement("base")).href = j.location.href,
        t.head.appendChild(s)) : t = j),
        h = !n && [],
        (u = tt.exec(o)) ? [t.createElement(u[1])] : (u = Ot([o], t, h),
        h && h.length && r(h).remove(),
        r.merge([], u.childNodes)));
        var s, u, h
    }
    ,
    r.fn.load = function(o, t, n) {
        var s, u, h, f = this, m = o.indexOf(" ");
        return -1 < m && (s = qe(o.slice(m)),
        o = o.slice(0, m)),
        y(t) ? (n = t,
        t = void 0) : t && _typeof(t) == "object" && (u = "POST"),
        0 < f.length && r.ajax({
            url: o,
            type: u || "GET",
            dataType: "html",
            data: t
        }).done(function(C) {
            h = arguments,
            f.html(s ? r("<div>").append(r.parseHTML(C)).find(s) : C)
        }).always(n && function(C, b) {
            f.each(function() {
                n.apply(this, h || [C.responseText, b, C])
            })
        }
        ),
        this
    }
    ,
    r.expr.pseudos.animated = function(o) {
        return r.grep(r.timers, function(t) {
            return o === t.elem
        }).length
    }
    ,
    r.offset = {
        setOffset: function(t, n, s) {
            var u, h, f, m, C, b, E = r.css(t, "position"), H = r(t), I = {};
            E === "static" && (t.style.position = "relative"),
            C = H.offset(),
            f = r.css(t, "top"),
            b = r.css(t, "left"),
            (E === "absolute" || E === "fixed") && -1 < (f + b).indexOf("auto") ? (m = (u = H.position()).top,
            h = u.left) : (m = parseFloat(f) || 0,
            h = parseFloat(b) || 0),
            y(n) && (n = n.call(t, s, r.extend({}, C))),
            n.top != null && (I.top = n.top - C.top + m),
            n.left != null && (I.left = n.left - C.left + h),
            "using"in n ? n.using.call(t, I) : (typeof I.top == "number" && (I.top += "px"),
            typeof I.left == "number" && (I.left += "px"),
            H.css(I))
        }
    },
    r.fn.extend({
        offset: function(t) {
            if (arguments.length)
                return t === void 0 ? this : this.each(function(h) {
                    r.offset.setOffset(this, t, h)
                });
            var n, s, u = this[0];
            return u ? u.getClientRects().length ? (n = u.getBoundingClientRect(),
            s = u.ownerDocument.defaultView,
            {
                top: n.top + s.pageYOffset,
                left: n.left + s.pageXOffset
            }) : {
                top: 0,
                left: 0
            } : void 0
        },
        position: function() {
            if (this[0]) {
                var t, n, s, u = this[0], h = {
                    top: 0,
                    left: 0
                };
                if (r.css(u, "position") === "fixed")
                    n = u.getBoundingClientRect();
                else {
                    for (n = this.offset(),
                    s = u.ownerDocument,
                    t = u.offsetParent || s.documentElement; t && (t === s.body || t === s.documentElement) && r.css(t, "position") === "static"; )
                        t = t.parentNode;
                    t && t !== u && t.nodeType === 1 && ((h = r(t).offset()).top += r.css(t, "borderTopWidth", !0),
                    h.left += r.css(t, "borderLeftWidth", !0))
                }
                return {
                    top: n.top - h.top - r.css(u, "marginTop", !0),
                    left: n.left - h.left - r.css(u, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                for (var t = this.offsetParent; t && r.css(t, "position") === "static"; )
                    t = t.offsetParent;
                return t || $e
            })
        }
    }),
    r.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(o, t) {
        var n = t === "pageYOffset";
        r.fn[o] = function(s) {
            return wt(this, function(u, h, f) {
                var m;
                if (A(u) ? m = u : u.nodeType === 9 && (m = u.defaultView),
                f === void 0)
                    return m ? m[t] : u[h];
                m ? m.scrollTo(n ? m.pageXOffset : f, n ? f : m.pageYOffset) : u[h] = f
            }, o, s, arguments.length)
        }
    }),
    r.each(["top", "left"], function(o, t) {
        r.cssHooks[t] = Mi(T.pixelPosition, function(n, s) {
            if (s)
                return s = Je(n, t),
                gi.test(s) ? r(n).position()[t] + "px" : s
        })
    }),
    r.each({
        Height: "height",
        Width: "width"
    }, function(o, t) {
        r.each({
            padding: "inner" + o,
            content: t,
            "": "outer" + o
        }, function(n, s) {
            r.fn[s] = function(u, h) {
                var f = arguments.length && (n || typeof u != "boolean")
                  , m = n || (u === !0 || h === !0 ? "margin" : "border");
                return wt(this, function(C, b, E) {
                    var H;
                    return A(C) ? s.indexOf("outer") === 0 ? C["inner" + o] : C.document.documentElement["client" + o] : C.nodeType === 9 ? (H = C.documentElement,
                    Math.max(C.body["scroll" + o], H["scroll" + o], C.body["offset" + o], H["offset" + o], H["client" + o])) : E === void 0 ? r.css(C, b, m) : r.style(C, b, E, m)
                }, t, f ? u : void 0, f)
            }
        })
    }),
    r.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(o, t) {
        r.fn[t] = function(n) {
            return this.on(t, n)
        }
    }),
    r.fn.extend({
        bind: function(t, n, s) {
            return this.on(t, null, n, s)
        },
        unbind: function(t, n) {
            return this.off(t, null, n)
        },
        delegate: function(t, n, s, u) {
            return this.on(n, t, s, u)
        },
        undelegate: function(t, n, s) {
            return arguments.length === 1 ? this.off(t, "**") : this.off(n, t || "**", s)
        },
        hover: function(t, n) {
            return this.mouseenter(t).mouseleave(n || t)
        }
    }),
    r.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(o, t) {
        r.fn[t] = function(n, s) {
            return 0 < arguments.length ? this.on(t, null, n, s) : this.trigger(t)
        }
    });
    var qn = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    r.proxy = function(o, t) {
        var n, s, u;
        if (typeof t == "string" && (n = o[t],
        t = o,
        o = n),
        y(o))
            return s = w.call(arguments, 2),
            (u = function() {
                return o.apply(t || this, s.concat(w.call(arguments)))
            }
            ).guid = o.guid = o.guid || r.guid++,
            u
    }
    ,
    r.holdReady = function(o) {
        o ? r.readyWait++ : r.ready(!0)
    }
    ,
    r.isArray = Array.isArray,
    r.parseJSON = JSON.parse,
    r.nodeName = X,
    r.isFunction = y,
    r.isWindow = A,
    r.camelCase = jt,
    r.type = K,
    r.now = Date.now,
    r.isNumeric = function(o) {
        var t = r.type(o);
        return (t === "number" || t === "string") && !isNaN(o - parseFloat(o))
    }
    ,
    r.trim = function(o) {
        return o == null ? "" : (o + "").replace(qn, "")
    }
    ,
    typeof define == "function" && define.amd && define("jquery", [], function() {
        return r
    });
    var In = xt.jQuery
      , Rn = xt.$;
    return r.noConflict = function(o) {
        return xt.$ === r && (xt.$ = Rn),
        o && xt.jQuery === r && (xt.jQuery = In),
        r
    }
    ,
    typeof le == "undefined" && (xt.jQuery = xt.$ = r),
    r
}),
theme.jQuery = $,
function(le) {
    var le = jQuery = le
      , Nt = null;
    /*! lazysizes - v4.0.1 */
    (function(d, w) {
        var e = w(d, d.document);
        d.lazySizes = e,
        (typeof module == "undefined" ? "undefined" : _typeof(module)) == "object" && module.exports && (module.exports = e)
    }
    )(window, function(d, w) {
        "use strict";
        if (w.getElementsByClassName) {
            var e, c, p = w.documentElement, i = d.Date, l = d.HTMLPictureElement, a = "addEventListener", g = "getAttribute", S = d[a], T = d.setTimeout, y = d.requestAnimationFrame || T, A = d.requestIdleCallback, j = /^picture$/i, L = ["load", "error", "lazyincluded", "_lazyloaded"], W = {}, K = Array.prototype.forEach, U = function(O, q) {
                return W[q] || (W[q] = new RegExp("(\\s|^)" + q + "(\\s|$)")),
                W[q].test(O[g]("class") || "") && W[q]
            }, r = function(O, q) {
                U(O, q) || O.setAttribute("class", (O[g]("class") || "").trim() + " " + q)
            }, ot = function(O, q) {
                var Q;
                (Q = U(O, q)) && O.setAttribute("class", (O[g]("class") || "").replace(Q, " "))
            }, B = function P(O, q, Q) {
                var st = Q ? a : "removeEventListener";
                Q && P(O, q),
                L.forEach(function(J) {
                    O[st](J, q)
                })
            }, it = function(O, q, Q, st, J) {
                var gt = w.createEvent("CustomEvent");
                return Q || (Q = {}),
                Q.instance = e,
                gt.initCustomEvent(q, !st, !J, Q),
                O.dispatchEvent(gt),
                gt
            }, yt = function(O, q) {
                var Q;
                !l && (Q = d.picturefill || c.pf) ? Q({
                    reevaluate: !0,
                    elements: [O]
                }) : q && q.src && (O.src = q.src)
            }, Y = function(O, q) {
                return (getComputedStyle(O, null) || {})[q]
            }, X = function(O, q, Q) {
                for (Q = Q || O.offsetWidth; Q < c.minSize && q && !O._lazysizesWidth; )
                    Q = q.offsetWidth,
                    q = q.parentNode;
                return Q
            }, tt = function() {
                var P, O, q = [], Q = [], st = q, J = function() {
                    var ht = st;
                    for (st = q.length ? Q : q,
                    P = !0,
                    O = !1; ht.length; )
                        ht.shift()();
                    P = !1
                }, gt = function(ht, pt) {
                    P && !pt ? ht.apply(this, arguments) : (st.push(ht),
                    O || (O = !0,
                    (w.hidden ? T : y)(J)))
                };
                return gt._lsFlush = J,
                gt
            }(), ft = function(O, q) {
                return q ? function() {
                    tt(O)
                }
                : function() {
                    var Q = this
                      , st = arguments;
                    tt(function() {
                        O.apply(Q, st)
                    })
                }
            }, dt = function(O) {
                var q, Q = 0, st = 125, J = c.ricTimeout, gt = function() {
                    q = !1,
                    Q = i.now(),
                    O()
                }, wt = A && c.ricTimeout ? function() {
                    A(gt, {
                        timeout: J
                    }),
                    J !== c.ricTimeout && (J = c.ricTimeout)
                }
                : ft(function() {
                    T(gt)
                }, !0);
                return function(ht) {
                    var pt;
                    (ht = ht === !0) && (J = 33),
                    q || (q = !0,
                    pt = st - (i.now() - Q),
                    0 > pt && (pt = 0),
                    ht || 9 > pt && A ? wt() : T(wt, pt))
                }
            }, V = function(O) {
                var q, Q, st = 99, J = function() {
                    q = null,
                    O()
                }, gt = function wt() {
                    var ht = i.now() - Q;
                    st > ht ? T(wt, st - ht) : (A || J)(J)
                };
                return function() {
                    Q = i.now(),
                    q || (q = T(gt, st))
                }
            };
            (function() {
                var P, O = {
                    lazyClass: "lazyload",
                    loadedClass: "lazyloaded",
                    loadingClass: "lazyloading",
                    preloadClass: "lazypreload",
                    errorClass: "lazyerror",
                    autosizesClass: "lazyautosizes",
                    srcAttr: "data-src",
                    srcsetAttr: "data-srcset",
                    sizesAttr: "data-sizes",
                    minSize: 40,
                    customMedia: {},
                    init: !0,
                    expFactor: 1.5,
                    hFac: .8,
                    loadMode: 2,
                    loadHidden: !0,
                    ricTimeout: 300
                };
                c = d.lazySizesConfig || d.lazysizesConfig || {};
                for (P in O)
                    P in c || (c[P] = O[P]);
                d.lazySizesConfig = c,
                T(function() {
                    c.init && R()
                })
            }
            )();
            var nt = function() {
                var P, O, q, Q, st, J, gt, wt, ht, pt, kt, jt, ce, ee, at = /^img$/i, Xt = /^iframe$/i, ye = "onscroll"in d && !/glebot/.test(navigator.userAgent), fe = 0, Me = 0, oe = 0, ge = -1, ue = function _t(lt) {
                    oe--,
                    lt && lt.target && B(lt.target, _t),
                    (!lt || 0 > oe || !lt.target) && (oe = 0)
                }, $e = function(lt, bt) {
                    var Dt, Vt = lt, Ot = Y(w.body, "visibility") == "hidden" || Y(lt, "visibility") != "hidden";
                    for (wt -= bt,
                    kt += bt,
                    ht -= bt,
                    pt += bt; Ot && (Vt = Vt.offsetParent) && Vt != w.body && Vt != p; )
                        Ot = (Y(Vt, "opacity") || 1) > 0,
                        Ot && Y(Vt, "overflow") != "visible" && (Dt = Vt.getBoundingClientRect(),
                        Ot = pt > Dt.left && ht < Dt.right && kt > Dt.top - 1 && wt < Dt.bottom + 1);
                    return Ot
                }, Ae = function() {
                    var lt, bt, Dt, Vt, Ot, ie, _e, de, re, Mt = e.elements;
                    if ((Q = c.loadMode) && 8 > oe && (lt = Mt.length)) {
                        for (bt = 0,
                        ge++,
                        ce == null && ("expand"in c || (c.expand = p.clientHeight > 500 && p.clientWidth > 500 ? 500 : 370),
                        jt = c.expand,
                        ce = jt * c.expFactor),
                        ce > Me && 1 > oe && ge > 2 && Q > 2 && !w.hidden ? (Me = ce,
                        ge = 0) : Me = Q > 1 && ge > 1 && 6 > oe ? jt : fe; lt > bt; bt++)
                            if (Mt[bt] && !Mt[bt]._lazyRace)
                                if (ye)
                                    if ((de = Mt[bt][g]("data-expand")) && (ie = 1 * de) || (ie = Me),
                                    re !== ie && (J = innerWidth + ie * ee,
                                    gt = innerHeight + ie,
                                    _e = -1 * ie,
                                    re = ie),
                                    Dt = Mt[bt].getBoundingClientRect(),
                                    (kt = Dt.bottom) >= _e && (wt = Dt.top) <= gt && (pt = Dt.right) >= _e * ee && (ht = Dt.left) <= J && (kt || pt || ht || wt) && (c.loadHidden || Y(Mt[bt], "visibility") != "hidden") && (O && 3 > oe && !de && (3 > Q || 4 > ge) || $e(Mt[bt], ie))) {
                                        if (ke(Mt[bt]),
                                        Ot = !0,
                                        oe > 9)
                                            break
                                    } else
                                        !Ot && O && !Vt && 4 > oe && 4 > ge && Q > 2 && (P[0] || c.preloadAfterLoad) && (P[0] || !de && (kt || pt || ht || wt || Mt[bt][g](c.sizesAttr) != "auto")) && (Vt = P[0] || Mt[bt]);
                                else
                                    ke(Mt[bt]);
                        Vt && !Ot && ke(Vt)
                    }
                }, se = dt(Ae), He = function(lt) {
                    r(lt.target, c.loadedClass),
                    ot(lt.target, c.loadingClass),
                    B(lt.target, Ze),
                    it(lt.target, "lazyloaded")
                }, si = ft(He), Ze = function(lt) {
                    si({
                        target: lt.target
                    })
                }, Ne = function(lt, bt) {
                    try {
                        lt.contentWindow.location.replace(bt)
                    } catch (Dt) {
                        lt.src = bt
                    }
                }, Ee = function(lt) {
                    var bt, Dt = lt[g](c.srcsetAttr);
                    (bt = c.customMedia[lt[g]("data-media") || lt[g]("media")]) && lt.setAttribute("media", bt),
                    Dt && lt.setAttribute("srcset", Dt)
                }, Fe = ft(function(_t, lt, bt, Dt, Vt) {
                    var Ot, ie, _e, de, re, Mt;
                    (re = it(_t, "lazybeforeunveil", lt)).defaultPrevented || (Dt && (bt ? r(_t, c.autosizesClass) : _t.setAttribute("sizes", Dt)),
                    ie = _t[g](c.srcsetAttr),
                    Ot = _t[g](c.srcAttr),
                    Vt && (_e = _t.parentNode,
                    de = _e && j.test(_e.nodeName || "")),
                    Mt = lt.firesLoad || "src"in _t && (ie || Ot || de),
                    re = {
                        target: _t
                    },
                    Mt && (B(_t, ue, !0),
                    clearTimeout(q),
                    q = T(ue, 2500),
                    r(_t, c.loadingClass),
                    B(_t, Ze, !0)),
                    de && K.call(_e.getElementsByTagName("source"), Ee),
                    ie ? _t.setAttribute("srcset", ie) : Ot && !de && (Xt.test(_t.nodeName) ? Ne(_t, Ot) : _t.src = Ot),
                    Vt && (ie || de) && yt(_t, {
                        src: Ot
                    })),
                    _t._lazyRace && delete _t._lazyRace,
                    ot(_t, c.lazyClass),
                    tt(function() {
                        (!Mt || _t.complete && _t.naturalWidth > 1) && (Mt ? ue(re) : oe--,
                        He(re))
                    }, !0)
                }), ke = function(lt) {
                    var bt, Dt = at.test(lt.nodeName), Vt = Dt && (lt[g](c.sizesAttr) || lt[g]("sizes")), Ot = Vt == "auto";
                    (!Ot && O || !Dt || !lt[g]("src") && !lt.srcset || lt.complete || U(lt, c.errorClass) || !U(lt, c.lazyClass)) && (bt = it(lt, "lazyunveilread").detail,
                    Ot && ct.updateElem(lt, !0, lt.offsetWidth),
                    lt._lazyRace = !0,
                    oe++,
                    Fe(lt, bt, Ot, Vt, Dt))
                }, Be = function _t() {
                    if (!O) {
                        if (i.now() - st < 999)
                            return void T(_t, 999);
                        var lt = V(function() {
                            c.loadMode = 3,
                            se()
                        });
                        O = !0,
                        c.loadMode = 3,
                        se(),
                        S("scroll", function() {
                            c.loadMode == 3 && (c.loadMode = 2),
                            lt()
                        }, !0)
                    }
                };
                return {
                    _: function() {
                        st = i.now(),
                        e.elements = w.getElementsByClassName(c.lazyClass),
                        P = w.getElementsByClassName(c.lazyClass + " " + c.preloadClass),
                        ee = c.hFac,
                        S("scroll", se, !0),
                        S("resize", se, !0),
                        d.MutationObserver ? new MutationObserver(se).observe(p, {
                            childList: !0,
                            subtree: !0,
                            attributes: !0
                        }) : (p[a]("DOMNodeInserted", se, !0),
                        p[a]("DOMAttrModified", se, !0),
                        setInterval(se, 999)),
                        S("hashchange", se, !0),
                        ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function(lt) {
                            w[a](lt, se, !0)
                        }),
                        /d$|^c/.test(w.readyState) ? Be() : (S("load", Be),
                        w[a]("DOMContentLoaded", se),
                        T(Be, 2e4)),
                        e.elements.length ? (Ae(),
                        tt._lsFlush()) : se()
                    },
                    checkElems: se,
                    unveil: ke
                }
            }()
              , ct = function() {
                var P, O = ft(function(J, gt, wt, ht) {
                    var pt, kt, jt;
                    if (J._lazysizesWidth = ht,
                    ht += "px",
                    J.setAttribute("sizes", ht),
                    j.test(gt.nodeName || ""))
                        for (pt = gt.getElementsByTagName("source"),
                        kt = 0,
                        jt = pt.length; jt > kt; kt++)
                            pt[kt].setAttribute("sizes", ht);
                    wt.detail.dataAttr || yt(J, wt.detail)
                }), q = function(gt, wt, ht) {
                    var pt, kt = gt.parentNode;
                    kt && (ht = X(gt, kt, ht),
                    pt = it(gt, "lazybeforesizes", {
                        width: ht,
                        dataAttr: !!wt
                    }),
                    pt.defaultPrevented || (ht = pt.detail.width,
                    ht && ht !== gt._lazysizesWidth && O(gt, kt, pt, ht)))
                }, Q = function() {
                    var gt, wt = P.length;
                    if (wt)
                        for (gt = 0; wt > gt; gt++)
                            q(P[gt])
                }, st = V(Q);
                return {
                    _: function() {
                        P = w.getElementsByClassName(c.autosizesClass),
                        S("resize", st)
                    },
                    checkElems: st,
                    updateElem: q
                }
            }()
              , R = function P() {
                P.i || (P.i = !0,
                ct._(),
                nt._())
            };
            return e = {
                cfg: c,
                autoSizer: ct,
                loader: nt,
                init: R,
                uP: yt,
                aC: r,
                rC: ot,
                hC: U,
                fire: it,
                gW: X,
                rAF: tt
            }
        }
    });
    /*! lazysizes - rias */
    (function(d, w) {
        var e = function c() {
            w(d.lazySizes),
            d.removeEventListener("lazyunveilread", c, !0)
        };
        w = w.bind(null, d, d.document),
        (typeof module == "undefined" ? "undefined" : _typeof(module)) == "object" && module.exports ? w(require("lazysizes")) : d.lazySizes ? e() : d.addEventListener("lazyunveilread", e, !0)
    }
    )(window, function(d, w, e) {
        "use strict";
        function c(Y, X) {
            var tt, ft, dt, V, nt = d.getComputedStyle(Y);
            ft = Y.parentNode,
            V = {
                isPicture: !(!ft || !A.test(ft.nodeName || ""))
            },
            dt = function(R, P) {
                var O = Y.getAttribute("data-" + R);
                if (!O) {
                    var q = nt.getPropertyValue("--ls-" + R);
                    q && (O = q.trim())
                }
                if (O) {
                    if (O == "true")
                        O = !0;
                    else if (O == "false")
                        O = !1;
                    else if (y.test(O))
                        O = parseFloat(O);
                    else if (typeof S[R] == "function")
                        O = S[R](Y, O);
                    else if (K.test(O))
                        try {
                            O = JSON.parse(O)
                        } catch (Q) {}
                    V[R] = O
                } else
                    R in S && typeof S[R] != "function" ? V[R] = S[R] : P && typeof S[R] == "function" && (V[R] = S[R](Y, O))
            }
            ;
            for (tt in S)
                dt(tt);
            return X.replace(W, function(ct, R) {
                R in V || dt(R, !0)
            }),
            V
        }
        function p(Y, X) {
            var tt = []
              , ft = function(V, nt) {
                return T[_typeof(X[nt])] ? X[nt] : V
            };
            return tt.srcset = [],
            X.absUrl && (r.setAttribute("href", Y),
            Y = r.href),
            Y = ((X.prefix || "") + Y + (X.postfix || "")).replace(W, ft),
            X.widths.forEach(function(dt) {
                var V = X.widthmap[dt] || dt
                  , nt = {
                    u: Y.replace(j, V).replace(L, X.ratio ? Math.round(dt * X.ratio) : ""),
                    w: dt
                };
                tt.push(nt),
                tt.srcset.push(nt.c = nt.u + " " + dt + "w")
            }),
            tt
        }
        function i(Y, X, tt) {
            var ft = 0
              , dt = 0
              , V = tt;
            if (Y) {
                if (X.ratio === "container") {
                    for (ft = V.scrollWidth,
                    dt = V.scrollHeight; !(ft && dt || V === w); )
                        V = V.parentNode,
                        ft = V.scrollWidth,
                        dt = V.scrollHeight;
                    ft && dt && (X.ratio = dt / ft)
                }
                Y = p(Y, X),
                Y.isPicture = X.isPicture,
                B && tt.nodeName.toUpperCase() == "IMG" ? tt.removeAttribute(g.srcsetAttr) : tt.setAttribute(g.srcsetAttr, Y.srcset.join(", ")),
                Object.defineProperty(tt, "_lazyrias", {
                    value: Y,
                    writable: !0
                })
            }
        }
        function l(Y, X) {
            var tt = c(Y, X);
            return S.modifyOptions.call(Y, {
                target: Y,
                details: tt,
                detail: tt
            }),
            e.fire(Y, "lazyriasmodifyoptions", tt),
            tt
        }
        function a(Y) {
            return Y.getAttribute(Y.getAttribute("data-srcattr") || S.srcAttr) || Y.getAttribute(g.srcsetAttr) || Y.getAttribute(g.srcAttr) || Y.getAttribute("data-pfsrcset") || ""
        }
        var g, S, T = {
            string: 1,
            number: 1
        }, y = /^\-*\+*\d+\.*\d*$/, A = /^picture$/i, j = /\s*\{\s*width\s*\}\s*/i, L = /\s*\{\s*height\s*\}\s*/i, W = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, K = /^\[.*\]|\{.*\}$/, U = /^(?:auto|\d+(px)?)$/, r = w.createElement("a"), ot = w.createElement("img"), B = "srcset"in ot && !("sizes"in ot), it = !!d.HTMLPictureElement && !B;
        (function() {
            var Y, X = function() {}, tt = {
                prefix: "",
                postfix: "",
                srcAttr: "data-src",
                absUrl: !1,
                modifyOptions: X,
                widthmap: {},
                ratio: !1
            };
            g = e && e.cfg || d.lazySizesConfig,
            g || (g = {},
            d.lazySizesConfig = g),
            g.supportsType || (g.supportsType = function(ft) {
                return !ft
            }
            ),
            g.rias || (g.rias = {}),
            S = g.rias,
            "widths"in S || (S.widths = [],
            function(ft) {
                for (var dt, V = 0; !dt || 3e3 > dt; )
                    V += 5,
                    V > 30 && (V += 1),
                    dt = 36 * V,
                    ft.push(dt)
            }(S.widths));
            for (Y in tt)
                Y in S || (S[Y] = tt[Y])
        }
        )(),
        addEventListener("lazybeforesizes", function(Y) {
            if (Y.detail.instance == e) {
                var X, tt, ft, dt, V, nt, ct, R, P, O, q, Q, st;
                if (X = Y.target,
                Y.detail.dataAttr && !Y.defaultPrevented && !S.disabled && (P = X.getAttribute(g.sizesAttr) || X.getAttribute("sizes")) && U.test(P)) {
                    if (tt = a(X),
                    ft = l(X, tt),
                    q = j.test(ft.prefix) || j.test(ft.postfix),
                    ft.isPicture && (dt = X.parentNode))
                        for (V = dt.getElementsByTagName("source"),
                        nt = 0,
                        ct = V.length; ct > nt; nt++)
                            (q || j.test(R = a(V[nt]))) && (i(R, ft, V[nt]),
                            Q = !0);
                    q || j.test(tt) ? (i(tt, ft, X),
                    Q = !0) : Q && (st = [],
                    st.srcset = [],
                    st.isPicture = !0,
                    Object.defineProperty(X, "_lazyrias", {
                        value: st,
                        writable: !0
                    })),
                    Q && (it ? X.removeAttribute(g.srcAttr) : P != "auto" && (O = {
                        width: parseInt(P, 10)
                    },
                    yt({
                        target: X,
                        detail: O
                    })))
                }
            }
        }, !0);
        var yt = function() {
            var Y = function(ct, R) {
                return ct.w - R.w
            }
              , X = function(ct) {
                var R, P, O = ct.length, q = ct[O - 1], Q = 0;
                for (Q; O > Q; Q++)
                    if (q = ct[Q],
                    q.d = q.w / ct.w,
                    q.d >= ct.d) {
                        !q.cached && (R = ct[Q - 1]) && R.d > ct.d - .13 * Math.pow(ct.d, 2.2) && (P = Math.pow(R.d - .6, 1.6),
                        R.cached && (R.d += .15 * P),
                        R.d + (q.d - ct.d) * P > ct.d && (q = R));
                        break
                    }
                return q
            }
              , tt = function(ct, R) {
                var P;
                return !ct._lazyrias && e.pWS && (P = e.pWS(ct.getAttribute(g.srcsetAttr || ""))).length && (Object.defineProperty(ct, "_lazyrias", {
                    value: P,
                    writable: !0
                }),
                R && ct.parentNode && (P.isPicture = ct.parentNode.nodeName.toUpperCase() == "PICTURE")),
                ct._lazyrias
            }
              , ft = function(ct) {
                var R = d.devicePixelRatio || 1
                  , P = e.getX && e.getX(ct);
                return Math.min(P || R, 2.4, R)
            }
              , dt = function(ct, R) {
                var P, O, q, Q, st, J;
                if (st = ct._lazyrias,
                st.isPicture && d.matchMedia) {
                    for (O = 0,
                    P = ct.parentNode.getElementsByTagName("source"),
                    q = P.length; q > O; O++)
                        if (tt(P[O]) && !P[O].getAttribute("type") && (!(Q = P[O].getAttribute("media")) || (matchMedia(Q) || {}).matches)) {
                            st = P[O]._lazyrias;
                            break
                        }
                }
                return (!st.w || st.w < R) && (st.w = R,
                st.d = ft(ct),
                J = X(st.sort(Y))),
                J
            }
              , V = function(ct) {
                if (ct.detail.instance == e) {
                    var R, P = ct.target;
                    return !B && (d.respimage || d.picturefill || lazySizesConfig.pf) ? void w.removeEventListener("lazybeforesizes", V) : void (("_lazyrias"in P || ct.detail.dataAttr && tt(P, !0)) && (R = dt(P, ct.detail.width),
                    R && R.u && P._lazyrias.cur != R.u && (P._lazyrias.cur = R.u,
                    R.cached = !0,
                    e.rAF(function() {
                        P.setAttribute(g.srcAttr, R.u),
                        P.setAttribute("src", R.u)
                    }))))
                }
            };
            return it ? V = function() {}
            : addEventListener("lazybeforesizes", V),
            V
        }()
    }),
    function(d, w, e) {
        "use strict";
        if (d.addEventListener) {
            var c, p = /^picture$/i, i = w.documentElement, l = function() {
                var A, j = /(([^,\s].[^\s]+)\s+(\d+)(w|h)(\s+(\d+)(w|h))?)/g, L = function(K, U, r, ot, B, it, yt, Y) {
                    A.push({
                        c: U,
                        u: r,
                        w: 1 * (Y == "w" ? yt : ot)
                    })
                };
                return function(W) {
                    return A = [],
                    W.replace(j, L),
                    A
                }
            }(), a = function() {
                var A = function(W, K) {
                    return W.w - K.w
                }
                  , j = function(W, K) {
                    var U = {
                        srcset: W.getAttribute(lazySizes.cfg.srcsetAttr) || ""
                    }
                      , r = l(U.srcset);
                    return Object.defineProperty(W, K, {
                        value: U,
                        writable: !0
                    }),
                    U.cands = r,
                    U.index = 0,
                    U.dirty = !1,
                    r[0] && r[0].w ? (r.sort(A),
                    U.cSrcset = [r[U.index].c]) : (U.cSrcset = U.srcset ? [U.srcset] : [],
                    U.cands = []),
                    U
                };
                return function(L, W) {
                    var K, U, r, ot;
                    if (!L[W] && (ot = L.parentNode || {},
                    L[W] = j(L, W),
                    L[W].isImg = !0,
                    p.test(ot.nodeName || "")))
                        for (L[W].picture = !0,
                        K = ot.getElementsByTagName("source"),
                        U = 0,
                        r = K.length; r > U; U++)
                            j(K[U], W).isImg = !1;
                    return L[W]
                }
            }(), g = {
                _lazyOptimumx: function() {
                    var A = function(L, W, K) {
                        var U, r, ot;
                        return L && L.d ? (ot = K > .7 ? .6 : .4,
                        L.d >= K ? !1 : (r = Math.pow(L.d - ot, 1.6) || .1,
                        .1 > r ? r = .1 : r > 3 && (r = 3),
                        U = L.d + (W - K) * r,
                        K > U)) : !0
                    };
                    return function(j, L, W) {
                        var K, U;
                        for (K = 0; K < j.cands.length; K++)
                            if (U = j.cands[K],
                            U.d = (U.w || 1) / L,
                            !(j.index >= K)) {
                                if (!(U.d <= W || A(j.cands[K - 1], U.d, W)))
                                    break;
                                j.cSrcset.push(U.c),
                                j.index = K
                            }
                    }
                }()
            }, S = function() {
                var A = function(L, W, K, U, r) {
                    var ot, B = L[r];
                    B && (ot = B.index,
                    g[r](B, W, K),
                    B.dirty && ot == B.index || (B.cSrcset.join(", "),
                    L.setAttribute(U, B.cSrcset.join(", ")),
                    B.dirty = !0))
                };
                return function(j, L, W, K, U) {
                    var r, ot, B, it, yt = j[U];
                    if (yt.width = L,
                    yt.picture && (ot = j.parentNode))
                        for (r = ot.getElementsByTagName("source"),
                        it = 0,
                        B = r.length; B > it; it++)
                            A(r[it], L, W, K, U);
                    A(j, L, W, K, U)
                }
            }(), T = function(j) {
                var L = j.getAttribute("data-optimumx") || j.getAttribute("data-maxdpr");
                return !L && c.constrainPixelDensity && (L = "auto"),
                L && (L = L == "auto" ? c.getOptimumX(j) : parseFloat(L, 10)),
                L
            }, y = function A() {
                d.lazySizes && !d.lazySizes.getOptimumX && (lazySizes.getX = T,
                lazySizes.pWS = l,
                i.removeEventListener("lazybeforeunveil", A))
            };
            i.addEventListener("lazybeforeunveil", y),
            setTimeout(y),
            c = d.lazySizes && lazySizes.cfg || d.lazySizesConfig,
            c || (c = {},
            d.lazySizesConfig = c),
            typeof c.getOptimumX != "function" && (c.getOptimumX = function() {
                var A = d.devicePixelRatio || 1;
                return A > 2.6 ? A *= .6 : A > 1.9 ? A *= .8 : A -= .01,
                Math.min(Math.round(100 * A) / 100, 2)
            }
            ),
            d.devicePixelRatio && addEventListener("lazybeforesizes", function(A) {
                var j, L, W, K, U = A.target, r = A.detail, ot = r.dataAttr;
                A.defaultPrevented || !(j = T(U)) || j >= devicePixelRatio || (!ot || !U._lazyOptimumx || r.reloaded || c.unloadedClass && lazySizes.hC(U, c.unloadedClass) || (U._lazyOptimumx = null),
                L = a(U, "_lazyOptimumx"),
                W = r.width,
                W && (L.width || 0) < W && (K = ot ? lazySizes.cfg.srcsetAttr : "srcset",
                lazySizes.rAF(function() {
                    S(U, W, j, K, "_lazyOptimumx")
                })))
            })
        }
    }(window, document),
    function(d, w) {
        var e = function c() {
            w(d.lazySizes),
            d.removeEventListener("lazyunveilread", c, !0)
        };
        w = w.bind(null, d, d.document),
        (typeof module == "undefined" ? "undefined" : _typeof(module)) == "object" && module.exports ? w(require("lazysizes")) : d.lazySizes ? e() : d.addEventListener("lazyunveilread", e, !0)
    }(window, function(d, w, e) {
        "use strict";
        var c, p;
        "srcset"in w.createElement("img") && (c = /^img$/i,
        p = function(l) {
            l.target.style.backgroundSize = "",
            l.target.style.backgroundImage = "",
            l.target.removeEventListener(l.type, p)
        }
        ,
        w.addEventListener("lazybeforeunveil", function(i) {
            if (i.detail.instance == e) {
                var l = i.target;
                if (c.test(l.nodeName)) {
                    var a = l.getAttribute("src");
                    a && (l.style.backgroundSize = "100% 100%",
                    l.style.backgroundImage = "url(" + a + ")",
                    l.removeAttribute("src"),
                    l.addEventListener("load", p))
                }
            }
        }, !1))
    }),
    function(d, w) {
        var e = function c() {
            w(d.lazySizes),
            d.removeEventListener("lazyunveilread", c, !0)
        };
        w = w.bind(null, d, d.document),
        (typeof module == "undefined" ? "undefined" : _typeof(module)) == "object" && module.exports ? w(require("lazysizes")) : d.lazySizes ? e() : d.addEventListener("lazyunveilread", e, !0)
    }(window, function(d, w, e) {
        "use strict";
        if (d.addEventListener) {
            var c = /\s+(\d+)(w|h)\s+(\d+)(w|h)/
              , p = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/
              , i = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/
              , l = /^picture$/i
              , a = function(T) {
                return getComputedStyle(T, null) || {}
            }
              , g = {
                getParent: function(T, y) {
                    var A = T
                      , j = T.parentNode;
                    return y && y != "prev" || !j || !l.test(j.nodeName || "") || (j = j.parentNode),
                    y != "self" && (A = y == "prev" ? T.previousElementSibling : y && (j.closest || d.jQuery) && (j.closest ? j.closest(y) : jQuery(j).closest(y)[0]) || j),
                    A
                },
                getFit: function(T) {
                    var y, A, j = a(T), L = j.content || j.fontFamily, W = {
                        fit: T._lazysizesParentFit || T.getAttribute("data-parent-fit")
                    };
                    return !W.fit && L && (y = L.match(p)) && (W.fit = y[1]),
                    W.fit ? (A = T._lazysizesParentContainer || T.getAttribute("data-parent-container"),
                    !A && L && (y = L.match(i)) && (A = y[1]),
                    W.parent = g.getParent(T, A)) : W.fit = j.objectFit,
                    W
                },
                getImageRatio: function(T) {
                    var y, A, j, L, W = T.parentNode, K = W && l.test(W.nodeName || "") ? W.querySelectorAll("source, img") : [T];
                    for (y = 0; y < K.length; y++)
                        if (T = K[y],
                        A = T.getAttribute(lazySizesConfig.srcsetAttr) || T.getAttribute("srcset") || T.getAttribute("data-pfsrcset") || T.getAttribute("data-risrcset") || "",
                        j = T._lsMedia || T.getAttribute("media"),
                        j = lazySizesConfig.customMedia[T.getAttribute("data-media") || j] || j,
                        A && (!j || (d.matchMedia && matchMedia(j) || {}).matches)) {
                            L = parseFloat(T.getAttribute("data-aspectratio")),
                            !L && A.match(c) && (L = RegExp.$2 == "w" ? RegExp.$1 / RegExp.$3 : RegExp.$3 / RegExp.$1);
                            break
                        }
                    return L
                },
                calculateSize: function(T, y) {
                    var A, j, L, W, K = this.getFit(T), U = K.fit, r = K.parent;
                    return U == "width" || (U == "contain" || U == "cover") && (L = this.getImageRatio(T)) ? (r ? y = r.clientWidth : r = T,
                    W = y,
                    U == "width" ? W = y : (j = r.clientHeight,
                    j > 40 && (A = y / j) && (U == "cover" && L > A || U == "contain" && A > L) && (W = y * (L / A))),
                    W) : y
                }
            };
            e.parentFit = g,
            w.addEventListener("lazybeforesizes", function(S) {
                if (!S.defaultPrevented && S.detail.instance == e) {
                    var T = S.target;
                    S.detail.width = g.calculateSize(T, S.detail.width)
                }
            })
        }
    });
    /*! lazysizes - respimg */
    (function(d, w) {
        var e = function c() {
            w(d.lazySizes),
            d.removeEventListener("lazyunveilread", c, !0)
        };
        w = w.bind(null, d, d.document),
        (typeof module == "undefined" ? "undefined" : _typeof(module)) == "object" && module.exports ? w(require("lazysizes"), require("../fix-ios-sizes/fix-ios-sizes")) : d.lazySizes ? e() : d.addEventListener("lazyunveilread", e, !0)
    }
    )(window, function(d, w, e) {
        "use strict";
        var c, p = e && e.cfg || d.lazySizesConfig, i = w.createElement("img"), l = "sizes"in i && "srcset"in i, a = /\s+\d+h/g, g = function() {
            var S = /\s+(\d+)(w|h)\s+(\d+)(w|h)/
              , T = Array.prototype.forEach;
            return function(y) {
                var A = w.createElement("img")
                  , j = function(U) {
                    var r, ot, B = U.getAttribute(lazySizesConfig.srcsetAttr);
                    B && ((ot = B.match(S)) && (r = ot[2] == "w" ? ot[1] / ot[3] : ot[3] / ot[1],
                    r && U.setAttribute("data-aspectratio", r)),
                    U.setAttribute(lazySizesConfig.srcsetAttr, B.replace(a, "")))
                }
                  , L = function(U) {
                    var r = U.target.parentNode;
                    r && r.nodeName == "PICTURE" && T.call(r.getElementsByTagName("source"), j),
                    j(U.target)
                }
                  , W = function() {
                    A.currentSrc && w.removeEventListener("lazybeforeunveil", L)
                };
                y[1] && (w.addEventListener("lazybeforeunveil", L),
                A.onload = W,
                A.onerror = W,
                A.srcset = "data:,a 1w 1h",
                A.complete && W())
            }
        }();
        if (p || (p = {},
        d.lazySizesConfig = p),
        p.supportsType || (p.supportsType = function(S) {
            return !S
        }
        ),
        !d.picturefill && !p.pf) {
            if (d.HTMLPictureElement && l)
                return w.msElementsFromPoint && g(navigator.userAgent.match(/Edge\/(\d+)/)),
                void (p.pf = function() {}
                );
            p.pf = function(S) {
                var T, y;
                if (!d.picturefill)
                    for (T = 0,
                    y = S.elements.length; y > T; T++)
                        c(S.elements[T])
            }
            ,
            c = function() {
                var S = function(B, it) {
                    return B.w - it.w
                }
                  , T = /^\s*\d+\.*\d*px\s*$/
                  , y = function(B) {
                    var it, yt, Y = B.length, X = B[Y - 1], tt = 0;
                    for (tt; Y > tt; tt++)
                        if (X = B[tt],
                        X.d = X.w / B.w,
                        X.d >= B.d) {
                            !X.cached && (it = B[tt - 1]) && it.d > B.d - .13 * Math.pow(B.d, 2.2) && (yt = Math.pow(it.d - .6, 1.6),
                            it.cached && (it.d += .15 * yt),
                            it.d + (X.d - B.d) * yt > B.d && (X = it));
                            break
                        }
                    return X
                }
                  , A = function() {
                    var ot, B = /(([^,\s].[^\s]+)\s+(\d+)w)/g, it = /\s/, yt = function(X, tt, ft, dt) {
                        ot.push({
                            c: tt,
                            u: ft,
                            w: 1 * dt
                        })
                    };
                    return function(Y) {
                        return ot = [],
                        Y = Y.trim(),
                        Y.replace(a, "").replace(B, yt),
                        ot.length || !Y || it.test(Y) || ot.push({
                            c: Y,
                            u: Y,
                            w: 99
                        }),
                        ot
                    }
                }()
                  , j = function ot() {
                    ot.init || (ot.init = !0,
                    addEventListener("resize", function() {
                        var B, it = w.getElementsByClassName("lazymatchmedia"), yt = function() {
                            var X, tt;
                            for (X = 0,
                            tt = it.length; tt > X; X++)
                                c(it[X])
                        };
                        return function() {
                            clearTimeout(B),
                            B = setTimeout(yt, 66)
                        }
                    }()))
                }
                  , L = function(B, it) {
                    var yt, Y = B.getAttribute("srcset") || B.getAttribute(p.srcsetAttr);
                    !Y && it && (Y = B._lazypolyfill ? B._lazypolyfill._set : B.getAttribute(p.srcAttr) || B.getAttribute("src")),
                    B._lazypolyfill && B._lazypolyfill._set == Y || (yt = A(Y || ""),
                    it && B.parentNode && (yt.isPicture = B.parentNode.nodeName.toUpperCase() == "PICTURE",
                    yt.isPicture && d.matchMedia && (e.aC(B, "lazymatchmedia"),
                    j())),
                    yt._set = Y,
                    Object.defineProperty(B, "_lazypolyfill", {
                        value: yt,
                        writable: !0
                    }))
                }
                  , W = function(B) {
                    var it = d.devicePixelRatio || 1
                      , yt = e.getX && e.getX(B);
                    return Math.min(yt || it, 2.5, it)
                }
                  , K = function(B) {
                    return d.matchMedia ? (K = function(yt) {
                        return !yt || (matchMedia(yt) || {}).matches
                    }
                    )(B) : !B
                }
                  , U = function(B) {
                    var it, yt, Y, X, tt, ft, dt;
                    if (X = B,
                    L(X, !0),
                    tt = X._lazypolyfill,
                    tt.isPicture) {
                        for (yt = 0,
                        it = B.parentNode.getElementsByTagName("source"),
                        Y = it.length; Y > yt; yt++)
                            if (p.supportsType(it[yt].getAttribute("type"), B) && K(it[yt].getAttribute("media"))) {
                                X = it[yt],
                                L(X),
                                tt = X._lazypolyfill;
                                break
                            }
                    }
                    return tt.length > 1 ? (dt = X.getAttribute("sizes") || "",
                    dt = T.test(dt) && parseInt(dt, 10) || e.gW(B, B.parentNode),
                    tt.d = W(B),
                    !tt.src || !tt.w || tt.w < dt ? (tt.w = dt,
                    ft = y(tt.sort(S)),
                    tt.src = ft) : ft = tt.src) : ft = tt[0],
                    ft
                }
                  , r = function(B) {
                    if (!l || !B.parentNode || B.parentNode.nodeName.toUpperCase() == "PICTURE") {
                        var it = U(B);
                        it && it.u && B._lazypolyfill.cur != it.u && (B._lazypolyfill.cur = it.u,
                        it.cached = !0,
                        B.setAttribute(p.srcAttr, it.u),
                        B.setAttribute("src", it.u))
                    }
                };
                return r.parse = A,
                r
            }(),
            p.loadedClass && p.loadingClass && function() {
                var S = [];
                ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function(T) {
                    S.push(T + p.loadedClass),
                    S.push(T + p.loadingClass)
                }),
                p.pf({
                    elements: w.querySelectorAll(S.join(", "))
                })
            }()
        }
    });
    /*! lazysizes - bgset */
    (function(d, w) {
        var e = function c() {
            w(d.lazySizes),
            d.removeEventListener("lazyunveilread", c, !0)
        };
        w = w.bind(null, d, d.document),
        (typeof module == "undefined" ? "undefined" : _typeof(module)) == "object" && module.exports ? w(require("lazysizes")) : d.lazySizes ? e() : d.addEventListener("lazyunveilread", e, !0)
    }
    )(window, function(d, w, e) {
        "use strict";
        if (d.addEventListener) {
            var c = /\s+/g
              , p = /\s*\|\s+|\s+\|\s*/g
              , i = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/
              , l = /\(|\)|'/
              , a = {
                contain: 1,
                cover: 1
            }
              , g = function(j) {
                var L = e.gW(j, j.parentNode);
                return (!j._lazysizesWidth || L > j._lazysizesWidth) && (j._lazysizesWidth = L),
                j._lazysizesWidth
            }
              , S = function(j) {
                var L;
                return L = (getComputedStyle(j) || {
                    getPropertyValue: function() {}
                }).getPropertyValue("background-size"),
                !a[L] && a[j.style.backgroundSize] && (L = j.style.backgroundSize),
                L
            }
              , T = function(j, L, W) {
                var K = w.createElement("picture")
                  , U = L.getAttribute(lazySizesConfig.sizesAttr)
                  , r = L.getAttribute("data-ratio")
                  , ot = L.getAttribute("data-optimumx");
                L._lazybgset && L._lazybgset.parentNode == L && L.removeChild(L._lazybgset),
                Object.defineProperty(W, "_lazybgset", {
                    value: L,
                    writable: !0
                }),
                Object.defineProperty(L, "_lazybgset", {
                    value: K,
                    writable: !0
                }),
                j = j.replace(c, " ").split(p),
                K.style.display = "none",
                W.className = lazySizesConfig.lazyClass,
                j.length != 1 || U || (U = "auto"),
                j.forEach(function(B) {
                    var it = w.createElement("source");
                    U && U != "auto" && it.setAttribute("sizes", U),
                    B.match(i) && (it.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1),
                    RegExp.$2 && it.setAttribute("media", lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2)),
                    K.appendChild(it)
                }),
                U && (W.setAttribute(lazySizesConfig.sizesAttr, U),
                L.removeAttribute(lazySizesConfig.sizesAttr),
                L.removeAttribute("sizes")),
                ot && W.setAttribute("data-optimumx", ot),
                r && W.setAttribute("data-ratio", r),
                K.appendChild(W),
                L.appendChild(K)
            }
              , y = function(j) {
                if (j.target._lazybgset) {
                    var L = j.target
                      , W = L._lazybgset
                      , K = L.currentSrc || L.src;
                    K && (W.style.backgroundImage = "url(" + (l.test(K) ? JSON.stringify(K) : K) + ")"),
                    L._lazybgsetLoading && (e.fire(W, "_lazyloaded", {}, !1, !0),
                    delete L._lazybgsetLoading)
                }
            };
            addEventListener("lazybeforeunveil", function(A) {
                var j, L, W;
                !A.defaultPrevented && (j = A.target.getAttribute("data-bgset")) && (W = A.target,
                L = w.createElement("img"),
                L.alt = "",
                L._lazybgsetLoading = !0,
                A.detail.firesLoad = !0,
                T(j, W, L),
                setTimeout(function() {
                    e.loader.unveil(L),
                    e.rAF(function() {
                        e.fire(L, "_lazyloaded", {}, !0, !0),
                        L.complete && y({
                            target: L
                        })
                    })
                }))
            }),
            w.addEventListener("load", y, !0),
            d.addEventListener("lazybeforesizes", function(A) {
                if (A.detail.instance == e && A.target._lazybgset && A.detail.dataAttr) {
                    var j = A.target._lazybgset
                      , L = S(j);
                    a[L] && (A.target._lazysizesParentFit = L,
                    e.rAF(function() {
                        A.target.setAttribute("data-parent-fit", L),
                        A.target._lazysizesParentFit && delete A.target._lazysizesParentFit
                    }))
                }
            }, !0),
            w.documentElement.addEventListener("lazybeforesizes", function(A) {
                !A.defaultPrevented && A.target._lazybgset && A.detail.instance == e && (A.detail.width = g(A.target._lazybgset))
            })
        }
    }),
    document.addEventListener("lazyloaded", function(d) {
        d.target.parentElement.className = d.target.parentElement.className.replace("lazyload--placeholder", "")
    }),
    function(d) {
        "use strict";
        typeof Nt == "function" && Nt.amd ? Nt(["jquery"], d) : typeof exports != "undefined" ? module.exports = d(require("jquery")) : d(jQuery)
    }(function(d) {
        "use strict";
        var w = window.Slick || {};
        w = function() {
            function e(p, i) {
                var l, a = this;
                a.defaults = {
                    accessibility: !0,
                    adaptiveHeight: !1,
                    appendArrows: d(p),
                    appendDots: d(p),
                    arrows: !0,
                    asNavFor: null,
                    prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="' + theme.strings.previous + '" tabindex="0" role="button">' + theme.strings.previous + "</button>",
                    nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="' + theme.strings.next + '" tabindex="0" role="button">' + theme.strings.next + "</button>",
                    autoplay: !1,
                    autoplaySpeed: 3e3,
                    centerMode: !1,
                    centerPadding: "50px",
                    cssEase: "ease",
                    customPaging: function(S, T) {
                        return d('<button type="button" data-role="none" role="button" tabindex="0" />').text(T + 1)
                    },
                    dots: !1,
                    dotsClass: "slick-dots",
                    draggable: !0,
                    easing: "linear",
                    edgeFriction: .35,
                    fade: !1,
                    focusOnSelect: !1,
                    infinite: !0,
                    initialSlide: 0,
                    lazyLoad: "ondemand",
                    mobileFirst: !1,
                    pauseOnHover: !0,
                    pauseOnFocus: !0,
                    pauseOnDotsHover: !1,
                    respondTo: "window",
                    responsive: null,
                    rows: 1,
                    rtl: !1,
                    slide: "",
                    slidesPerRow: 1,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 500,
                    swipe: !0,
                    swipeToSlide: !1,
                    touchMove: !0,
                    touchThreshold: 5,
                    useCSS: !0,
                    useTransform: !0,
                    variableWidth: !1,
                    vertical: !1,
                    verticalSwiping: !1,
                    waitForAnimate: !0,
                    zIndex: 1e3
                },
                a.initials = {
                    animating: !1,
                    dragging: !1,
                    autoPlayTimer: null,
                    currentDirection: 0,
                    currentLeft: null,
                    currentSlide: 0,
                    direction: 1,
                    $dots: null,
                    listWidth: null,
                    listHeight: null,
                    loadIndex: 0,
                    $nextArrow: null,
                    $prevArrow: null,
                    slideCount: null,
                    slideWidth: null,
                    $slideTrack: null,
                    $slides: null,
                    sliding: !1,
                    slideOffset: 0,
                    swipeLeft: null,
                    $list: null,
                    touchObject: {},
                    transformsEnabled: !1,
                    unslicked: !1
                },
                d.extend(a, a.initials),
                a.activeBreakpoint = null,
                a.animType = null,
                a.animProp = null,
                a.breakpoints = [],
                a.breakpointSettings = [],
                a.cssTransitions = !1,
                a.focussed = !1,
                a.interrupted = !1,
                a.hidden = "hidden",
                a.paused = !0,
                a.positionProp = null,
                a.respondTo = null,
                a.rowCount = 1,
                a.shouldClick = !0,
                a.$slider = d(p),
                a.$slidesCache = null,
                a.transformType = null,
                a.transitionType = null,
                a.visibilityChange = "visibilitychange",
                a.windowWidth = 0,
                a.windowTimer = null,
                l = d(p).data("slick") || {},
                a.options = d.extend({}, a.defaults, i, l),
                a.currentSlide = a.options.initialSlide,
                a.originalSettings = a.options,
                typeof document.mozHidden != "undefined" ? (a.hidden = "mozHidden",
                a.visibilityChange = "mozvisibilitychange") : typeof document.webkitHidden != "undefined" && (a.hidden = "webkitHidden",
                a.visibilityChange = "webkitvisibilitychange"),
                a.autoPlay = d.proxy(a.autoPlay, a),
                a.autoPlayClear = d.proxy(a.autoPlayClear, a),
                a.autoPlayIterator = d.proxy(a.autoPlayIterator, a),
                a.changeSlide = d.proxy(a.changeSlide, a),
                a.clickHandler = d.proxy(a.clickHandler, a),
                a.selectHandler = d.proxy(a.selectHandler, a),
                a.setPosition = d.proxy(a.setPosition, a),
                a.swipeHandler = d.proxy(a.swipeHandler, a),
                a.dragHandler = d.proxy(a.dragHandler, a),
                a.keyHandler = d.proxy(a.keyHandler, a),
                a.instanceUid = c++,
                a.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/,
                a.registerBreakpoints(),
                a.init(!0)
            }
            var c = 0;
            return e
        }(),
        w.prototype.activateADA = function() {
            var e = this;
            e.$slideTrack.find(".slick-active").attr({
                "aria-hidden": "false"
            }).find("a, input, button, select").attr({
                tabindex: "0"
            })
        }
        ,
        w.prototype.addSlide = w.prototype.slickAdd = function(e, c, p) {
            var i = this;
            if (typeof c == "boolean")
                p = c,
                c = null;
            else if (0 > c || c >= i.slideCount)
                return !1;
            i.unload(),
            typeof c == "number" ? c === 0 && i.$slides.length === 0 ? d(e).appendTo(i.$slideTrack) : p ? d(e).insertBefore(i.$slides.eq(c)) : d(e).insertAfter(i.$slides.eq(c)) : p === !0 ? d(e).prependTo(i.$slideTrack) : d(e).appendTo(i.$slideTrack),
            i.$slides = i.$slideTrack.children(this.options.slide),
            i.$slideTrack.children(this.options.slide).detach(),
            i.$slideTrack.append(i.$slides),
            i.$slides.each(function(l, a) {
                d(a).attr("data-slick-index", l)
            }),
            i.$slidesCache = i.$slides,
            i.reinit()
        }
        ,
        w.prototype.animateHeight = function() {
            var e = this;
            if (e.options.slidesToShow === 1 && e.options.adaptiveHeight === !0 && e.options.vertical === !1) {
                var c = e.$slides.eq(e.currentSlide).outerHeight(!0);
                e.$list.animate({
                    height: c
                }, e.options.speed)
            }
        }
        ,
        w.prototype.animateSlide = function(e, c) {
            var p = {}
              , i = this;
            i.animateHeight(),
            i.options.rtl === !0 && i.options.vertical === !1 && (e = -e),
            i.transformsEnabled === !1 ? i.options.vertical === !1 ? i.$slideTrack.animate({
                left: e
            }, i.options.speed, i.options.easing, c) : i.$slideTrack.animate({
                top: e
            }, i.options.speed, i.options.easing, c) : i.cssTransitions === !1 ? (i.options.rtl === !0 && (i.currentLeft = -i.currentLeft),
            d({
                animStart: i.currentLeft
            }).animate({
                animStart: e
            }, {
                duration: i.options.speed,
                easing: i.options.easing,
                step: function(a) {
                    a = Math.ceil(a),
                    i.options.vertical === !1 ? (p[i.animType] = "translate(" + a + "px, 0px)",
                    i.$slideTrack.css(p)) : (p[i.animType] = "translate(0px," + a + "px)",
                    i.$slideTrack.css(p))
                },
                complete: function() {
                    c && c.call()
                }
            })) : (i.applyTransition(),
            e = Math.ceil(e),
            i.options.vertical === !1 ? p[i.animType] = "translate3d(" + e + "px, 0px, 0px)" : p[i.animType] = "translate3d(0px," + e + "px, 0px)",
            i.$slideTrack.css(p),
            c && setTimeout(function() {
                i.disableTransition(),
                c.call()
            }, i.options.speed))
        }
        ,
        w.prototype.getNavTarget = function() {
            var e = this
              , c = e.options.asNavFor;
            return c && c !== null && (c = d(c).not(e.$slider)),
            c
        }
        ,
        w.prototype.asNavFor = function(e) {
            var c = this
              , p = c.getNavTarget();
            p !== null && _typeof(p) == "object" && p.each(function() {
                var i = d(this).slick("getSlick");
                i.unslicked || i.slideHandler(e, !0)
            })
        }
        ,
        w.prototype.applyTransition = function(e) {
            var c = this
              , p = {};
            c.options.fade === !1 ? p[c.transitionType] = c.transformType + " " + c.options.speed + "ms " + c.options.cssEase : p[c.transitionType] = "opacity " + c.options.speed + "ms " + c.options.cssEase,
            c.options.fade === !1 ? c.$slideTrack.css(p) : c.$slides.eq(e).css(p)
        }
        ,
        w.prototype.autoPlay = function() {
            var e = this;
            e.autoPlayClear(),
            e.slideCount > e.options.slidesToShow && (e.autoPlayTimer = setInterval(e.autoPlayIterator, e.options.autoplaySpeed))
        }
        ,
        w.prototype.autoPlayClear = function() {
            var e = this;
            e.autoPlayTimer && clearInterval(e.autoPlayTimer)
        }
        ,
        w.prototype.autoPlayIterator = function() {
            var e = this
              , c = e.currentSlide + e.options.slidesToScroll;
            e.paused || e.interrupted || e.focussed || (e.options.infinite === !1 && (e.direction === 1 && e.currentSlide + 1 === e.slideCount - 1 ? e.direction = 0 : e.direction === 0 && (c = e.currentSlide - e.options.slidesToScroll,
            e.currentSlide - 1 === 0 && (e.direction = 1))),
            e.slideHandler(c))
        }
        ,
        w.prototype.buildArrows = function() {
            var e = this;
            e.options.arrows === !0 && (e.$prevArrow = d(e.options.prevArrow).addClass("slick-arrow"),
            e.$nextArrow = d(e.options.nextArrow).addClass("slick-arrow"),
            e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
            e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
            e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows),
            e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows),
            e.options.infinite !== !0 && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
                "aria-disabled": "true",
                tabindex: "-1"
            }))
        }
        ,
        w.prototype.buildDots = function() {
            var e, c, p = this;
            if (p.options.dots === !0 && p.slideCount > p.options.slidesToShow) {
                for (p.$slider.addClass("slick-dotted"),
                c = d("<ul />").addClass(p.options.dotsClass),
                e = 0; e <= p.getDotCount(); e += 1)
                    c.append(d("<li />").append(p.options.customPaging.call(this, p, e)));
                p.$dots = c.appendTo(p.options.appendDots),
                p.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false")
            }
        }
        ,
        w.prototype.buildOut = function() {
            var e = this;
            e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"),
            e.slideCount = e.$slides.length,
            e.$slides.each(function(c, p) {
                d(p).attr("data-slick-index", c).data("originalStyling", d(p).attr("style") || "")
            }),
            e.$slider.addClass("slick-slider"),
            e.$slideTrack = e.slideCount === 0 ? d('<div class="slick-track" aria-label="'.concat(theme.strings.imageSlider ? theme.strings.imageSlider : "", '"/>')).appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track" aria-label="'.concat(theme.strings.imageSlider ? theme.strings.imageSlider : "", '"/>')).parent(),
            e.$list = e.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(),
            e.$slideTrack.css("opacity", 0),
            (e.options.centerMode === !0 || e.options.swipeToSlide === !0) && (e.options.slidesToScroll = 1),
            d("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
            e.setupInfinite(),
            e.buildArrows(),
            e.buildDots(),
            e.updateDots(),
            e.setSlideClasses(typeof e.currentSlide == "number" ? e.currentSlide : 0),
            e.options.draggable === !0 && e.$list.addClass("draggable")
        }
        ,
        w.prototype.buildRows = function() {
            var e, c, p, i, l, a, g, S = this;
            if (i = document.createDocumentFragment(),
            a = S.$slider.children(),
            S.options.rows > 1) {
                for (g = S.options.slidesPerRow * S.options.rows,
                l = Math.ceil(a.length / g),
                e = 0; l > e; e++) {
                    var T = document.createElement("div");
                    for (c = 0; c < S.options.rows; c++) {
                        var y = document.createElement("div");
                        for (p = 0; p < S.options.slidesPerRow; p++) {
                            var A = e * g + (c * S.options.slidesPerRow + p);
                            a.get(A) && y.appendChild(a.get(A))
                        }
                        T.appendChild(y)
                    }
                    i.appendChild(T)
                }
                S.$slider.empty().append(i),
                S.$slider.children().children().children().css({
                    width: 100 / S.options.slidesPerRow + "%",
                    display: "inline-block"
                })
            }
        }
        ,
        w.prototype.checkResponsive = function(e, c) {
            var p, i, l, a = this, g = !1, S = a.$slider.width(), T = window.innerWidth || d(window).width();
            if (a.respondTo === "window" ? l = T : a.respondTo === "slider" ? l = S : a.respondTo === "min" && (l = Math.min(T, S)),
            a.options.responsive && a.options.responsive.length && a.options.responsive !== null) {
                i = null;
                for (p in a.breakpoints)
                    a.breakpoints.hasOwnProperty(p) && (a.originalSettings.mobileFirst === !1 ? l < a.breakpoints[p] && (i = a.breakpoints[p]) : l > a.breakpoints[p] && (i = a.breakpoints[p]));
                i !== null ? a.activeBreakpoint !== null ? (i !== a.activeBreakpoint || c) && (a.activeBreakpoint = i,
                a.breakpointSettings[i] === "unslick" ? a.unslick(i) : (a.options = d.extend({}, a.originalSettings, a.breakpointSettings[i]),
                e === !0 && (a.currentSlide = a.options.initialSlide),
                a.refresh(e)),
                g = i) : (a.activeBreakpoint = i,
                a.breakpointSettings[i] === "unslick" ? a.unslick(i) : (a.options = d.extend({}, a.originalSettings, a.breakpointSettings[i]),
                e === !0 && (a.currentSlide = a.options.initialSlide),
                a.refresh(e)),
                g = i) : a.activeBreakpoint !== null && (a.activeBreakpoint = null,
                a.options = a.originalSettings,
                e === !0 && (a.currentSlide = a.options.initialSlide),
                a.refresh(e),
                g = i),
                e || g === !1 || a.$slider.trigger("breakpoint", [a, g])
            }
        }
        ,
        w.prototype.changeSlide = function(e, c) {
            var p, i, l, a = this, g = d(e.currentTarget);
            switch (g.is("a") && e.preventDefault(),
            g.is("li") || (g = g.closest("li")),
            l = a.slideCount % a.options.slidesToScroll !== 0,
            p = l ? 0 : (a.slideCount - a.currentSlide) % a.options.slidesToScroll,
            e.data.message) {
            case "previous":
                i = p === 0 ? a.options.slidesToScroll : a.options.slidesToShow - p,
                a.slideCount > a.options.slidesToShow && a.slideHandler(a.currentSlide - i, !1, c);
                break;
            case "next":
                i = p === 0 ? a.options.slidesToScroll : p,
                a.slideCount > a.options.slidesToShow && a.slideHandler(a.currentSlide + i, !1, c);
                break;
            case "index":
                var S = e.data.index === 0 ? 0 : e.data.index || g.index() * a.options.slidesToScroll;
                a.slideHandler(a.checkNavigable(S), !1, c),
                g.children().trigger("focus");
                break;
            default:
                return
            }
        }
        ,
        w.prototype.checkNavigable = function(e) {
            var c, p, i = this;
            if (c = i.getNavigableIndexes(),
            p = 0,
            e > c[c.length - 1])
                e = c[c.length - 1];
            else
                for (var l in c) {
                    if (e < c[l]) {
                        e = p;
                        break
                    }
                    p = c[l]
                }
            return e
        }
        ,
        w.prototype.cleanUpEvents = function() {
            var e = this;
            e.options.dots && e.$dots !== null && d("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", d.proxy(e.interrupt, e, !0)).off("mouseleave.slick", d.proxy(e.interrupt, e, !1)),
            e.$slider.off("focus.slick blur.slick"),
            e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
            e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide)),
            e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
            e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
            e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
            e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
            e.$list.off("click.slick", e.clickHandler),
            d(document).off(e.visibilityChange, e.visibility),
            e.cleanUpSlideEvents(),
            e.options.accessibility === !0 && e.$list.off("keydown.slick", e.keyHandler),
            e.options.focusOnSelect === !0 && d(e.$slideTrack).children().off("click.slick", e.selectHandler),
            d(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange),
            d(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
            d("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault),
            d(window).off("load.slick.slick-" + e.instanceUid, e.setPosition),
            d(document).off("ready.slick.slick-" + e.instanceUid, e.setPosition)
        }
        ,
        w.prototype.cleanUpSlideEvents = function() {
            var e = this;
            e.$list.off("mouseenter.slick", d.proxy(e.interrupt, e, !0)),
            e.$list.off("mouseleave.slick", d.proxy(e.interrupt, e, !1))
        }
        ,
        w.prototype.cleanUpRows = function() {
            var e, c = this;
            c.options.rows > 1 && (e = c.$slides.children().children(),
            e.removeAttr("style"),
            c.$slider.empty().append(e))
        }
        ,
        w.prototype.clickHandler = function(e) {
            var c = this;
            c.shouldClick === !1 && (e.stopImmediatePropagation(),
            e.stopPropagation(),
            e.preventDefault())
        }
        ,
        w.prototype.destroy = function(e) {
            var c = this;
            c.autoPlayClear(),
            c.touchObject = {},
            c.cleanUpEvents(),
            d(".slick-cloned", c.$slider).detach(),
            c.$dots && c.$dots.remove(),
            c.$prevArrow && c.$prevArrow.length && (c.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""),
            c.htmlExpr.test(c.options.prevArrow) && c.$prevArrow.remove()),
            c.$nextArrow && c.$nextArrow.length && (c.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""),
            c.htmlExpr.test(c.options.nextArrow) && c.$nextArrow.remove()),
            c.$slides && (c.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
                d(this).attr("style", d(this).data("originalStyling"))
            }),
            c.$slideTrack.children(this.options.slide).detach(),
            c.$slideTrack.detach(),
            c.$list.detach(),
            c.$slider.append(c.$slides)),
            c.cleanUpRows(),
            c.$slider.removeClass("slick-slider"),
            c.$slider.removeClass("slick-initialized"),
            c.$slider.removeClass("slick-dotted"),
            c.unslicked = !0,
            e || c.$slider.trigger("destroy", [c])
        }
        ,
        w.prototype.disableTransition = function(e) {
            var c = this
              , p = {};
            p[c.transitionType] = "",
            c.options.fade === !1 ? c.$slideTrack.css(p) : c.$slides.eq(e).css(p)
        }
        ,
        w.prototype.fadeSlide = function(e, c) {
            var p = this;
            p.cssTransitions === !1 ? (p.$slides.eq(e).css({
                zIndex: p.options.zIndex
            }),
            p.$slides.eq(e).animate({
                opacity: 1
            }, p.options.speed, p.options.easing, c)) : (p.applyTransition(e),
            p.$slides.eq(e).css({
                opacity: 1,
                zIndex: p.options.zIndex
            }),
            c && setTimeout(function() {
                p.disableTransition(e),
                c.call()
            }, p.options.speed))
        }
        ,
        w.prototype.fadeSlideOut = function(e) {
            var c = this;
            c.cssTransitions === !1 ? c.$slides.eq(e).animate({
                opacity: 0,
                zIndex: c.options.zIndex - 2
            }, c.options.speed, c.options.easing) : (c.applyTransition(e),
            c.$slides.eq(e).css({
                opacity: 0,
                zIndex: c.options.zIndex - 2
            }))
        }
        ,
        w.prototype.filterSlides = w.prototype.slickFilter = function(e) {
            var c = this;
            e !== null && (c.$slidesCache = c.$slides,
            c.unload(),
            c.$slideTrack.children(this.options.slide).detach(),
            c.$slidesCache.filter(e).appendTo(c.$slideTrack),
            c.reinit())
        }
        ,
        w.prototype.focusHandler = function() {
            var e = this;
            e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*:not(.slick-arrow)", function(c) {
                var p = d(this);
                setTimeout(function() {
                    e.options.pauseOnFocus && (e.focussed = p.is(":focus"),
                    e.autoPlay())
                }, 0)
            })
        }
        ,
        w.prototype.getCurrent = w.prototype.slickCurrentSlide = function() {
            var e = this;
            return e.currentSlide
        }
        ,
        w.prototype.getDotCount = function() {
            var e = this
              , c = 0
              , p = 0
              , i = 0;
            if (e.options.infinite === !0)
                for (; c < e.slideCount; )
                    ++i,
                    c = p + e.options.slidesToScroll,
                    p += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
            else if (e.options.centerMode === !0)
                i = e.slideCount;
            else if (e.options.asNavFor)
                for (; c < e.slideCount; )
                    ++i,
                    c = p + e.options.slidesToScroll,
                    p += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
            else
                i = 1 + Math.ceil((e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll);
            return i - 1
        }
        ,
        w.prototype.getLeft = function(e) {
            var c, p, i, l = this, a = 0;
            return l.slideOffset = 0,
            p = l.$slides.first().outerHeight(!0),
            l.options.infinite === !0 ? (l.slideCount > l.options.slidesToShow && (l.slideOffset = l.slideWidth * l.options.slidesToShow * -1,
            a = p * l.options.slidesToShow * -1),
            l.slideCount % l.options.slidesToScroll !== 0 && e + l.options.slidesToScroll > l.slideCount && l.slideCount > l.options.slidesToShow && (e > l.slideCount ? (l.slideOffset = (l.options.slidesToShow - (e - l.slideCount)) * l.slideWidth * -1,
            a = (l.options.slidesToShow - (e - l.slideCount)) * p * -1) : (l.slideOffset = l.slideCount % l.options.slidesToScroll * l.slideWidth * -1,
            a = l.slideCount % l.options.slidesToScroll * p * -1))) : e + l.options.slidesToShow > l.slideCount && (l.slideOffset = (e + l.options.slidesToShow - l.slideCount) * l.slideWidth,
            a = (e + l.options.slidesToShow - l.slideCount) * p),
            l.slideCount <= l.options.slidesToShow && (l.slideOffset = 0,
            a = 0),
            l.options.centerMode === !0 && l.options.infinite === !0 ? l.slideOffset += l.slideWidth * Math.floor(l.options.slidesToShow / 2) - l.slideWidth : l.options.centerMode === !0 && (l.slideOffset = 0,
            l.slideOffset += l.slideWidth * Math.floor(l.options.slidesToShow / 2)),
            c = l.options.vertical === !1 ? e * l.slideWidth * -1 + l.slideOffset : e * p * -1 + a,
            l.options.variableWidth === !0 && (i = l.slideCount <= l.options.slidesToShow || l.options.infinite === !1 ? l.$slideTrack.children(".slick-slide").eq(e) : l.$slideTrack.children(".slick-slide").eq(e + l.options.slidesToShow),
            c = l.options.rtl === !0 ? i[0] ? -1 * (l.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0 : i[0] ? -1 * i[0].offsetLeft : 0,
            l.options.centerMode === !0 && (i = l.slideCount <= l.options.slidesToShow || l.options.infinite === !1 ? l.$slideTrack.children(".slick-slide").eq(e) : l.$slideTrack.children(".slick-slide").eq(e + l.options.slidesToShow + 1),
            c = l.options.rtl === !0 ? i[0] ? -1 * (l.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0 : i[0] ? -1 * i[0].offsetLeft : 0,
            c += (l.$list.width() - i.outerWidth()) / 2)),
            c
        }
        ,
        w.prototype.getOption = w.prototype.slickGetOption = function(e) {
            var c = this;
            return c.options[e]
        }
        ,
        w.prototype.getNavigableIndexes = function() {
            var e, c = this, p = 0, i = 0, l = [];
            for (c.options.infinite === !1 ? e = c.slideCount : (p = -1 * c.options.slidesToScroll,
            i = -1 * c.options.slidesToScroll,
            e = 2 * c.slideCount); e > p; )
                l.push(p),
                p = i + c.options.slidesToScroll,
                i += c.options.slidesToScroll <= c.options.slidesToShow ? c.options.slidesToScroll : c.options.slidesToShow;
            return l
        }
        ,
        w.prototype.getSlick = function() {
            return this
        }
        ,
        w.prototype.getSlideCount = function() {
            var e, c, p, i = this;
            return p = i.options.centerMode === !0 ? i.slideWidth * Math.floor(i.options.slidesToShow / 2) : 0,
            i.options.swipeToSlide === !0 ? (i.$slideTrack.find(".slick-slide").each(function(l, a) {
                return a.offsetLeft - p + d(a).outerWidth() / 2 > -1 * i.swipeLeft ? (c = a,
                !1) : void 0
            }),
            e = Math.abs(d(c).attr("data-slick-index") - i.currentSlide) || 1) : i.options.slidesToScroll
        }
        ,
        w.prototype.goTo = w.prototype.slickGoTo = function(e, c) {
            var p = this;
            p.changeSlide({
                data: {
                    message: "index",
                    index: parseInt(e)
                }
            }, c)
        }
        ,
        w.prototype.init = function(e) {
            var c = this;
            d(c.$slider).hasClass("slick-initialized") || (d(c.$slider).addClass("slick-initialized"),
            c.buildRows(),
            c.buildOut(),
            c.setProps(),
            c.startLoad(),
            c.loadSlider(),
            c.initializeEvents(),
            c.updateArrows(),
            c.updateDots(),
            c.checkResponsive(!0),
            c.focusHandler()),
            e && c.$slider.trigger("init", [c]),
            c.options.accessibility === !0 && c.initADA(),
            c.options.autoplay && (c.paused = !1,
            c.autoPlay())
        }
        ,
        w.prototype.initADA = function() {
            var e = this;
            e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({
                "aria-hidden": "true",
                tabindex: "-1"
            }).find("a, input, button, select").attr({
                tabindex: "-1"
            }),
            e.$slideTrack.attr("role", "listbox"),
            e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(c) {
                d(this).attr({
                    role: "option"
                })
            }),
            e.$dots !== null && e.$dots.attr("aria-hidden", "true").find("li").each(function(c) {
                d(this).attr({
                    role: "presentation",
                    "aria-selected": "false",
                    "aria-controls": "navigation" + e.instanceUid + c,
                    id: "slick-slide" + e.instanceUid + c
                })
            }).first().attr("aria-selected", "true").end().find("button").attr("role", "button").end().closest("div").attr("role", "toolbar"),
            e.activateADA()
        }
        ,
        w.prototype.initArrowEvents = function() {
            var e = this;
            e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && (e.$prevArrow.off("click.slick").on("click.slick", {
                message: "previous"
            }, e.changeSlide),
            e.$nextArrow.off("click.slick").on("click.slick", {
                message: "next"
            }, e.changeSlide))
        }
        ,
        w.prototype.initDotEvents = function() {
            var e = this;
            e.options.dots === !0 && e.slideCount > e.options.slidesToShow && d("li", e.$dots).on("click.slick", {
                message: "index"
            }, e.changeSlide),
            e.options.dots === !0 && e.options.pauseOnDotsHover === !0 && d("li", e.$dots).on("mouseenter.slick", d.proxy(e.interrupt, e, !0)).on("mouseleave.slick", d.proxy(e.interrupt, e, !1))
        }
        ,
        w.prototype.initSlideEvents = function() {
            var e = this;
            e.options.pauseOnHover && (e.$list.on("mouseenter.slick", d.proxy(e.interrupt, e, !0)),
            e.$list.on("mouseleave.slick", d.proxy(e.interrupt, e, !1)))
        }
        ,
        w.prototype.initializeEvents = function() {
            var e = this;
            e.initArrowEvents(),
            e.initDotEvents(),
            e.initSlideEvents(),
            e.$list.on("touchstart.slick mousedown.slick", {
                action: "start"
            }, e.swipeHandler),
            e.$list.on("touchmove.slick mousemove.slick", {
                action: "move"
            }, e.swipeHandler),
            e.$list.on("touchend.slick mouseup.slick", {
                action: "end"
            }, e.swipeHandler),
            e.$list.on("touchcancel.slick mouseleave.slick", {
                action: "end"
            }, e.swipeHandler),
            e.$list.on("click.slick", e.clickHandler),
            d(document).on(e.visibilityChange, d.proxy(e.visibility, e)),
            e.options.accessibility === !0 && e.$list.on("keydown.slick", e.keyHandler),
            e.options.focusOnSelect === !0 && d(e.$slideTrack).children().on("click.slick", e.selectHandler),
            d(window).on("orientationchange.slick.slick-" + e.instanceUid, d.proxy(e.orientationChange, e)),
            d(window).on("resize.slick.slick-" + e.instanceUid, d.proxy(e.resize, e)),
            d("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault),
            d(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
            d(document).on("ready.slick.slick-" + e.instanceUid, e.setPosition)
        }
        ,
        w.prototype.initUI = function() {
            var e = this;
            e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && (e.$prevArrow.show(),
            e.$nextArrow.show()),
            e.options.dots === !0 && e.slideCount > e.options.slidesToShow && e.$dots.show()
        }
        ,
        w.prototype.keyHandler = function(e) {
            var c = this;
            e.target.tagName.match("TEXTAREA|INPUT|SELECT") || (e.keyCode === 37 && c.options.accessibility === !0 ? c.changeSlide({
                data: {
                    message: c.options.rtl === !0 ? "next" : "previous"
                }
            }) : e.keyCode === 39 && c.options.accessibility === !0 && c.changeSlide({
                data: {
                    message: c.options.rtl === !0 ? "previous" : "next"
                }
            }))
        }
        ,
        w.prototype.lazyLoad = function() {
            function e(g) {
                d("img[data-lazy]", g).each(function() {
                    var S = d(this)
                      , T = d(this).attr("data-lazy")
                      , y = document.createElement("img");
                    y.onload = function() {
                        S.animate({
                            opacity: 0
                        }, 100, function() {
                            S.attr("src", T).animate({
                                opacity: 1
                            }, 200, function() {
                                S.removeAttr("data-lazy").removeClass("slick-loading")
                            }),
                            a.$slider.trigger("lazyLoaded", [a, S, T])
                        })
                    }
                    ,
                    y.onerror = function() {
                        S.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
                        a.$slider.trigger("lazyLoadError", [a, S, T])
                    }
                    ,
                    y.src = T
                })
            }
            var c, p, i, l, a = this;
            a.options.centerMode === !0 ? a.options.infinite === !0 ? (i = a.currentSlide + (a.options.slidesToShow / 2 + 1),
            l = i + a.options.slidesToShow + 2) : (i = Math.max(0, a.currentSlide - (a.options.slidesToShow / 2 + 1)),
            l = 2 + (a.options.slidesToShow / 2 + 1) + a.currentSlide) : (i = a.options.infinite ? a.options.slidesToShow + a.currentSlide : a.currentSlide,
            l = Math.ceil(i + a.options.slidesToShow),
            a.options.fade === !0 && (i > 0 && i--,
            l <= a.slideCount && l++)),
            c = a.$slider.find(".slick-slide").slice(i, l),
            e(c),
            a.slideCount <= a.options.slidesToShow ? (p = a.$slider.find(".slick-slide"),
            e(p)) : a.currentSlide >= a.slideCount - a.options.slidesToShow ? (p = a.$slider.find(".slick-cloned").slice(0, a.options.slidesToShow),
            e(p)) : a.currentSlide === 0 && (p = a.$slider.find(".slick-cloned").slice(-1 * a.options.slidesToShow),
            e(p))
        }
        ,
        w.prototype.loadSlider = function() {
            var e = this;
            e.setPosition(),
            e.$slideTrack.css({
                opacity: 1
            }),
            e.$slider.removeClass("slick-loading"),
            e.initUI(),
            e.options.lazyLoad === "progressive" && e.progressiveLazyLoad()
        }
        ,
        w.prototype.next = w.prototype.slickNext = function() {
            var e = this;
            e.changeSlide({
                data: {
                    message: "next"
                }
            })
        }
        ,
        w.prototype.orientationChange = function() {
            var e = this;
            e.checkResponsive(),
            e.setPosition()
        }
        ,
        w.prototype.pause = w.prototype.slickPause = function() {
            var e = this;
            e.autoPlayClear(),
            e.paused = !0
        }
        ,
        w.prototype.play = w.prototype.slickPlay = function() {
            var e = this;
            e.autoPlay(),
            e.options.autoplay = !0,
            e.paused = !1,
            e.focussed = !1,
            e.interrupted = !1
        }
        ,
        w.prototype.postSlide = function(e) {
            var c = this;
            c.unslicked || (c.$slider.trigger("afterChange", [c, e]),
            c.animating = !1,
            c.setPosition(),
            c.swipeLeft = null,
            c.options.autoplay && c.autoPlay(),
            c.options.accessibility === !0 && c.initADA())
        }
        ,
        w.prototype.prev = w.prototype.slickPrev = function() {
            var e = this;
            e.changeSlide({
                data: {
                    message: "previous"
                }
            })
        }
        ,
        w.prototype.preventDefault = function(e) {
            e.preventDefault()
        }
        ,
        w.prototype.progressiveLazyLoad = function(e) {
            e = e || 1;
            var c, p, i, l = this, a = d("img[data-lazy]", l.$slider);
            a.length ? (c = a.first(),
            p = c.attr("data-lazy"),
            i = document.createElement("img"),
            i.onload = function() {
                c.attr("src", p).removeAttr("data-lazy").removeClass("slick-loading"),
                l.options.adaptiveHeight === !0 && l.setPosition(),
                l.$slider.trigger("lazyLoaded", [l, c, p]),
                l.progressiveLazyLoad()
            }
            ,
            i.onerror = function() {
                3 > e ? setTimeout(function() {
                    l.progressiveLazyLoad(e + 1)
                }, 500) : (c.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
                l.$slider.trigger("lazyLoadError", [l, c, p]),
                l.progressiveLazyLoad())
            }
            ,
            i.src = p) : l.$slider.trigger("allImagesLoaded", [l])
        }
        ,
        w.prototype.refresh = function(e) {
            var c, p, i = this;
            p = i.slideCount - i.options.slidesToShow,
            !i.options.infinite && i.currentSlide > p && (i.currentSlide = p),
            i.slideCount <= i.options.slidesToShow && (i.currentSlide = 0),
            c = i.currentSlide,
            i.destroy(!0),
            d.extend(i, i.initials, {
                currentSlide: c
            }),
            i.init(),
            e || i.changeSlide({
                data: {
                    message: "index",
                    index: c
                }
            }, !1)
        }
        ,
        w.prototype.registerBreakpoints = function() {
            var e, c, p, i = this, l = i.options.responsive || null;
            if (d.type(l) === "array" && l.length) {
                i.respondTo = i.options.respondTo || "window";
                for (e in l)
                    if (p = i.breakpoints.length - 1,
                    c = l[e].breakpoint,
                    l.hasOwnProperty(e)) {
                        for (; p >= 0; )
                            i.breakpoints[p] && i.breakpoints[p] === c && i.breakpoints.splice(p, 1),
                            p--;
                        i.breakpoints.push(c),
                        i.breakpointSettings[c] = l[e].settings
                    }
                i.breakpoints.sort(function(a, g) {
                    return i.options.mobileFirst ? a - g : g - a
                })
            }
        }
        ,
        w.prototype.reinit = function() {
            var e = this;
            e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"),
            e.slideCount = e.$slides.length,
            e.currentSlide >= e.slideCount && e.currentSlide !== 0 && (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
            e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
            e.registerBreakpoints(),
            e.setProps(),
            e.setupInfinite(),
            e.buildArrows(),
            e.updateArrows(),
            e.initArrowEvents(),
            e.buildDots(),
            e.updateDots(),
            e.initDotEvents(),
            e.cleanUpSlideEvents(),
            e.initSlideEvents(),
            e.checkResponsive(!1, !0),
            e.options.focusOnSelect === !0 && d(e.$slideTrack).children().on("click.slick", e.selectHandler),
            e.setSlideClasses(typeof e.currentSlide == "number" ? e.currentSlide : 0),
            e.setPosition(),
            e.focusHandler(),
            e.paused = !e.options.autoplay,
            e.autoPlay(),
            e.$slider.trigger("reInit", [e])
        }
        ,
        w.prototype.resize = function() {
            var e = this;
            d(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay),
            e.windowDelay = window.setTimeout(function() {
                e.windowWidth = d(window).width(),
                e.checkResponsive(),
                e.unslicked || e.setPosition()
            }, 50))
        }
        ,
        w.prototype.removeSlide = w.prototype.slickRemove = function(e, c, p) {
            var i = this;
            return typeof e == "boolean" ? (c = e,
            e = c === !0 ? 0 : i.slideCount - 1) : e = c === !0 ? --e : e,
            i.slideCount < 1 || 0 > e || e > i.slideCount - 1 ? !1 : (i.unload(),
            p === !0 ? i.$slideTrack.children().remove() : i.$slideTrack.children(this.options.slide).eq(e).remove(),
            i.$slides = i.$slideTrack.children(this.options.slide),
            i.$slideTrack.children(this.options.slide).detach(),
            i.$slideTrack.append(i.$slides),
            i.$slidesCache = i.$slides,
            void i.reinit())
        }
        ,
        w.prototype.setCSS = function(e) {
            var c, p, i = this, l = {};
            i.options.rtl === !0 && (e = -e),
            c = i.positionProp == "left" ? Math.ceil(e) + "px" : "0px",
            p = i.positionProp == "top" ? Math.ceil(e) + "px" : "0px",
            l[i.positionProp] = e,
            i.transformsEnabled === !1 ? i.$slideTrack.css(l) : (l = {},
            i.cssTransitions === !1 ? (l[i.animType] = "translate(" + c + ", " + p + ")",
            i.$slideTrack.css(l)) : (l[i.animType] = "translate3d(" + c + ", " + p + ", 0px)",
            i.$slideTrack.css(l)))
        }
        ,
        w.prototype.setDimensions = function() {
            var e = this;
            e.options.vertical === !1 ? e.options.centerMode === !0 && e.$list.css({
                padding: "0px " + e.options.centerPadding
            }) : (e.$list.height(e.$slides.first().outerHeight(!0) * e.options.slidesToShow),
            e.options.centerMode === !0 && e.$list.css({
                padding: e.options.centerPadding + " 0px"
            })),
            e.listWidth = e.$list.width(),
            e.listHeight = e.$list.height(),
            e.options.vertical === !1 && e.options.variableWidth === !1 ? (e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow),
            e.$slideTrack.width(Math.ceil(e.slideWidth * e.$slideTrack.children(".slick-slide").length))) : e.options.variableWidth === !0 ? e.$slideTrack.width(5e3 * e.slideCount) : (e.slideWidth = Math.ceil(e.listWidth),
            e.$slideTrack.height(Math.ceil(e.$slides.first().outerHeight(!0) * e.$slideTrack.children(".slick-slide").length)));
            var c = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
            e.options.variableWidth === !1 && e.$slideTrack.children(".slick-slide").width(e.slideWidth - c)
        }
        ,
        w.prototype.setFade = function() {
            var e, c = this;
            c.$slides.each(function(p, i) {
                e = c.slideWidth * p * -1,
                c.options.rtl === !0 ? d(i).css({
                    position: "relative",
                    right: e,
                    top: 0,
                    zIndex: c.options.zIndex - 2,
                    opacity: 0
                }) : d(i).css({
                    position: "relative",
                    left: e,
                    top: 0,
                    zIndex: c.options.zIndex - 2,
                    opacity: 0
                })
            }),
            c.$slides.eq(c.currentSlide).css({
                zIndex: c.options.zIndex - 1,
                opacity: 1
            })
        }
        ,
        w.prototype.setHeight = function() {
            var e = this;
            if (e.options.slidesToShow === 1 && e.options.adaptiveHeight === !0 && e.options.vertical === !1) {
                var c = e.$slides.eq(e.currentSlide).outerHeight(!0);
                e.$list.css("height", c)
            }
        }
        ,
        w.prototype.setOption = w.prototype.slickSetOption = function() {
            var e, c, p, i, l, a = this, g = !1;
            if (d.type(arguments[0]) === "object" ? (p = arguments[0],
            g = arguments[1],
            l = "multiple") : d.type(arguments[0]) === "string" && (p = arguments[0],
            i = arguments[1],
            g = arguments[2],
            arguments[0] === "responsive" && d.type(arguments[1]) === "array" ? l = "responsive" : typeof arguments[1] != "undefined" && (l = "single")),
            l === "single")
                a.options[p] = i;
            else if (l === "multiple")
                d.each(p, function(S, T) {
                    a.options[S] = T
                });
            else if (l === "responsive")
                for (c in i)
                    if (d.type(a.options.responsive) !== "array")
                        a.options.responsive = [i[c]];
                    else {
                        for (e = a.options.responsive.length - 1; e >= 0; )
                            a.options.responsive[e].breakpoint === i[c].breakpoint && a.options.responsive.splice(e, 1),
                            e--;
                        a.options.responsive.push(i[c])
                    }
            g && (a.unload(),
            a.reinit())
        }
        ,
        w.prototype.setPosition = function() {
            var e = this;
            e.setDimensions(),
            e.setHeight(),
            e.options.fade === !1 ? e.setCSS(e.getLeft(e.currentSlide)) : e.setFade(),
            e.$slider.trigger("setPosition", [e])
        }
        ,
        w.prototype.setProps = function() {
            var e = this
              , c = document.body.style;
            e.positionProp = e.options.vertical === !0 ? "top" : "left",
            e.positionProp === "top" ? e.$slider.addClass("slick-vertical") : e.$slider.removeClass("slick-vertical"),
            (c.WebkitTransition !== void 0 || c.MozTransition !== void 0 || c.msTransition !== void 0) && e.options.useCSS === !0 && (e.cssTransitions = !0),
            e.options.fade && (typeof e.options.zIndex == "number" ? e.options.zIndex < 3 && (e.options.zIndex = 3) : e.options.zIndex = e.defaults.zIndex),
            c.OTransform !== void 0 && (e.animType = "OTransform",
            e.transformType = "-o-transform",
            e.transitionType = "OTransition",
            c.perspectiveProperty === void 0 && c.webkitPerspective === void 0 && (e.animType = !1)),
            c.MozTransform !== void 0 && (e.animType = "MozTransform",
            e.transformType = "-moz-transform",
            e.transitionType = "MozTransition",
            c.perspectiveProperty === void 0 && c.MozPerspective === void 0 && (e.animType = !1)),
            c.webkitTransform !== void 0 && (e.animType = "webkitTransform",
            e.transformType = "-webkit-transform",
            e.transitionType = "webkitTransition",
            c.perspectiveProperty === void 0 && c.webkitPerspective === void 0 && (e.animType = !1)),
            c.msTransform !== void 0 && (e.animType = "msTransform",
            e.transformType = "-ms-transform",
            e.transitionType = "msTransition",
            c.msTransform === void 0 && (e.animType = !1)),
            c.transform !== void 0 && e.animType !== !1 && (e.animType = "transform",
            e.transformType = "transform",
            e.transitionType = "transition"),
            e.transformsEnabled = e.options.useTransform && e.animType !== null && e.animType !== !1
        }
        ,
        w.prototype.setSlideClasses = function(e) {
            var c, p, i, l, a = this;
            p = a.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"),
            a.$slides.eq(e).addClass("slick-current"),
            a.options.centerMode === !0 ? (c = Math.floor(a.options.slidesToShow / 2),
            a.options.infinite === !0 && (e >= c && e <= a.slideCount - 1 - c ? a.$slides.slice(e - c, e + c + 1).addClass("slick-active").attr("aria-hidden", "false") : (i = a.options.slidesToShow + e,
            p.slice(i - c + 1, i + c + 2).addClass("slick-active").attr("aria-hidden", "false")),
            e === 0 ? p.eq(p.length - 1 - a.options.slidesToShow).addClass("slick-center") : e === a.slideCount - 1 && p.eq(a.options.slidesToShow).addClass("slick-center")),
            a.$slides.eq(e).addClass("slick-center")) : e >= 0 && e <= a.slideCount - a.options.slidesToShow ? a.$slides.slice(e, e + a.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : p.length <= a.options.slidesToShow ? p.addClass("slick-active").attr("aria-hidden", "false") : (l = a.slideCount % a.options.slidesToShow,
            i = a.options.infinite === !0 ? a.options.slidesToShow + e : e,
            a.options.slidesToShow == a.options.slidesToScroll && a.slideCount - e < a.options.slidesToShow ? p.slice(i - (a.options.slidesToShow - l), i + l).addClass("slick-active").attr("aria-hidden", "false") : p.slice(i, i + a.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false")),
            a.options.lazyLoad === "ondemand" && a.lazyLoad()
        }
        ,
        w.prototype.setupInfinite = function() {
            var e, c, p, i = this;
            if (i.options.fade === !0 && (i.options.centerMode = !1),
            i.options.infinite === !0 && i.options.fade === !1 && (c = null,
            i.slideCount > i.options.slidesToShow)) {
                for (p = i.options.centerMode === !0 ? i.options.slidesToShow + 1 : i.options.slidesToShow,
                e = i.slideCount; e > i.slideCount - p; e -= 1)
                    c = e - 1,
                    d(i.$slides[c]).clone(!0).attr("id", "").attr("data-slick-index", c - i.slideCount).prependTo(i.$slideTrack).addClass("slick-cloned");
                for (e = 0; p > e; e += 1)
                    c = e,
                    d(i.$slides[c]).clone(!0).attr("id", "").attr("data-slick-index", c + i.slideCount).appendTo(i.$slideTrack).addClass("slick-cloned");
                i.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                    d(this).attr("id", "")
                })
            }
        }
        ,
        w.prototype.interrupt = function(e) {
            var c = this;
            e || c.autoPlay(),
            c.interrupted = e
        }
        ,
        w.prototype.selectHandler = function(e) {
            var c = this
              , p = d(e.target).is(".slick-slide") ? d(e.target) : d(e.target).parents(".slick-slide")
              , i = parseInt(p.attr("data-slick-index"));
            return i || (i = 0),
            c.slideCount <= c.options.slidesToShow ? (c.setSlideClasses(i),
            void c.asNavFor(i)) : void c.slideHandler(i)
        }
        ,
        w.prototype.slideHandler = function(e, c, p) {
            var i, l, a, g, S, T = null, y = this;
            return c = c || !1,
            y.animating === !0 && y.options.waitForAnimate === !0 || y.options.fade === !0 && y.currentSlide === e || y.slideCount <= y.options.slidesToShow ? void 0 : (c === !1 && y.asNavFor(e),
            i = e,
            T = y.getLeft(i),
            g = y.getLeft(y.currentSlide),
            y.currentLeft = y.swipeLeft === null ? g : y.swipeLeft,
            y.options.infinite === !1 && y.options.centerMode === !1 && (0 > e || e > y.getDotCount() * y.options.slidesToScroll) ? void (y.options.fade === !1 && (i = y.currentSlide,
            p !== !0 ? y.animateSlide(g, function() {
                y.postSlide(i)
            }) : y.postSlide(i))) : y.options.infinite === !1 && y.options.centerMode === !0 && (0 > e || e > y.slideCount - y.options.slidesToScroll) ? void (y.options.fade === !1 && (i = y.currentSlide,
            p !== !0 ? y.animateSlide(g, function() {
                y.postSlide(i)
            }) : y.postSlide(i))) : (y.options.autoplay && clearInterval(y.autoPlayTimer),
            l = 0 > i ? y.slideCount % y.options.slidesToScroll !== 0 ? y.slideCount - y.slideCount % y.options.slidesToScroll : y.slideCount + i : i >= y.slideCount ? y.slideCount % y.options.slidesToScroll !== 0 ? 0 : i - y.slideCount : i,
            y.animating = !0,
            y.$slider.trigger("beforeChange", [y, y.currentSlide, l]),
            a = y.currentSlide,
            y.currentSlide = l,
            y.setSlideClasses(y.currentSlide),
            y.options.asNavFor && (S = y.getNavTarget(),
            S = S.slick("getSlick"),
            S.slideCount <= S.options.slidesToShow && S.setSlideClasses(y.currentSlide)),
            y.updateDots(),
            y.updateArrows(),
            y.options.fade === !0 ? (p !== !0 ? (y.fadeSlideOut(a),
            y.fadeSlide(l, function() {
                y.postSlide(l)
            })) : y.postSlide(l),
            void y.animateHeight()) : void (p !== !0 ? y.animateSlide(T, function() {
                y.postSlide(l)
            }) : y.postSlide(l))))
        }
        ,
        w.prototype.startLoad = function() {
            var e = this;
            e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && (e.$prevArrow.hide(),
            e.$nextArrow.hide()),
            e.options.dots === !0 && e.slideCount > e.options.slidesToShow && e.$dots.hide(),
            e.$slider.addClass("slick-loading")
        }
        ,
        w.prototype.swipeDirection = function() {
            var e, c, p, i, l = this;
            return e = l.touchObject.startX - l.touchObject.curX,
            c = l.touchObject.startY - l.touchObject.curY,
            p = Math.atan2(c, e),
            i = Math.round(180 * p / Math.PI),
            0 > i && (i = 360 - Math.abs(i)),
            45 >= i && i >= 0 || 360 >= i && i >= 315 ? l.options.rtl === !1 ? "left" : "right" : i >= 135 && 225 >= i ? l.options.rtl === !1 ? "right" : "left" : l.options.verticalSwiping === !0 ? i >= 35 && 135 >= i ? "down" : "up" : "vertical"
        }
        ,
        w.prototype.swipeEnd = function(e) {
            var c, p, i = this;
            if (i.dragging = !1,
            i.interrupted = !1,
            i.shouldClick = !(i.touchObject.swipeLength > 10),
            i.touchObject.curX === void 0)
                return !1;
            if (i.touchObject.edgeHit === !0 && i.$slider.trigger("edge", [i, i.swipeDirection()]),
            i.touchObject.swipeLength >= i.touchObject.minSwipe) {
                switch (p = i.swipeDirection()) {
                case "left":
                case "down":
                    c = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide + i.getSlideCount()) : i.currentSlide + i.getSlideCount(),
                    i.currentDirection = 0;
                    break;
                case "right":
                case "up":
                    c = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide - i.getSlideCount()) : i.currentSlide - i.getSlideCount(),
                    i.currentDirection = 1
                }
                p != "vertical" && (i.slideHandler(c),
                i.touchObject = {},
                i.$slider.trigger("swipe", [i, p]))
            } else
                i.touchObject.startX !== i.touchObject.curX && (i.slideHandler(i.currentSlide),
                i.touchObject = {})
        }
        ,
        w.prototype.swipeHandler = function(e) {
            var c = this;
            if (!(c.options.swipe === !1 || "ontouchend"in document && c.options.swipe === !1 || c.options.draggable === !1 && e.type.indexOf("mouse") !== -1))
                switch (c.touchObject.fingerCount = e.originalEvent && e.originalEvent.touches !== void 0 ? e.originalEvent.touches.length : 1,
                c.touchObject.minSwipe = c.listWidth / c.options.touchThreshold,
                c.options.verticalSwiping === !0 && (c.touchObject.minSwipe = c.listHeight / c.options.touchThreshold),
                e.data.action) {
                case "start":
                    c.swipeStart(e);
                    break;
                case "move":
                    c.swipeMove(e);
                    break;
                case "end":
                    c.swipeEnd(e)
                }
        }
        ,
        w.prototype.swipeMove = function(e) {
            var c, p, i, l, a, g = this;
            return a = e.originalEvent !== void 0 ? e.originalEvent.touches : null,
            !g.dragging || a && a.length !== 1 ? !1 : (c = g.getLeft(g.currentSlide),
            g.touchObject.curX = a !== void 0 ? a[0].pageX : e.clientX,
            g.touchObject.curY = a !== void 0 ? a[0].pageY : e.clientY,
            g.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(g.touchObject.curX - g.touchObject.startX, 2))),
            g.options.verticalSwiping === !0 && (g.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(g.touchObject.curY - g.touchObject.startY, 2)))),
            p = g.swipeDirection(),
            p !== "vertical" ? (e.originalEvent !== void 0 && g.touchObject.swipeLength > 4 && e.preventDefault(),
            l = (g.options.rtl === !1 ? 1 : -1) * (g.touchObject.curX > g.touchObject.startX ? 1 : -1),
            g.options.verticalSwiping === !0 && (l = g.touchObject.curY > g.touchObject.startY ? 1 : -1),
            i = g.touchObject.swipeLength,
            g.touchObject.edgeHit = !1,
            g.options.infinite === !1 && (g.currentSlide === 0 && p === "right" || g.currentSlide >= g.getDotCount() && p === "left") && (i = g.touchObject.swipeLength * g.options.edgeFriction,
            g.touchObject.edgeHit = !0),
            g.options.vertical === !1 ? g.swipeLeft = c + i * l : g.swipeLeft = c + i * (g.$list.height() / g.listWidth) * l,
            g.options.verticalSwiping === !0 && (g.swipeLeft = c + i * l),
            g.options.fade === !0 || g.options.touchMove === !1 ? !1 : g.animating === !0 ? (g.swipeLeft = null,
            !1) : void g.setCSS(g.swipeLeft)) : void 0)
        }
        ,
        w.prototype.swipeStart = function(e) {
            var c, p = this;
            return p.interrupted = !0,
            p.touchObject.fingerCount !== 1 || p.slideCount <= p.options.slidesToShow ? (p.touchObject = {},
            !1) : (e.originalEvent !== void 0 && e.originalEvent.touches !== void 0 && (c = e.originalEvent.touches[0]),
            p.touchObject.startX = p.touchObject.curX = c !== void 0 ? c.pageX : e.clientX,
            p.touchObject.startY = p.touchObject.curY = c !== void 0 ? c.pageY : e.clientY,
            void (p.dragging = !0))
        }
        ,
        w.prototype.unfilterSlides = w.prototype.slickUnfilter = function() {
            var e = this;
            e.$slidesCache !== null && (e.unload(),
            e.$slideTrack.children(this.options.slide).detach(),
            e.$slidesCache.appendTo(e.$slideTrack),
            e.reinit())
        }
        ,
        w.prototype.unload = function() {
            var e = this;
            d(".slick-cloned", e.$slider).remove(),
            e.$dots && e.$dots.remove(),
            e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(),
            e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(),
            e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
        }
        ,
        w.prototype.unslick = function(e) {
            var c = this;
            c.$slider.trigger("unslick", [c, e]),
            c.destroy()
        }
        ,
        w.prototype.updateArrows = function() {
            var e, c = this;
            e = Math.floor(c.options.slidesToShow / 2),
            c.options.arrows === !0 && c.slideCount > c.options.slidesToShow && !c.options.infinite && (c.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
            c.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
            c.currentSlide === 0 ? (c.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
            c.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : (c.currentSlide >= c.slideCount - c.options.slidesToShow && c.options.centerMode === !1 || c.currentSlide >= c.slideCount - 1 && c.options.centerMode === !0) && (c.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"),
            c.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
        }
        ,
        w.prototype.updateDots = function() {
            var e = this;
            e.$dots !== null && (e.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"),
            e.$dots.find("li").eq(Math.floor(e.currentSlide / e.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden", "false"))
        }
        ,
        w.prototype.visibility = function() {
            var e = this;
            e.options.autoplay && (document[e.hidden] ? e.interrupted = !0 : e.interrupted = !1)
        }
        ,
        d.fn.slick = function() {
            var e, c, p = this, i = arguments[0], l = Array.prototype.slice.call(arguments, 1), a = p.length;
            for (e = 0; a > e; e++)
                if (_typeof(i) == "object" || typeof i == "undefined" ? p[e].slick = new w(p[e],i) : c = p[e].slick[i].apply(p[e].slick, l),
                typeof c != "undefined")
                    return c;
            return p
        }
    }),
    jQuery.cookie = function(d, w, e) {
        if (typeof w != "undefined") {
            e = e || {},
            w === null && (w = "",
            e.expires = -1);
            var c = "";
            if (e.expires && (typeof e.expires == "number" || e.expires.toUTCString)) {
                var p;
                typeof e.expires == "number" ? (p = new Date,
                p.setTime(p.getTime() + e.expires * 24 * 60 * 60 * 1e3)) : p = e.expires,
                c = "; expires=" + p.toUTCString()
            }
            var i = e.path ? "; path=" + e.path : ""
              , l = e.domain ? "; domain=" + e.domain : ""
              , a = e.secure ? "; secure" : "";
            document.cookie = [d, "=", encodeURIComponent(w), c, i, l, a].join("")
        } else {
            var g = null;
            if (document.cookie && document.cookie != "")
                for (var S = document.cookie.split(";"), T = 0; T < S.length; T++) {
                    var y = jQuery.trim(S[T]);
                    if (y.substring(0, d.length + 1) == d + "=") {
                        g = decodeURIComponent(y.substring(d.length + 1));
                        break
                    }
                }
            return g
        }
    }
    ,
    window.Modernizr = function(d, w, e) {
        function c(R) {
            K.cssText = R
        }
        function p(R, P) {
            return c(prefixes.join(R + ";") + (P || ""))
        }
        function i(R, P) {
            return _typeof(R) === P
        }
        function l(R, P) {
            return !!~("" + R).indexOf(P)
        }
        function a(R, P) {
            for (var O in R) {
                var q = R[O];
                if (!l(q, "-") && K[q] !== e)
                    return P == "pfx" ? q : !0
            }
            return !1
        }
        function g(R, P, O) {
            for (var q in R) {
                var Q = P[R[q]];
                if (Q !== e)
                    return O === !1 ? R[q] : i(Q, "function") ? Q.bind(O || P) : Q
            }
            return !1
        }
        function S(R, P, O) {
            var q = R.charAt(0).toUpperCase() + R.slice(1)
              , Q = (R + " " + B.join(q + " ") + q).split(" ");
            return i(P, "string") || i(P, "undefined") ? a(Q, P) : (Q = (R + " " + it.join(q + " ") + q).split(" "),
            g(Q, P, O))
        }
        function T() {
            A.input = function(R) {
                for (var P = 0, O = R.length; P < O; P++)
                    X[R[P]] = R[P]in U;
                return X.list && (X.list = !!w.createElement("datalist") && !!d.HTMLDataListElement),
                X
            }("autocomplete autofocus list placeholder max min multiple pattern required step".split(" "))
        }
        var y = "2.6.2", A = {}, j = w.documentElement, L = "modernizr", W = w.createElement(L), K = W.style, U = w.createElement("input"), r = {}.toString, ot = "Webkit Moz O ms", B = ot.split(" "), it = ot.toLowerCase().split(" "), yt = {}, Y = {}, X = {}, tt = [], ft = tt.slice, dt, V = {}.hasOwnProperty, nt;
        !i(V, "undefined") && !i(V.call, "undefined") ? nt = function(P, O) {
            return V.call(P, O)
        }
        : nt = function(P, O) {
            return O in P && i(P.constructor.prototype[O], "undefined")
        }
        ,
        Function.prototype.bind || (Function.prototype.bind = function(R) {
            var P = this;
            if (typeof P != "function")
                throw new TypeError;
            var O = ft.call(arguments, 1)
              , q = function Q() {
                if (this instanceof Q) {
                    var st = function() {};
                    st.prototype = P.prototype;
                    var J = new st
                      , gt = P.apply(J, O.concat(ft.call(arguments)));
                    return Object(gt) === gt ? gt : J
                }
                return P.apply(R, O.concat(ft.call(arguments)))
            };
            return q
        }
        ),
        yt.csstransitions = function() {
            return S("transition")
        }
        ;
        for (var ct in yt)
            nt(yt, ct) && (dt = ct.toLowerCase(),
            A[dt] = yt[ct](),
            tt.push((A[dt] ? "" : "no-") + dt));
        return A.input || T(),
        A.addTest = function(R, P) {
            if (_typeof(R) == "object")
                for (var O in R)
                    nt(R, O) && A.addTest(O, R[O]);
            else {
                if (R = R.toLowerCase(),
                A[R] !== e)
                    return A;
                P = typeof P == "function" ? P() : P,
                typeof enableClasses != "undefined" && enableClasses && (j.className += " " + (P ? "" : "no-") + R),
                A[R] = P
            }
            return A
        }
        ,
        c(""),
        W = U = null,
        A._version = y,
        A._domPrefixes = it,
        A._cssomPrefixes = B,
        A.testProp = function(R) {
            return a([R])
        }
        ,
        A.testAllProps = S,
        A
    }(this, this.document),
    function(d, w, e) {
        function c(V) {
            return j.call(V) == "[object Function]"
        }
        function p(V) {
            return typeof V == "string"
        }
        function i() {}
        function l(V) {
            return !V || V == "loaded" || V == "complete" || V == "uninitialized"
        }
        function a() {
            var V = L.shift();
            W = 1,
            V ? V.t ? y(function() {
                (V.t == "c" ? dt.injectCss : dt.injectJs)(V.s, 0, V.a, V.x, V.e, 1)
            }, 0) : (V(),
            a()) : W = 0
        }
        function g(V, nt, ct, R, P, O, st) {
            function Q(pt) {
                if (!gt && l(J.readyState) && (ht.r = gt = 1,
                !W && a(),
                J.onload = J.onreadystatechange = null,
                pt)) {
                    V != "img" && y(function() {
                        r.removeChild(J)
                    }, 50);
                    for (var kt in X[nt])
                        X[nt].hasOwnProperty(kt) && X[nt][kt].onload()
                }
            }
            var st = st || dt.errorTimeout
              , J = w.createElement(V)
              , gt = 0
              , wt = 0
              , ht = {
                t: ct,
                s: nt,
                e: P,
                a: O,
                x: st
            };
            X[nt] === 1 && (wt = 1,
            X[nt] = []),
            V == "object" ? J.data = nt : (J.src = nt,
            J.type = V),
            J.width = J.height = "0",
            J.onerror = J.onload = J.onreadystatechange = function() {
                Q.call(this, wt)
            }
            ,
            L.splice(R, 0, ht),
            V != "img" && (wt || X[nt] === 2 ? (r.insertBefore(J, U ? null : A),
            y(Q, st)) : X[nt].push(J))
        }
        function S(V, nt, ct, R, P) {
            return W = 0,
            nt = nt || "j",
            p(V) ? g(nt == "c" ? it : B, V, nt, this.i++, ct, R, P) : (L.splice(this.i++, 0, V),
            L.length == 1 && a()),
            this
        }
        function T() {
            var V = dt;
            return V.loader = {
                load: S,
                i: 0
            },
            V
        }
        var ot = w.documentElement, y = d.setTimeout, A = w.getElementsByTagName("script")[0], j = {}.toString, L = [], W = 0, K = "MozAppearance"in ot.style, U = K && !!w.createRange().compareNode, r = U ? ot : A.parentNode, ot = d.opera && j.call(d.opera) == "[object Opera]", ot = !!w.attachEvent && !ot, B = K ? "object" : ot ? "script" : "img", it = ot ? "script" : B, yt = Array.isArray || function(V) {
            return j.call(V) == "[object Array]"
        }
        , Y = [], X = {}, tt = {
            timeout: function(nt, ct) {
                return ct.length && (nt.timeout = ct[0]),
                nt
            }
        }, ft, dt;
        dt = function(nt) {
            function ct(J) {
                var J = J.split("!"), gt = Y.length, ht = J.pop(), wt = J.length, ht = {
                    url: ht,
                    origUrl: ht,
                    prefixes: J
                }, pt, kt, jt;
                for (kt = 0; kt < wt; kt++)
                    jt = J[kt].split("="),
                    (pt = tt[jt.shift()]) && (ht = pt(ht, jt));
                for (kt = 0; kt < gt; kt++)
                    ht = Y[kt](ht);
                return ht
            }
            function R(st, J, gt, wt, ht) {
                var pt = ct(st)
                  , kt = pt.autoCallback;
                pt.url.split(".").pop().split("?").shift(),
                pt.bypass || (J && (J = c(J) ? J : J[st] || J[wt] || J[st.split("/").pop().split("?")[0]]),
                pt.instead ? pt.instead(st, J, gt, wt, ht) : (X[pt.url] ? pt.noexec = !0 : X[pt.url] = 1,
                gt.load(pt.url, pt.forceCSS || !pt.forceJS && pt.url.split(".").pop().split("?").shift() == "css" ? "c" : e, pt.noexec, pt.attrs, pt.timeout),
                (c(J) || c(kt)) && gt.load(function() {
                    T(),
                    J && J(pt.origUrl, ht, wt),
                    kt && kt(pt.origUrl, ht, wt),
                    X[pt.url] = 2
                })))
            }
            function P(st, J) {
                function gt(at, Xt) {
                    if (at) {
                        if (p(at))
                            Xt || (pt = function() {
                                var fe = [].slice.call(arguments);
                                kt.apply(this, fe),
                                jt()
                            }
                            ),
                            R(at, pt, J, 0, wt);
                        else if (Object(at) === at)
                            for (ee in ce = function() {
                                var ye = 0, fe;
                                for (fe in at)
                                    at.hasOwnProperty(fe) && ye++;
                                return ye
                            }(),
                            at)
                                at.hasOwnProperty(ee) && (!Xt && !--ce && (c(pt) ? pt = function() {
                                    var fe = [].slice.call(arguments);
                                    kt.apply(this, fe),
                                    jt()
                                }
                                : pt[ee] = function(ye) {
                                    return function() {
                                        var fe = [].slice.call(arguments);
                                        ye && ye.apply(this, fe),
                                        jt()
                                    }
                                }(kt[ee])),
                                R(at[ee], pt, J, ee, wt))
                    } else
                        !Xt && jt()
                }
                var wt = !!st.test, ht = st.load || st.both, pt = st.callback || i, kt = pt, jt = st.complete || i, ce, ee;
                gt(wt ? st.yep : st.nope, !!ht),
                ht && gt(ht)
            }
            var O, q, Q = this.yepnope.loader;
            if (p(nt))
                R(nt, 0, Q, 0);
            else if (yt(nt))
                for (O = 0; O < nt.length; O++)
                    q = nt[O],
                    p(q) ? R(q, 0, Q, 0) : yt(q) ? dt(q) : Object(q) === q && P(q, Q);
            else
                Object(nt) === nt && P(nt, Q)
        }
        ,
        dt.addPrefix = function(V, nt) {
            tt[V] = nt
        }
        ,
        dt.addFilter = function(V) {
            Y.push(V)
        }
        ,
        dt.errorTimeout = 1e4,
        w.readyState == null && w.addEventListener && (w.readyState = "loading",
        w.addEventListener("DOMContentLoaded", ft = function() {
            w.removeEventListener("DOMContentLoaded", ft, 0),
            w.readyState = "complete"
        }
        , 0)),
        d.yepnope = T(),
        d.yepnope.executeStack = a,
        d.yepnope.injectJs = function(V, nt, ct, J, P, O) {
            var q = w.createElement("script"), Q, st, J = J || dt.errorTimeout;
            q.src = V;
            for (st in ct)
                q.setAttribute(st, ct[st]);
            nt = O ? a : nt || i,
            q.onreadystatechange = q.onload = function() {
                !Q && l(q.readyState) && (Q = 1,
                nt(),
                q.onload = q.onreadystatechange = null)
            }
            ,
            y(function() {
                Q || (Q = 1,
                nt(1))
            }, J),
            P ? q.onload() : A.parentNode.insertBefore(q, A)
        }
        ,
        d.yepnope.injectCss = function(V, st, ct, q, P, O) {
            var q = w.createElement("link"), Q, st = O ? a : st || i;
            q.href = V,
            q.rel = "stylesheet",
            q.type = "text/css";
            for (Q in ct)
                q.setAttribute(Q, ct[Q]);
            P || (A.parentNode.insertBefore(q, A),
            y(st, 0))
        }
    }(this, document),
    Modernizr.load = function() {
        yepnope.apply(window, [].slice.call(arguments, 0))
    }
    ,
    function() {
        var d = le.event, w, e, c = window.innerWidth;
        w = d.special.debouncedresize = {
            setup: function() {
                le(this).on("resize", w.handler)
            },
            teardown: function() {
                le(this).off("resize", w.handler)
            },
            handler: function(i, l) {
                var a = this
                  , g = arguments
                  , S = function() {
                    i.type = "debouncedresize",
                    d.dispatch.apply(a, g),
                    c !== window.innerWidth && (i.type = "debouncedresizewidth",
                    d.dispatch.apply(a, g),
                    c = window.innerWidth)
                };
                e && clearTimeout(e),
                l ? S() : e = setTimeout(S, w.threshold)
            },
            threshold: 150
        }
    }(),
    function(d, w, e, c) {
        function p(i, l) {
            this.settings = null,
            this.options = d.extend({}, p.Defaults, l),
            this.$element = d(i),
            this._handlers = {},
            this._plugins = {},
            this._supress = {},
            this._current = null,
            this._speed = null,
            this._coordinates = [],
            this._breakpoint = null,
            this._width = null,
            this._items = [],
            this._clones = [],
            this._mergers = [],
            this._widths = [],
            this._invalidated = {},
            this._pipe = [],
            this._drag = {
                time: null,
                target: null,
                pointer: null,
                stage: {
                    start: null,
                    current: null
                },
                direction: null
            },
            this._states = {
                current: {},
                tags: {
                    initializing: ["busy"],
                    animating: ["busy"],
                    dragging: ["interacting"]
                }
            },
            d.each(["onResize", "onThrottledResize"], d.proxy(function(a, g) {
                this._handlers[g] = d.proxy(this[g], this)
            }, this)),
            d.each(p.Plugins, d.proxy(function(a, g) {
                this._plugins[a.charAt(0).toLowerCase() + a.slice(1)] = new g(this)
            }, this)),
            d.each(p.Workers, d.proxy(function(a, g) {
                this._pipe.push({
                    filter: g.filter,
                    run: d.proxy(g.run, this)
                })
            }, this)),
            this.setup(),
            this.initialize()
        }
        p.Defaults = {
            items: 3,
            loop: !1,
            center: !1,
            rewind: !1,
            checkVisibility: !0,
            mouseDrag: !0,
            touchDrag: !0,
            pullDrag: !0,
            freeDrag: !1,
            margin: 0,
            stagePadding: 0,
            merge: !1,
            mergeFit: !0,
            autoWidth: !1,
            startPosition: 0,
            rtl: !1,
            smartSpeed: 250,
            fluidSpeed: !1,
            dragEndSpeed: !1,
            responsive: {},
            responsiveRefreshRate: 200,
            responsiveBaseElement: w,
            fallbackEasing: "swing",
            slideTransition: "",
            info: !1,
            nestedItemSelector: !1,
            itemElement: "div",
            stageElement: "div",
            refreshClass: "owl-refresh",
            loadedClass: "owl-loaded",
            loadingClass: "owl-loading",
            rtlClass: "owl-rtl",
            responsiveClass: "owl-responsive",
            dragClass: "owl-drag",
            itemClass: "owl-item",
            stageClass: "owl-stage",
            stageOuterClass: "owl-stage-outer",
            grabClass: "owl-grab"
        },
        p.Width = {
            Default: "default",
            Inner: "inner",
            Outer: "outer"
        },
        p.Type = {
            Event: "event",
            State: "state"
        },
        p.Plugins = {},
        p.Workers = [{
            filter: ["width", "settings"],
            run: function() {
                this._width = this.$element.width()
            }
        }, {
            filter: ["width", "items", "settings"],
            run: function(l) {
                l.current = this._items && this._items[this.relative(this._current)]
            }
        }, {
            filter: ["items", "settings"],
            run: function() {
                this.$stage.children(".cloned").remove()
            }
        }, {
            filter: ["width", "items", "settings"],
            run: function(l) {
                var a = this.settings.margin || ""
                  , g = !this.settings.autoWidth
                  , S = this.settings.rtl
                  , T = {
                    width: "auto",
                    "margin-left": S ? a : "",
                    "margin-right": S ? "" : a
                };
                !g && this.$stage.children().css(T),
                l.css = T
            }
        }, {
            filter: ["width", "items", "settings"],
            run: function(l) {
                var a = (this.width() / this.settings.items).toFixed(3) - this.settings.margin
                  , g = null
                  , S = this._items.length
                  , T = !this.settings.autoWidth
                  , y = [];
                for (l.items = {
                    merge: !1,
                    width: a
                }; S--; )
                    g = this._mergers[S],
                    g = this.settings.mergeFit && Math.min(g, this.settings.items) || g,
                    l.items.merge = g > 1 || l.items.merge,
                    y[S] = T ? a * g : this._items[S].width();
                this._widths = y
            }
        }, {
            filter: ["items", "settings"],
            run: function() {
                var l = []
                  , a = this._items
                  , g = this.settings
                  , S = Math.max(2 * g.items, 4)
                  , T = 2 * Math.ceil(a.length / 2)
                  , y = g.loop && a.length ? g.rewind ? S : Math.max(S, T) : 0
                  , A = ""
                  , j = "";
                for (y /= 2; y > 0; )
                    l.push(this.normalize(l.length / 2, !0)),
                    A += a[l[l.length - 1]][0].outerHTML,
                    l.push(this.normalize(a.length - 1 - (l.length - 1) / 2, !0)),
                    j = a[l[l.length - 1]][0].outerHTML + j,
                    y -= 1;
                this._clones = l,
                d(A).addClass("cloned").appendTo(this.$stage),
                d(j).addClass("cloned").prependTo(this.$stage)
            }
        }, {
            filter: ["width", "items", "settings"],
            run: function() {
                for (var l = this.settings.rtl ? 1 : -1, a = this._clones.length + this._items.length, g = -1, S = 0, T = 0, y = []; ++g < a; )
                    S = y[g - 1] || 0,
                    T = this._widths[this.relative(g)] + this.settings.margin,
                    y.push(S + T * l);
                this._coordinates = y
            }
        }, {
            filter: ["width", "items", "settings"],
            run: function() {
                var l = this.settings.stagePadding
                  , a = this._coordinates
                  , g = {
                    width: Math.ceil(Math.abs(a[a.length - 1])) + 2 * l,
                    "padding-left": l || "",
                    "padding-right": l || ""
                };
                this.$stage.css(g)
            }
        }, {
            filter: ["width", "items", "settings"],
            run: function(l) {
                var a = this._coordinates.length
                  , g = !this.settings.autoWidth
                  , S = this.$stage.children();
                if (g && l.items.merge)
                    for (; a--; )
                        l.css.width = this._widths[this.relative(a)],
                        S.eq(a).css(l.css);
                else
                    g && (l.css.width = l.items.width,
                    S.css(l.css))
            }
        }, {
            filter: ["items"],
            run: function() {
                this._coordinates.length < 1 && this.$stage.removeAttr("style")
            }
        }, {
            filter: ["width", "items", "settings"],
            run: function(l) {
                l.current = l.current ? this.$stage.children().index(l.current) : 0,
                l.current = Math.max(this.minimum(), Math.min(this.maximum(), l.current)),
                this.reset(l.current)
            }
        }, {
            filter: ["position"],
            run: function() {
                this.animate(this.coordinates(this._current))
            }
        }, {
            filter: ["width", "position", "items", "settings"],
            run: function() {
                var l, a, g, S, T = this.settings.rtl ? 1 : -1, y = 2 * this.settings.stagePadding, A = this.coordinates(this.current()) + y, j = A + this.width() * T, L = [];
                for (g = 0,
                S = this._coordinates.length; g < S; g++)
                    l = this._coordinates[g - 1] || 0,
                    a = Math.abs(this._coordinates[g]) + y * T,
                    (this.op(l, "<=", A) && this.op(l, ">", j) || this.op(a, "<", A) && this.op(a, ">", j)) && L.push(g);
                this.$stage.children(".active").removeClass("active"),
                this.$stage.children(":eq(" + L.join("), :eq(") + ")").addClass("active"),
                this.$stage.children(".center").removeClass("center"),
                this.settings.center && this.$stage.children().eq(this.current()).addClass("center")
            }
        }],
        p.prototype.initializeStage = function() {
            this.$stage = this.$element.find("." + this.settings.stageClass),
            this.$stage.length || (this.$element.addClass(this.options.loadingClass),
            this.$stage = d("<" + this.settings.stageElement + ">", {
                class: this.settings.stageClass
            }).wrap(d("<div/>", {
                class: this.settings.stageOuterClass
            })),
            this.$element.append(this.$stage.parent()))
        }
        ,
        p.prototype.initializeItems = function() {
            var i = this.$element.find(".owl-item");
            if (i.length)
                return this._items = i.get().map(function(l) {
                    return d(l)
                }),
                this._mergers = this._items.map(function() {
                    return 1
                }),
                void this.refresh();
            this.replace(this.$element.children().not(this.$stage.parent())),
            this.isVisible() ? this.refresh() : this.invalidate("width"),
            this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass)
        }
        ,
        p.prototype.initialize = function() {
            if (this.enter("initializing"),
            this.trigger("initialize"),
            this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl),
            this.settings.autoWidth && !this.is("pre-loading")) {
                var i, l, a;
                i = this.$element.find("img"),
                l = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : c,
                a = this.$element.children(l).width(),
                i.length && a <= 0 && this.preloadAutoWidthImages(i)
            }
            this.initializeStage(),
            this.initializeItems(),
            this.registerEventHandlers(),
            this.leave("initializing"),
            this.trigger("initialized")
        }
        ,
        p.prototype.isVisible = function() {
            return !this.settings.checkVisibility || this.$element.is(":visible")
        }
        ,
        p.prototype.setup = function() {
            var i = this.viewport()
              , l = this.options.responsive
              , a = -1
              , g = null;
            l ? (d.each(l, function(S) {
                S <= i && S > a && (a = Number(S))
            }),
            g = d.extend({}, this.options, l[a]),
            typeof g.stagePadding == "function" && (g.stagePadding = g.stagePadding()),
            delete g.responsive,
            g.responsiveClass && this.$element.attr("class", this.$element.attr("class").replace(new RegExp("(" + this.options.responsiveClass + "-)\\S+\\s","g"), "$1" + a))) : g = d.extend({}, this.options),
            this.trigger("change", {
                property: {
                    name: "settings",
                    value: g
                }
            }),
            this._breakpoint = a,
            this.settings = g,
            this.invalidate("settings"),
            this.trigger("changed", {
                property: {
                    name: "settings",
                    value: this.settings
                }
            })
        }
        ,
        p.prototype.optionsLogic = function() {
            this.settings.autoWidth && (this.settings.stagePadding = !1,
            this.settings.merge = !1)
        }
        ,
        p.prototype.prepare = function(i) {
            var l = this.trigger("prepare", {
                content: i
            });
            return l.data || (l.data = d("<" + this.settings.itemElement + "/>").addClass(this.options.itemClass).append(i)),
            this.trigger("prepared", {
                content: l.data
            }),
            l.data
        }
        ,
        p.prototype.update = function() {
            for (var i = 0, l = this._pipe.length, a = d.proxy(function(S) {
                return this[S]
            }, this._invalidated), g = {}; i < l; )
                (this._invalidated.all || d.grep(this._pipe[i].filter, a).length > 0) && this._pipe[i].run(g),
                i++;
            this._invalidated = {},
            !this.is("valid") && this.enter("valid")
        }
        ,
        p.prototype.width = function(i) {
            switch (i = i || p.Width.Default) {
            case p.Width.Inner:
            case p.Width.Outer:
                return this._width;
            default:
                return this._width - 2 * this.settings.stagePadding + this.settings.margin
            }
        }
        ,
        p.prototype.refresh = function() {
            this.enter("refreshing"),
            this.trigger("refresh"),
            this.setup(),
            this.optionsLogic(),
            this.$element.addClass(this.options.refreshClass),
            this.update(),
            this.$element.removeClass(this.options.refreshClass),
            this.leave("refreshing"),
            this.trigger("refreshed")
        }
        ,
        p.prototype.onThrottledResize = function() {
            w.clearTimeout(this.resizeTimer),
            this.resizeTimer = w.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate)
        }
        ,
        p.prototype.onResize = function() {
            return !!this._items.length && this._width !== this.$element.width() && !!this.isVisible() && (this.enter("resizing"),
            this.trigger("resize").isDefaultPrevented() ? (this.leave("resizing"),
            !1) : (this.invalidate("width"),
            this.refresh(),
            this.leave("resizing"),
            void this.trigger("resized")))
        }
        ,
        p.prototype.registerEventHandlers = function() {
            d.support.transition && this.$stage.on(d.support.transition.end + ".owl.core", d.proxy(this.onTransitionEnd, this)),
            this.settings.responsive !== !1 && this.on(w, "resize", this._handlers.onThrottledResize),
            this.settings.mouseDrag && (this.$element.addClass(this.options.dragClass),
            this.$stage.on("mousedown.owl.core", d.proxy(this.onDragStart, this)),
            this.$stage.on("dragstart.owl.core selectstart.owl.core", function() {
                return !1
            })),
            this.settings.touchDrag && (this.$stage.on("touchstart.owl.core", d.proxy(this.onDragStart, this)),
            this.$stage.on("touchcancel.owl.core", d.proxy(this.onDragEnd, this)))
        }
        ,
        p.prototype.onDragStart = function(i) {
            var l = null;
            i.which !== 3 && (d.support.transform ? (l = this.$stage.css("transform").replace(/.*\(|\)| /g, "").split(","),
            l = {
                x: l[l.length === 16 ? 12 : 4],
                y: l[l.length === 16 ? 13 : 5]
            }) : (l = this.$stage.position(),
            l = {
                x: this.settings.rtl ? l.left + this.$stage.width() - this.width() + this.settings.margin : l.left,
                y: l.top
            }),
            this.is("animating") && (d.support.transform ? this.animate(l.x) : this.$stage.stop(),
            this.invalidate("position")),
            this.$element.toggleClass(this.options.grabClass, i.type === "mousedown"),
            this.speed(0),
            this._drag.time = new Date().getTime(),
            this._drag.target = d(i.target),
            this._drag.stage.start = l,
            this._drag.stage.current = l,
            this._drag.pointer = this.pointer(i),
            d(e).on("mouseup.owl.core touchend.owl.core", d.proxy(this.onDragEnd, this)),
            d(e).one("mousemove.owl.core touchmove.owl.core", d.proxy(function(a) {
                var g = this.difference(this._drag.pointer, this.pointer(a));
                d(e).on("mousemove.owl.core touchmove.owl.core", d.proxy(this.onDragMove, this)),
                Math.abs(g.x) < Math.abs(g.y) && this.is("valid") || (a.preventDefault(),
                this.enter("dragging"),
                this.trigger("drag"))
            }, this)))
        }
        ,
        p.prototype.onDragMove = function(i) {
            var l = null
              , a = null
              , g = null
              , S = this.difference(this._drag.pointer, this.pointer(i))
              , T = this.difference(this._drag.stage.start, S);
            this.is("dragging") && (i.preventDefault(),
            this.settings.loop ? (l = this.coordinates(this.minimum()),
            a = this.coordinates(this.maximum() + 1) - l,
            T.x = ((T.x - l) % a + a) % a + l) : (l = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum()),
            a = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum()),
            g = this.settings.pullDrag ? -1 * S.x / 5 : 0,
            T.x = Math.max(Math.min(T.x, l + g), a + g)),
            this._drag.stage.current = T,
            this.animate(T.x))
        }
        ,
        p.prototype.onDragEnd = function(i) {
            var l = this.difference(this._drag.pointer, this.pointer(i))
              , a = this._drag.stage.current
              , g = l.x > 0 ^ this.settings.rtl ? "left" : "right";
            d(e).off(".owl.core"),
            this.$element.removeClass(this.options.grabClass),
            (l.x !== 0 && this.is("dragging") || !this.is("valid")) && (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed),
            this.current(this.closest(a.x, l.x !== 0 ? g : this._drag.direction)),
            this.invalidate("position"),
            this.update(),
            this._drag.direction = g,
            (Math.abs(l.x) > 3 || new Date().getTime() - this._drag.time > 300) && this._drag.target.one("click.owl.core", function() {
                return !1
            })),
            this.is("dragging") && (this.leave("dragging"),
            this.trigger("dragged"))
        }
        ,
        p.prototype.closest = function(i, l) {
            var a = -1
              , g = 30
              , S = this.width()
              , T = this.coordinates();
            return this.settings.freeDrag || d.each(T, d.proxy(function(y, A) {
                return l === "left" && i > A - g && i < A + g ? a = y : l === "right" && i > A - S - g && i < A - S + g ? a = y + 1 : this.op(i, "<", A) && this.op(i, ">", T[y + 1] !== c ? T[y + 1] : A - S) && (a = l === "left" ? y + 1 : y),
                a === -1
            }, this)),
            this.settings.loop || (this.op(i, ">", T[this.minimum()]) ? a = i = this.minimum() : this.op(i, "<", T[this.maximum()]) && (a = i = this.maximum())),
            a
        }
        ,
        p.prototype.animate = function(i) {
            var l = this.speed() > 0;
            this.is("animating") && this.onTransitionEnd(),
            l && (this.enter("animating"),
            this.trigger("translate")),
            d.support.transform3d && d.support.transition ? this.$stage.css({
                transform: "translate3d(" + i + "px,0px,0px)",
                transition: this.speed() / 1e3 + "s" + (this.settings.slideTransition ? " " + this.settings.slideTransition : "")
            }) : l ? this.$stage.animate({
                left: i + "px"
            }, this.speed(), this.settings.fallbackEasing, d.proxy(this.onTransitionEnd, this)) : this.$stage.css({
                left: i + "px"
            })
        }
        ,
        p.prototype.is = function(i) {
            return this._states.current[i] && this._states.current[i] > 0
        }
        ,
        p.prototype.current = function(i) {
            if (i === c)
                return this._current;
            if (this._items.length === 0)
                return c;
            if (i = this.normalize(i),
            this._current !== i) {
                var l = this.trigger("change", {
                    property: {
                        name: "position",
                        value: i
                    }
                });
                l.data !== c && (i = this.normalize(l.data)),
                this._current = i,
                this.invalidate("position"),
                this.trigger("changed", {
                    property: {
                        name: "position",
                        value: this._current
                    }
                })
            }
            return this._current
        }
        ,
        p.prototype.invalidate = function(i) {
            return d.type(i) === "string" && (this._invalidated[i] = !0,
            this.is("valid") && this.leave("valid")),
            d.map(this._invalidated, function(l, a) {
                return a
            })
        }
        ,
        p.prototype.reset = function(i) {
            (i = this.normalize(i)) !== c && (this._speed = 0,
            this._current = i,
            this.suppress(["translate", "translated"]),
            this.animate(this.coordinates(i)),
            this.release(["translate", "translated"]))
        }
        ,
        p.prototype.normalize = function(i, l) {
            var a = this._items.length
              , g = l ? 0 : this._clones.length;
            return !this.isNumeric(i) || a < 1 ? i = c : (i < 0 || i >= a + g) && (i = ((i - g / 2) % a + a) % a + g / 2),
            i
        }
        ,
        p.prototype.relative = function(i) {
            return i -= this._clones.length / 2,
            this.normalize(i, !0)
        }
        ,
        p.prototype.maximum = function(i) {
            var l, a, g, S = this.settings, T = this._coordinates.length;
            if (S.loop)
                T = this._clones.length / 2 + this._items.length - 1;
            else if (S.autoWidth || S.merge) {
                if (l = this._items.length)
                    for (a = this._items[--l].width(),
                    g = this.$element.width(); l-- && !((a += this._items[l].width() + this.settings.margin) > g); )
                        ;
                T = l + 1
            } else
                T = S.center ? this._items.length - 1 : this._items.length - S.items;
            return i && (T -= this._clones.length / 2),
            Math.max(T, 0)
        }
        ,
        p.prototype.minimum = function(i) {
            return i ? 0 : this._clones.length / 2
        }
        ,
        p.prototype.items = function(i) {
            return i === c ? this._items.slice() : (i = this.normalize(i, !0),
            this._items[i])
        }
        ,
        p.prototype.mergers = function(i) {
            return i === c ? this._mergers.slice() : (i = this.normalize(i, !0),
            this._mergers[i])
        }
        ,
        p.prototype.clones = function(i) {
            var l = this._clones.length / 2
              , a = l + this._items.length
              , g = function(T) {
                return T % 2 == 0 ? a + T / 2 : l - (T + 1) / 2
            };
            return i === c ? d.map(this._clones, function(S, T) {
                return g(T)
            }) : d.map(this._clones, function(S, T) {
                return S === i ? g(T) : null
            })
        }
        ,
        p.prototype.speed = function(i) {
            return i !== c && (this._speed = i),
            this._speed
        }
        ,
        p.prototype.coordinates = function(i) {
            var l, a = 1, g = i - 1;
            return i === c ? d.map(this._coordinates, d.proxy(function(S, T) {
                return this.coordinates(T)
            }, this)) : (this.settings.center ? (this.settings.rtl && (a = -1,
            g = i + 1),
            l = this._coordinates[i],
            l += (this.width() - l + (this._coordinates[g] || 0)) / 2 * a) : l = this._coordinates[g] || 0,
            l = Math.ceil(l))
        }
        ,
        p.prototype.duration = function(i, l, a) {
            return a === 0 ? 0 : Math.min(Math.max(Math.abs(l - i), 1), 6) * Math.abs(a || this.settings.smartSpeed)
        }
        ,
        p.prototype.to = function(i, l) {
            var a = this.current()
              , g = null
              , S = i - this.relative(a)
              , T = (S > 0) - (S < 0)
              , y = this._items.length
              , A = this.minimum()
              , j = this.maximum();
            this.settings.loop ? (!this.settings.rewind && Math.abs(S) > y / 2 && (S += -1 * T * y),
            i = a + S,
            (g = ((i - A) % y + y) % y + A) !== i && g - S <= j && g - S > 0 && (a = g - S,
            i = g,
            this.reset(a))) : this.settings.rewind ? (j += 1,
            i = (i % j + j) % j) : i = Math.max(A, Math.min(j, i)),
            this.speed(this.duration(a, i, l)),
            this.current(i),
            this.isVisible() && this.update()
        }
        ,
        p.prototype.next = function(i) {
            i = i || !1,
            this.to(this.relative(this.current()) + 1, i)
        }
        ,
        p.prototype.prev = function(i) {
            i = i || !1,
            this.to(this.relative(this.current()) - 1, i)
        }
        ,
        p.prototype.onTransitionEnd = function(i) {
            if (i !== c && (i.stopPropagation(),
            (i.target || i.srcElement || i.originalTarget) !== this.$stage.get(0)))
                return !1;
            this.leave("animating"),
            this.trigger("translated")
        }
        ,
        p.prototype.viewport = function() {
            var i;
            return this.options.responsiveBaseElement !== w ? i = d(this.options.responsiveBaseElement).width() : w.innerWidth ? i = w.innerWidth : e.documentElement && e.documentElement.clientWidth ? i = e.documentElement.clientWidth : console.warn("Can not detect viewport width."),
            i
        }
        ,
        p.prototype.replace = function(i) {
            this.$stage.empty(),
            this._items = [],
            i && (i = i instanceof jQuery ? i : d(i)),
            this.settings.nestedItemSelector && (i = i.find("." + this.settings.nestedItemSelector)),
            i.filter(function() {
                return this.nodeType === 1
            }).each(d.proxy(function(l, a) {
                a = this.prepare(a),
                this.$stage.append(a),
                this._items.push(a),
                this._mergers.push(1 * a.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)
            }, this)),
            this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0),
            this.invalidate("items")
        }
        ,
        p.prototype.add = function(i, l) {
            var a = this.relative(this._current);
            l = l === c ? this._items.length : this.normalize(l, !0),
            i = i instanceof jQuery ? i : d(i),
            this.trigger("add", {
                content: i,
                position: l
            }),
            i = this.prepare(i),
            this._items.length === 0 || l === this._items.length ? (this._items.length === 0 && this.$stage.append(i),
            this._items.length !== 0 && this._items[l - 1].after(i),
            this._items.push(i),
            this._mergers.push(1 * i.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)) : (this._items[l].before(i),
            this._items.splice(l, 0, i),
            this._mergers.splice(l, 0, 1 * i.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)),
            this._items[a] && this.reset(this._items[a].index()),
            this.invalidate("items"),
            this.trigger("added", {
                content: i,
                position: l
            })
        }
        ,
        p.prototype.remove = function(i) {
            (i = this.normalize(i, !0)) !== c && (this.trigger("remove", {
                content: this._items[i],
                position: i
            }),
            this._items[i].remove(),
            this._items.splice(i, 1),
            this._mergers.splice(i, 1),
            this.invalidate("items"),
            this.trigger("removed", {
                content: null,
                position: i
            }))
        }
        ,
        p.prototype.preloadAutoWidthImages = function(i) {
            i.each(d.proxy(function(l, a) {
                this.enter("pre-loading"),
                a = d(a),
                d(new Image).one("load", d.proxy(function(g) {
                    a.attr("src", g.target.src),
                    a.css("opacity", 1),
                    this.leave("pre-loading"),
                    !this.is("pre-loading") && !this.is("initializing") && this.refresh()
                }, this)).attr("src", a.attr("src") || a.attr("data-src") || a.attr("data-src-retina"))
            }, this))
        }
        ,
        p.prototype.destroy = function() {
            this.$element.off(".owl.core"),
            this.$stage.off(".owl.core"),
            d(e).off(".owl.core"),
            this.settings.responsive !== !1 && (w.clearTimeout(this.resizeTimer),
            this.off(w, "resize", this._handlers.onThrottledResize));
            for (var i in this._plugins)
                this._plugins[i].destroy();
            this.$stage.children(".cloned").remove(),
            this.$stage.unwrap(),
            this.$stage.children().contents().unwrap(),
            this.$stage.children().unwrap(),
            this.$stage.remove(),
            this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class", this.$element.attr("class").replace(new RegExp(this.options.responsiveClass + "-\\S+\\s","g"), "")).removeData("owl.carousel")
        }
        ,
        p.prototype.op = function(i, l, a) {
            var g = this.settings.rtl;
            switch (l) {
            case "<":
                return g ? i > a : i < a;
            case ">":
                return g ? i < a : i > a;
            case ">=":
                return g ? i <= a : i >= a;
            case "<=":
                return g ? i >= a : i <= a
            }
        }
        ,
        p.prototype.on = function(i, l, a, g) {
            i.addEventListener ? i.addEventListener(l, a, g) : i.attachEvent && i.attachEvent("on" + l, a)
        }
        ,
        p.prototype.off = function(i, l, a, g) {
            i.removeEventListener ? i.removeEventListener(l, a, g) : i.detachEvent && i.detachEvent("on" + l, a)
        }
        ,
        p.prototype.trigger = function(i, l, a, g, S) {
            var T = {
                item: {
                    count: this._items.length,
                    index: this.current()
                }
            }
              , y = d.camelCase(d.grep(["on", i, a], function(j) {
                return j
            }).join("-").toLowerCase())
              , A = d.Event([i, "owl", a || "carousel"].join(".").toLowerCase(), d.extend({
                relatedTarget: this
            }, T, l));
            return this._supress[i] || (d.each(this._plugins, function(j, L) {
                L.onTrigger && L.onTrigger(A)
            }),
            this.register({
                type: p.Type.Event,
                name: i
            }),
            this.$element.trigger(A),
            this.settings && typeof this.settings[y] == "function" && this.settings[y].call(this, A)),
            A
        }
        ,
        p.prototype.enter = function(i) {
            d.each([i].concat(this._states.tags[i] || []), d.proxy(function(l, a) {
                this._states.current[a] === c && (this._states.current[a] = 0),
                this._states.current[a]++
            }, this))
        }
        ,
        p.prototype.leave = function(i) {
            d.each([i].concat(this._states.tags[i] || []), d.proxy(function(l, a) {
                this._states.current[a]--
            }, this))
        }
        ,
        p.prototype.register = function(i) {
            if (i.type === p.Type.Event) {
                if (d.event.special[i.name] || (d.event.special[i.name] = {}),
                !d.event.special[i.name].owl) {
                    var l = d.event.special[i.name]._default;
                    d.event.special[i.name]._default = function(a) {
                        return !l || !l.apply || a.namespace && a.namespace.indexOf("owl") !== -1 ? a.namespace && a.namespace.indexOf("owl") > -1 : l.apply(this, arguments)
                    }
                    ,
                    d.event.special[i.name].owl = !0
                }
            } else
                i.type === p.Type.State && (this._states.tags[i.name] ? this._states.tags[i.name] = this._states.tags[i.name].concat(i.tags) : this._states.tags[i.name] = i.tags,
                this._states.tags[i.name] = d.grep(this._states.tags[i.name], d.proxy(function(a, g) {
                    return d.inArray(a, this._states.tags[i.name]) === g
                }, this)))
        }
        ,
        p.prototype.suppress = function(i) {
            d.each(i, d.proxy(function(l, a) {
                this._supress[a] = !0
            }, this))
        }
        ,
        p.prototype.release = function(i) {
            d.each(i, d.proxy(function(l, a) {
                delete this._supress[a]
            }, this))
        }
        ,
        p.prototype.pointer = function(i) {
            var l = {
                x: null,
                y: null
            };
            return i = i.originalEvent || i || w.event,
            i = i.touches && i.touches.length ? i.touches[0] : i.changedTouches && i.changedTouches.length ? i.changedTouches[0] : i,
            i.pageX ? (l.x = i.pageX,
            l.y = i.pageY) : (l.x = i.clientX,
            l.y = i.clientY),
            l
        }
        ,
        p.prototype.isNumeric = function(i) {
            return !isNaN(parseFloat(i))
        }
        ,
        p.prototype.difference = function(i, l) {
            return {
                x: i.x - l.x,
                y: i.y - l.y
            }
        }
        ,
        d.fn.owlCarousel = function(i) {
            var l = Array.prototype.slice.call(arguments, 1);
            return this.each(function() {
                var a = d(this)
                  , g = a.data("owl.carousel");
                g || (g = new p(this,_typeof(i) == "object" && i),
                a.data("owl.carousel", g),
                d.each(["next", "prev", "to", "destroy", "refresh", "replace", "add", "remove"], function(S, T) {
                    g.register({
                        type: p.Type.Event,
                        name: T
                    }),
                    g.$element.on(T + ".owl.carousel.core", d.proxy(function(y) {
                        y.namespace && y.relatedTarget !== this && (this.suppress([T]),
                        g[T].apply(this, [].slice.call(arguments, 1)),
                        this.release([T]))
                    }, g))
                })),
                typeof i == "string" && i.charAt(0) !== "_" && g[i].apply(g, l)
            })
        }
        ,
        d.fn.owlCarousel.Constructor = p
    }(window.Zepto || window.jQuery, window, document),
    function(d, w, e, c) {
        var p = function i(l) {
            this._core = l,
            this._interval = null,
            this._visible = null,
            this._handlers = {
                "initialized.owl.carousel": d.proxy(function(a) {
                    a.namespace && this._core.settings.autoRefresh && this.watch()
                }, this)
            },
            this._core.options = d.extend({}, i.Defaults, this._core.options),
            this._core.$element.on(this._handlers)
        };
        p.Defaults = {
            autoRefresh: !0,
            autoRefreshInterval: 500
        },
        p.prototype.watch = function() {
            this._interval || (this._visible = this._core.isVisible(),
            this._interval = w.setInterval(d.proxy(this.refresh, this), this._core.settings.autoRefreshInterval))
        }
        ,
        p.prototype.refresh = function() {
            this._core.isVisible() !== this._visible && (this._visible = !this._visible,
            this._core.$element.toggleClass("owl-hidden", !this._visible),
            this._visible && this._core.invalidate("width") && this._core.refresh())
        }
        ,
        p.prototype.destroy = function() {
            var i, l;
            w.clearInterval(this._interval);
            for (i in this._handlers)
                this._core.$element.off(i, this._handlers[i]);
            for (l in Object.getOwnPropertyNames(this))
                typeof this[l] != "function" && (this[l] = null)
        }
        ,
        d.fn.owlCarousel.Constructor.Plugins.AutoRefresh = p
    }(window.Zepto || window.jQuery, window, document),
    function(d, w, e, c) {
        var p = function i(l) {
            this._core = l,
            this._loaded = [],
            this._handlers = {
                "initialized.owl.carousel change.owl.carousel resized.owl.carousel": d.proxy(function(a) {
                    if (a.namespace && this._core.settings && this._core.settings.lazyLoad && (a.property && a.property.name == "position" || a.type == "initialized")) {
                        var g = this._core.settings
                          , S = g.center && Math.ceil(g.items / 2) || g.items
                          , T = g.center && -1 * S || 0
                          , y = (a.property && a.property.value !== c ? a.property.value : this._core.current()) + T
                          , A = this._core.clones().length
                          , j = d.proxy(function(L, W) {
                            this.load(W)
                        }, this);
                        for (g.lazyLoadEager > 0 && (S += g.lazyLoadEager,
                        g.loop && (y -= g.lazyLoadEager,
                        S++)); T++ < S; )
                            this.load(A / 2 + this._core.relative(y)),
                            A && d.each(this._core.clones(this._core.relative(y)), j),
                            y++
                    }
                }, this)
            },
            this._core.options = d.extend({}, i.Defaults, this._core.options),
            this._core.$element.on(this._handlers)
        };
        p.Defaults = {
            lazyLoad: !1,
            lazyLoadEager: 0
        },
        p.prototype.load = function(i) {
            var l = this._core.$stage.children().eq(i)
              , a = l && l.find(".owl-lazy");
            !a || d.inArray(l.get(0), this._loaded) > -1 || (a.each(d.proxy(function(g, S) {
                var T, y = d(S), A = w.devicePixelRatio > 1 && y.attr("data-src-retina") || y.attr("data-src") || y.attr("data-srcset");
                this._core.trigger("load", {
                    element: y,
                    url: A
                }, "lazy"),
                y.is("img") ? y.one("load.owl.lazy", d.proxy(function() {
                    y.css("opacity", 1),
                    this._core.trigger("loaded", {
                        element: y,
                        url: A
                    }, "lazy")
                }, this)).attr("src", A) : y.is("source") ? y.one("load.owl.lazy", d.proxy(function() {
                    this._core.trigger("loaded", {
                        element: y,
                        url: A
                    }, "lazy")
                }, this)).attr("srcset", A) : (T = new Image,
                T.onload = d.proxy(function() {
                    y.css({
                        "background-image": 'url("' + A + '")',
                        opacity: "1"
                    }),
                    this._core.trigger("loaded", {
                        element: y,
                        url: A
                    }, "lazy")
                }, this),
                T.src = A)
            }, this)),
            this._loaded.push(l.get(0)))
        }
        ,
        p.prototype.destroy = function() {
            var i, l;
            for (i in this.handlers)
                this._core.$element.off(i, this.handlers[i]);
            for (l in Object.getOwnPropertyNames(this))
                typeof this[l] != "function" && (this[l] = null)
        }
        ,
        d.fn.owlCarousel.Constructor.Plugins.Lazy = p
    }(window.Zepto || window.jQuery, window, document),
    function(d, w, e, c) {
        var p = function i(l) {
            this._core = l,
            this._previousHeight = null,
            this._handlers = {
                "initialized.owl.carousel refreshed.owl.carousel": d.proxy(function(g) {
                    g.namespace && this._core.settings.autoHeight && this.update()
                }, this),
                "changed.owl.carousel": d.proxy(function(g) {
                    g.namespace && this._core.settings.autoHeight && g.property.name === "position" && this.update()
                }, this),
                "loaded.owl.lazy": d.proxy(function(g) {
                    g.namespace && this._core.settings.autoHeight && g.element.closest("." + this._core.settings.itemClass).index() === this._core.current() && this.update()
                }, this)
            },
            this._core.options = d.extend({}, i.Defaults, this._core.options),
            this._core.$element.on(this._handlers),
            this._intervalId = null;
            var a = this;
            d(w).on("load", function() {
                a._core.settings.autoHeight && a.update()
            }),
            d(w).resize(function() {
                a._core.settings.autoHeight && (a._intervalId != null && clearTimeout(a._intervalId),
                a._intervalId = setTimeout(function() {
                    a.update()
                }, 250))
            })
        };
        p.Defaults = {
            autoHeight: !1,
            autoHeightClass: "owl-height"
        },
        p.prototype.update = function() {
            var i = this._core._current
              , l = i + this._core.settings.items
              , a = this._core.settings.lazyLoad
              , g = this._core.$stage.children().toArray().slice(i, l)
              , S = []
              , T = 0;
            d.each(g, function(y, A) {
                S.push(d(A).height())
            }),
            T = Math.max.apply(null, S),
            T <= 1 && a && this._previousHeight && (T = this._previousHeight),
            this._previousHeight = T,
            this._core.$stage.parent().height(T).addClass(this._core.settings.autoHeightClass)
        }
        ,
        p.prototype.destroy = function() {
            var i, l;
            for (i in this._handlers)
                this._core.$element.off(i, this._handlers[i]);
            for (l in Object.getOwnPropertyNames(this))
                typeof this[l] != "function" && (this[l] = null)
        }
        ,
        d.fn.owlCarousel.Constructor.Plugins.AutoHeight = p
    }(window.Zepto || window.jQuery, window, document),
    function(d, w, e, c) {
        var p = function i(l) {
            this._core = l,
            this._videos = {},
            this._playing = null,
            this._handlers = {
                "initialized.owl.carousel": d.proxy(function(a) {
                    a.namespace && this._core.register({
                        type: "state",
                        name: "playing",
                        tags: ["interacting"]
                    })
                }, this),
                "resize.owl.carousel": d.proxy(function(a) {
                    a.namespace && this._core.settings.video && this.isInFullScreen() && a.preventDefault()
                }, this),
                "refreshed.owl.carousel": d.proxy(function(a) {
                    a.namespace && this._core.is("resizing") && this._core.$stage.find(".cloned .owl-video-frame").remove()
                }, this),
                "changed.owl.carousel": d.proxy(function(a) {
                    a.namespace && a.property.name === "position" && this._playing && this.stop()
                }, this),
                "prepared.owl.carousel": d.proxy(function(a) {
                    if (a.namespace) {
                        var g = d(a.content).find(".owl-video");
                        g.length && (g.css("display", "none"),
                        this.fetch(g, d(a.content)))
                    }
                }, this)
            },
            this._core.options = d.extend({}, i.Defaults, this._core.options),
            this._core.$element.on(this._handlers),
            this._core.$element.on("click.owl.video", ".owl-video-play-icon", d.proxy(function(a) {
                this.play(a)
            }, this))
        };
        p.Defaults = {
            video: !1,
            videoHeight: !1,
            videoWidth: !1
        },
        p.prototype.fetch = function(i, l) {
            var a = function() {
                return i.attr("data-vimeo-id") ? "vimeo" : i.attr("data-vzaar-id") ? "vzaar" : "youtube"
            }()
              , g = i.attr("data-vimeo-id") || i.attr("data-youtube-id") || i.attr("data-vzaar-id")
              , S = i.attr("data-width") || this._core.settings.videoWidth
              , T = i.attr("data-height") || this._core.settings.videoHeight
              , y = i.attr("href");
            if (!y)
                throw new Error("Missing video URL.");
            if (g = y.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/),
            g[3].indexOf("youtu") > -1)
                a = "youtube";
            else if (g[3].indexOf("vimeo") > -1)
                a = "vimeo";
            else {
                if (!(g[3].indexOf("vzaar") > -1))
                    throw new Error("Video URL not supported.");
                a = "vzaar"
            }
            g = g[6],
            this._videos[y] = {
                type: a,
                id: g,
                width: S,
                height: T
            },
            l.attr("data-video", y),
            this.thumbnail(i, this._videos[y])
        }
        ,
        p.prototype.thumbnail = function(i, l) {
            var a, g, S, T = l.width && l.height ? "width:" + l.width + "px;height:" + l.height + "px;" : "", y = i.find("img"), A = "src", j = "", L = this._core.settings, W = function(U) {
                g = '<div class="owl-video-play-icon"></div>',
                a = L.lazyLoad ? d("<div/>", {
                    class: "owl-video-tn " + j,
                    srcType: U
                }) : d("<div/>", {
                    class: "owl-video-tn",
                    style: "opacity:1;background-image:url(" + U + ")"
                }),
                i.after(a),
                i.after(g)
            };
            if (i.wrap(d("<div/>", {
                class: "owl-video-wrapper",
                style: T
            })),
            this._core.settings.lazyLoad && (A = "data-src",
            j = "owl-lazy"),
            y.length)
                return W(y.attr(A)),
                y.remove(),
                !1;
            l.type === "youtube" ? (S = "//img.youtube.com/vi/" + l.id + "/hqdefault.jpg",
            W(S)) : l.type === "vimeo" ? d.ajax({
                type: "GET",
                url: "//vimeo.com/api/v2/video/" + l.id + ".json",
                jsonp: "callback",
                dataType: "jsonp",
                success: function(U) {
                    S = U[0].thumbnail_large,
                    W(S)
                }
            }) : l.type === "vzaar" && d.ajax({
                type: "GET",
                url: "//vzaar.com/api/videos/" + l.id + ".json",
                jsonp: "callback",
                dataType: "jsonp",
                success: function(U) {
                    S = U.framegrab_url,
                    W(S)
                }
            })
        }
        ,
        p.prototype.stop = function() {
            this._core.trigger("stop", null, "video"),
            this._playing.find(".owl-video-frame").remove(),
            this._playing.removeClass("owl-video-playing"),
            this._playing = null,
            this._core.leave("playing"),
            this._core.trigger("stopped", null, "video")
        }
        ,
        p.prototype.play = function(i) {
            var l, a = d(i.target), g = a.closest("." + this._core.settings.itemClass), S = this._videos[g.attr("data-video")], T = S.width || "100%", y = S.height || this._core.$stage.height();
            this._playing || (this._core.enter("playing"),
            this._core.trigger("play", null, "video"),
            g = this._core.items(this._core.relative(g.index())),
            this._core.reset(g.index()),
            l = d('<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>'),
            l.attr("height", y),
            l.attr("width", T),
            S.type === "youtube" ? l.attr("src", "//www.youtube.com/embed/" + S.id + "?autoplay=1&rel=0&v=" + S.id) : S.type === "vimeo" ? l.attr("src", "//player.vimeo.com/video/" + S.id + "?autoplay=1") : S.type === "vzaar" && l.attr("src", "//view.vzaar.com/" + S.id + "/player?autoplay=true"),
            d(l).wrap('<div class="owl-video-frame" />').insertAfter(g.find(".owl-video")),
            this._playing = g.addClass("owl-video-playing"))
        }
        ,
        p.prototype.isInFullScreen = function() {
            var i = e.fullscreenElement || e.mozFullScreenElement || e.webkitFullscreenElement;
            return i && d(i).parent().hasClass("owl-video-frame")
        }
        ,
        p.prototype.destroy = function() {
            var i, l;
            this._core.$element.off("click.owl.video");
            for (i in this._handlers)
                this._core.$element.off(i, this._handlers[i]);
            for (l in Object.getOwnPropertyNames(this))
                typeof this[l] != "function" && (this[l] = null)
        }
        ,
        d.fn.owlCarousel.Constructor.Plugins.Video = p
    }(window.Zepto || window.jQuery, window, document),
    function(d, w, e, c) {
        var p = function i(l) {
            this.core = l,
            this.core.options = d.extend({}, i.Defaults, this.core.options),
            this.swapping = !0,
            this.previous = c,
            this.next = c,
            this.handlers = {
                "change.owl.carousel": d.proxy(function(a) {
                    a.namespace && a.property.name == "position" && (this.previous = this.core.current(),
                    this.next = a.property.value)
                }, this),
                "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": d.proxy(function(a) {
                    a.namespace && (this.swapping = a.type == "translated")
                }, this),
                "translate.owl.carousel": d.proxy(function(a) {
                    a.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap()
                }, this)
            },
            this.core.$element.on(this.handlers)
        };
        p.Defaults = {
            animateOut: !1,
            animateIn: !1
        },
        p.prototype.swap = function() {
            if (this.core.settings.items === 1 && d.support.animation && d.support.transition) {
                this.core.speed(0);
                var i, l = d.proxy(this.clear, this), a = this.core.$stage.children().eq(this.previous), g = this.core.$stage.children().eq(this.next), S = this.core.settings.animateIn, T = this.core.settings.animateOut;
                this.core.current() !== this.previous && (T && (i = this.core.coordinates(this.previous) - this.core.coordinates(this.next),
                a.one(d.support.animation.end, l).css({
                    left: i + "px"
                }).addClass("animated owl-animated-out").addClass(T)),
                S && g.one(d.support.animation.end, l).addClass("animated owl-animated-in").addClass(S))
            }
        }
        ,
        p.prototype.clear = function(i) {
            d(i.target).css({
                left: ""
            }).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut),
            this.core.onTransitionEnd()
        }
        ,
        p.prototype.destroy = function() {
            var i, l;
            for (i in this.handlers)
                this.core.$element.off(i, this.handlers[i]);
            for (l in Object.getOwnPropertyNames(this))
                typeof this[l] != "function" && (this[l] = null)
        }
        ,
        d.fn.owlCarousel.Constructor.Plugins.Animate = p
    }(window.Zepto || window.jQuery, window, document),
    function(d, w, e, c) {
        var p = function i(l) {
            this._core = l,
            this._call = null,
            this._time = 0,
            this._timeout = 0,
            this._paused = !0,
            this._handlers = {
                "changed.owl.carousel": d.proxy(function(a) {
                    a.namespace && a.property.name === "settings" ? this._core.settings.autoplay ? this.play() : this.stop() : a.namespace && a.property.name === "position" && this._paused && (this._time = 0)
                }, this),
                "initialized.owl.carousel": d.proxy(function(a) {
                    a.namespace && this._core.settings.autoplay && this.play()
                }, this),
                "play.owl.autoplay": d.proxy(function(a, g, S) {
                    a.namespace && this.play(g, S)
                }, this),
                "stop.owl.autoplay": d.proxy(function(a) {
                    a.namespace && this.stop()
                }, this),
                "mouseover.owl.autoplay": d.proxy(function() {
                    this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause()
                }, this),
                "mouseleave.owl.autoplay": d.proxy(function() {
                    this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.play()
                }, this),
                "touchstart.owl.core": d.proxy(function() {
                    this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause()
                }, this),
                "touchend.owl.core": d.proxy(function() {
                    this._core.settings.autoplayHoverPause && this.play()
                }, this)
            },
            this._core.$element.on(this._handlers),
            this._core.options = d.extend({}, i.Defaults, this._core.options)
        };
        p.Defaults = {
            autoplay: !1,
            autoplayTimeout: 5e3,
            autoplayHoverPause: !1,
            autoplaySpeed: !1
        },
        p.prototype._next = function(i) {
            this._call = w.setTimeout(d.proxy(this._next, this, i), this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read()),
            this._core.is("interacting") || e.hidden || this._core.next(i || this._core.settings.autoplaySpeed)
        }
        ,
        p.prototype.read = function() {
            return new Date().getTime() - this._time
        }
        ,
        p.prototype.play = function(i, l) {
            var a;
            this._core.is("rotating") || this._core.enter("rotating"),
            i = i || this._core.settings.autoplayTimeout,
            a = Math.min(this._time % (this._timeout || i), i),
            this._paused ? (this._time = this.read(),
            this._paused = !1) : w.clearTimeout(this._call),
            this._time += this.read() % i - a,
            this._timeout = i,
            this._call = w.setTimeout(d.proxy(this._next, this, l), i - a)
        }
        ,
        p.prototype.stop = function() {
            this._core.is("rotating") && (this._time = 0,
            this._paused = !0,
            w.clearTimeout(this._call),
            this._core.leave("rotating"))
        }
        ,
        p.prototype.pause = function() {
            this._core.is("rotating") && !this._paused && (this._time = this.read(),
            this._paused = !0,
            w.clearTimeout(this._call))
        }
        ,
        p.prototype.destroy = function() {
            var i, l;
            this.stop();
            for (i in this._handlers)
                this._core.$element.off(i, this._handlers[i]);
            for (l in Object.getOwnPropertyNames(this))
                typeof this[l] != "function" && (this[l] = null)
        }
        ,
        d.fn.owlCarousel.Constructor.Plugins.autoplay = p
    }(window.Zepto || window.jQuery, window, document),
    function(d, w, e, c) {
        "use strict";
        var p = function i(l) {
            this._core = l,
            this._initialized = !1,
            this._pages = [],
            this._controls = {},
            this._templates = [],
            this.$element = this._core.$element,
            this._overrides = {
                next: this._core.next,
                prev: this._core.prev,
                to: this._core.to
            },
            this._handlers = {
                "prepared.owl.carousel": d.proxy(function(a) {
                    a.namespace && this._core.settings.dotsData && this._templates.push('<div class="' + this._core.settings.dotClass + '">' + d(a.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot") + "</div>")
                }, this),
                "added.owl.carousel": d.proxy(function(a) {
                    a.namespace && this._core.settings.dotsData && this._templates.splice(a.position, 0, this._templates.pop())
                }, this),
                "remove.owl.carousel": d.proxy(function(a) {
                    a.namespace && this._core.settings.dotsData && this._templates.splice(a.position, 1)
                }, this),
                "changed.owl.carousel": d.proxy(function(a) {
                    a.namespace && a.property.name == "position" && this.draw()
                }, this),
                "initialized.owl.carousel": d.proxy(function(a) {
                    a.namespace && !this._initialized && (this._core.trigger("initialize", null, "navigation"),
                    this.initialize(),
                    this.update(),
                    this.draw(),
                    this._initialized = !0,
                    this._core.trigger("initialized", null, "navigation"))
                }, this),
                "refreshed.owl.carousel": d.proxy(function(a) {
                    a.namespace && this._initialized && (this._core.trigger("refresh", null, "navigation"),
                    this.update(),
                    this.draw(),
                    this._core.trigger("refreshed", null, "navigation"))
                }, this)
            },
            this._core.options = d.extend({}, i.Defaults, this._core.options),
            this.$element.on(this._handlers)
        };
        p.Defaults = {
            nav: !1,
            navText: ['<span aria-label="' + theme.strings.previous + '">&#x2039;</span>', '<span aria-label="' + theme.strings.next + '">&#x203a;</span>'],
            navSpeed: !1,
            navElement: 'button type="button" role="presentation"',
            navContainer: !1,
            navContainerClass: "owl-nav",
            navClass: ["owl-prev", "owl-next"],
            slideBy: 1,
            dotClass: "owl-dot",
            dotsClass: "owl-dots",
            dots: !0,
            dotsEach: !1,
            dotsData: !1,
            dotsSpeed: !1,
            dotsContainer: !1
        },
        p.prototype.initialize = function() {
            var i, l = this._core.settings;
            this._controls.$relative = (l.navContainer ? d(l.navContainer) : d("<div>").addClass(l.navContainerClass).appendTo(this.$element)).addClass("disabled"),
            this._controls.$previous = d("<" + l.navElement + ">").addClass(l.navClass[0]).html(l.navText[0]).prependTo(this._controls.$relative).on("click", d.proxy(function(a) {
                this.prev(l.navSpeed)
            }, this)),
            this._controls.$next = d("<" + l.navElement + ">").addClass(l.navClass[1]).html(l.navText[1]).appendTo(this._controls.$relative).on("click", d.proxy(function(a) {
                this.next(l.navSpeed)
            }, this)),
            l.dotsData || (this._templates = [d('<button role="button">').addClass(l.dotClass).append(d("<span>")).prop("outerHTML")]),
            this._controls.$absolute = (l.dotsContainer ? d(l.dotsContainer) : d("<div>").addClass(l.dotsClass).appendTo(this.$element)).addClass("disabled"),
            this._controls.$absolute.on("click", "button", d.proxy(function(a) {
                var g = d(a.target).parent().is(this._controls.$absolute) ? d(a.target).index() : d(a.target).parent().index();
                a.preventDefault(),
                this.to(g, l.dotsSpeed)
            }, this));
            for (i in this._overrides)
                this._core[i] = d.proxy(this[i], this)
        }
        ,
        p.prototype.destroy = function() {
            var i, l, a, g, S;
            S = this._core.settings;
            for (i in this._handlers)
                this.$element.off(i, this._handlers[i]);
            for (l in this._controls)
                l === "$relative" && S.navContainer ? this._controls[l].html("") : this._controls[l].remove();
            for (g in this.overides)
                this._core[g] = this._overrides[g];
            for (a in Object.getOwnPropertyNames(this))
                typeof this[a] != "function" && (this[a] = null)
        }
        ,
        p.prototype.update = function() {
            var i, l, a, g = this._core.clones().length / 2, S = g + this._core.items().length, T = this._core.maximum(!0), y = this._core.settings, A = y.center || y.autoWidth || y.dotsData ? 1 : y.dotsEach || y.items;
            if (y.slideBy !== "page" && (y.slideBy = Math.min(y.slideBy, y.items)),
            y.dots || y.slideBy == "page")
                for (this._pages = [],
                i = g,
                l = 0,
                a = 0; i < S; i++) {
                    if (l >= A || l === 0) {
                        if (this._pages.push({
                            start: Math.min(T, i - g),
                            end: i - g + A - 1
                        }),
                        Math.min(T, i - g) === T)
                            break;
                        l = 0,
                        ++a
                    }
                    l += this._core.mergers(this._core.relative(i))
                }
        }
        ,
        p.prototype.draw = function() {
            var i, l = this._core.settings, a = this._core.items().length <= l.items, g = this._core.relative(this._core.current()), S = l.loop || l.rewind;
            this._controls.$relative.toggleClass("disabled", !l.nav || a),
            l.nav && (this._controls.$previous.toggleClass("disabled", !S && g <= this._core.minimum(!0)),
            this._controls.$next.toggleClass("disabled", !S && g >= this._core.maximum(!0))),
            this._controls.$absolute.toggleClass("disabled", !l.dots || a),
            l.dots && (i = this._pages.length - this._controls.$absolute.children().length,
            l.dotsData && i !== 0 ? this._controls.$absolute.html(this._templates.join("")) : i > 0 ? this._controls.$absolute.append(new Array(i + 1).join(this._templates[0])) : i < 0 && this._controls.$absolute.children().slice(i).remove(),
            this._controls.$absolute.find(".active").removeClass("active"),
            this._controls.$absolute.children().eq(d.inArray(this.current(), this._pages)).addClass("active"))
        }
        ,
        p.prototype.onTrigger = function(i) {
            var l = this._core.settings;
            i.page = {
                index: d.inArray(this.current(), this._pages),
                count: this._pages.length,
                size: l && (l.center || l.autoWidth || l.dotsData ? 1 : l.dotsEach || l.items)
            }
        }
        ,
        p.prototype.current = function() {
            var i = this._core.relative(this._core.current());
            return d.grep(this._pages, d.proxy(function(l, a) {
                return l.start <= i && l.end >= i
            }, this)).pop()
        }
        ,
        p.prototype.getPosition = function(i) {
            var l, a, g = this._core.settings;
            return g.slideBy == "page" ? (l = d.inArray(this.current(), this._pages),
            a = this._pages.length,
            i ? ++l : --l,
            l = this._pages[(l % a + a) % a].start) : (l = this._core.relative(this._core.current()),
            a = this._core.items().length,
            i ? l += g.slideBy : l -= g.slideBy),
            l
        }
        ,
        p.prototype.next = function(i) {
            d.proxy(this._overrides.to, this._core)(this.getPosition(!0), i)
        }
        ,
        p.prototype.prev = function(i) {
            d.proxy(this._overrides.to, this._core)(this.getPosition(!1), i)
        }
        ,
        p.prototype.to = function(i, l, a) {
            var g;
            !a && this._pages.length ? (g = this._pages.length,
            d.proxy(this._overrides.to, this._core)(this._pages[(i % g + g) % g].start, l)) : d.proxy(this._overrides.to, this._core)(i, l)
        }
        ,
        d.fn.owlCarousel.Constructor.Plugins.Navigation = p
    }(window.Zepto || window.jQuery, window, document),
    function(d, w, e, c) {
        "use strict";
        var p = function i(l) {
            this._core = l,
            this._hashes = {},
            this.$element = this._core.$element,
            this._handlers = {
                "initialized.owl.carousel": d.proxy(function(a) {
                    a.namespace && this._core.settings.startPosition === "URLHash" && d(w).trigger("hashchange.owl.navigation")
                }, this),
                "prepared.owl.carousel": d.proxy(function(a) {
                    if (a.namespace) {
                        var g = d(a.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");
                        if (!g)
                            return;
                        this._hashes[g] = a.content
                    }
                }, this),
                "changed.owl.carousel": d.proxy(function(a) {
                    if (a.namespace && a.property.name === "position") {
                        var g = this._core.items(this._core.relative(this._core.current()))
                          , S = d.map(this._hashes, function(T, y) {
                            return T === g ? y : null
                        }).join();
                        if (!S || w.location.hash.slice(1) === S)
                            return;
                        w.location.hash = S
                    }
                }, this)
            },
            this._core.options = d.extend({}, i.Defaults, this._core.options),
            this.$element.on(this._handlers),
            d(w).on("hashchange.owl.navigation", d.proxy(function(a) {
                var g = w.location.hash.substring(1)
                  , S = this._core.$stage.children()
                  , T = this._hashes[g] && S.index(this._hashes[g]);
                T !== c && T !== this._core.current() && this._core.to(this._core.relative(T), !1, !0)
            }, this))
        };
        p.Defaults = {
            URLhashListener: !1
        },
        p.prototype.destroy = function() {
            var i, l;
            d(w).off("hashchange.owl.navigation");
            for (i in this._handlers)
                this._core.$element.off(i, this._handlers[i]);
            for (l in Object.getOwnPropertyNames(this))
                typeof this[l] != "function" && (this[l] = null)
        }
        ,
        d.fn.owlCarousel.Constructor.Plugins.Hash = p
    }(window.Zepto || window.jQuery, window, document),
    function(d, w, e, c) {
        function p(T, y) {
            var A = !1
              , j = T.charAt(0).toUpperCase() + T.slice(1);
            return d.each((T + " " + a.join(j + " ") + j).split(" "), function(L, W) {
                if (l[W] !== c)
                    return A = !y || W,
                    !1
            }),
            A
        }
        function i(T) {
            return p(T, !0)
        }
        var l = d("<support>").get(0).style
          , a = "Webkit Moz O ms".split(" ")
          , g = {
            transition: {
                end: {
                    WebkitTransition: "webkitTransitionEnd",
                    MozTransition: "transitionend",
                    OTransition: "oTransitionEnd",
                    transition: "transitionend"
                }
            },
            animation: {
                end: {
                    WebkitAnimation: "webkitAnimationEnd",
                    MozAnimation: "animationend",
                    OAnimation: "oAnimationEnd",
                    animation: "animationend"
                }
            }
        }
          , S = {
            csstransforms: function() {
                return !!p("transform")
            },
            csstransforms3d: function() {
                return !!p("perspective")
            },
            csstransitions: function() {
                return !!p("transition")
            },
            cssanimations: function() {
                return !!p("animation")
            }
        };
        S.csstransitions() && (d.support.transition = new String(i("transition")),
        d.support.transition.end = g.transition.end[d.support.transition]),
        S.cssanimations() && (d.support.animation = new String(i("animation")),
        d.support.animation.end = g.animation.end[d.support.animation]),
        S.csstransforms() && (d.support.transform = new String(i("transform")),
        d.support.transform3d = S.csstransforms3d())
    }(window.Zepto || window.jQuery, window, document)
}(theme.jQuery);
//# sourceMappingURL=/s/files/1/0246/2081/t/30/assets/vendor.js.map?v=138568586205433922451656562572
